{
  "level": "q304",
  "source": {
    "spawn": "DERIVED_FROM_TREES_BBOX:q304",
    "objects": "AREAS.E3:q304.e3",
    "mesh": "TREES.E3:q304.e3"
  },
  "spawn_point": {
    "position": [
      961.9952427637484,
      794.3483718991591,
      -276.0
    ],
    "facing_rad": 0.0,
    "look_point": [
      961.9952427637484,
      894.3483718991591,
      -276.0
    ],
    "forward": [
      0.0,
      1.0,
      0.0
    ],
    "up": [
      0.0,
      0.0,
      1.0
    ],
    "derived": true
  },
  "mesh_point_cloud": {
    "note": "Raw vertex positions from TREES.E3.",
    "bbox_min": [
      -4205.05859375,
      -4764.30029296875,
      -300.0
    ],
    "bbox_max": [
      7681.30224609375,
      7450.0,
      1857.3123779296875
    ],
    "vertex_count": 1532,
    "vertices": [
      [
        -3660.1962890625,
        -2427.517822265625,
        1172.1954345703125
      ],
      [
        -3660.927734375,
        -2428.069091796875,
        1220.0
      ],
      [
        -4110.7685546875,
        -2767.048095703125,
        1371.9029541015625
      ],
      [
        -4116.7685546875,
        -2771.56982421875,
        1403.2762451171875
      ],
      [
        -4102.099609375,
        -2760.515625,
        1220.0
      ],
      [
        -4110.7685546875,
        -2767.048095703125,
        1371.9029541015625
      ],
      [
        -3661.619384765625,
        -2428.59033203125,
        1091.7215576171875
      ],
      [
        -3660.1962890625,
        -2427.517822265625,
        1172.1954345703125
      ],
      [
        -3000.0,
        -3214.59765625,
        1181.8935546875
      ],
      [
        -3000.0,
        -3408.73486328125,
        667.6585693359375
      ],
      [
        -3000.0,
        -3408.73486328125,
        667.6585693359375
      ],
      [
        -3000.0,
        -3527.920166015625,
        960.6837768554688
      ],
      [
        -3515.1474609375,
        -2584.24951171875,
        630.2245483398438
      ],
      [
        -3661.619384765625,
        -2428.59033203125,
        1091.7215576171875
      ],
      [
        -3658.444091796875,
        -2426.19775390625,
        1057.6986083984375
      ],
      [
        -3452.1201171875,
        -2659.722412109375,
        642.3209228515625
      ],
      [
        -3000.0,
        -3210.00390625,
        1194.0616455078125
      ],
      [
        -3000.0,
        -3052.4541015625,
        311.63726806640625
      ],
      [
        -3000.0,
        -3210.00390625,
        1194.0616455078125
      ],
      [
        -3577.691162109375,
        -2365.345947265625,
        192.41732788085938
      ],
      [
        -3000.0,
        -3052.4541015625,
        311.6372375488281
      ],
      [
        -3000.0,
        -3005.550537109375,
        150.83631896972656
      ],
      [
        -3000.0,
        -4714.78125,
        1390.1104736328125
      ],
      [
        -3000.0,
        -4650.2626953125,
        1191.9580078125
      ],
      [
        -3000.0,
        -3565.30615234375,
        1052.5999755859375
      ],
      [
        -3714.042724609375,
        -2323.521484375,
        1179.1292724609375
      ],
      [
        -3697.7392578125,
        -2384.4521484375,
        1181.5667724609375
      ],
      [
        -3709.58251953125,
        -2363.246337890625,
        1182.9832763671875
      ],
      [
        -3605.362548828125,
        -2269.30224609375,
        2.0755867958068848
      ],
      [
        -4205.05859375,
        -2619.064208984375,
        1400.2432861328125
      ],
      [
        -3902.9365234375,
        -2462.454833984375,
        1267.6805419921875
      ],
      [
        -4113.74951171875,
        -2769.29443359375,
        1387.4892578125
      ],
      [
        -4205.0,
        -2619.44677734375,
        1400.274658203125
      ],
      [
        -3605.362548828125,
        -2269.30224609375,
        2.0755615234375
      ],
      [
        -3709.58251953125,
        -2363.246337890625,
        1182.983154296875
      ],
      [
        -3714.01416015625,
        -2323.6279296875,
        1179.1334228515625
      ],
      [
        -3714.02197265625,
        -2323.558349609375,
        1179.126708984375
      ],
      [
        -3697.488525390625,
        -2384.901123046875,
        1181.5367431640625
      ],
      [
        -3697.488525390625,
        -2384.901123046875,
        1181.53662109375
      ],
      [
        -3662.39306640625,
        -2424.958984375,
        1174.1900634765625
      ],
      [
        -3662.39306640625,
        -2424.958984375,
        1174.1900634765625
      ],
      [
        -3660.219970703125,
        -2427.53564453125,
        1173.7484130859375
      ],
      [
        -3725.1884765625,
        -2329.142822265625,
        1300.001953125
      ],
      [
        -3725.18798828125,
        -2329.1435546875,
        1299.9984130859375
      ],
      [
        -3725.151611328125,
        -2329.19677734375,
        1299.78955078125
      ],
      [
        -3714.01416015625,
        -2323.6279296875,
        1179.1334228515625
      ],
      [
        -3709.690185546875,
        -2362.283203125,
        1182.8895263671875
      ],
      [
        -3725.158447265625,
        -2329.2001953125,
        1299.8638916015625
      ],
      [
        -3697.79833984375,
        -2384.52392578125,
        1182.312255859375
      ],
      [
        -3697.73974609375,
        -2384.451171875,
        1181.5667724609375
      ],
      [
        -3697.79833984375,
        -2384.52392578125,
        1182.3121337890625
      ],
      [
        -3702.450439453125,
        -2378.302978515625,
        1210.5587158203125
      ],
      [
        -3702.450439453125,
        -2378.302978515625,
        1210.5587158203125
      ],
      [
        -3703.801513671875,
        -2376.973876953125,
        1220.0
      ],
      [
        -2881.897705078125,
        -4764.30029296875,
        1390.1087646484375
      ],
      [
        -2880.93603515625,
        -4709.201171875,
        1219.6473388671875
      ],
      [
        -2852.99609375,
        -3108.556396484375,
        0.0
      ],
      [
        -2853.1044921875,
        -3114.76806640625,
        11.255549430847168
      ],
      [
        -2853.1044921875,
        -3114.76806640625,
        11.2554931640625
      ],
      [
        -2860.521728515625,
        -3539.687744140625,
        1052.5999755859375
      ],
      [
        -2853.27587890625,
        -3124.58837890625,
        35.3218994140625
      ],
      [
        -2395.35791015625,
        -863.1936645507812,
        100.0
      ],
      [
        -2823.71630859375,
        -503.75830078125,
        100.0
      ],
      [
        -800.0,
        -2100.0,
        508.155517578125
      ],
      [
        -800.0,
        -1855.504150390625,
        287.1609191894531
      ],
      [
        200.0,
        7450.0,
        680.7955932617188
      ],
      [
        3108.39404296875,
        6871.484375,
        547.115966796875
      ],
      [
        4832.6005859375,
        2700.0,
        1325.890869140625
      ],
      [
        7681.30224609375,
        2700.0,
        1793.450439453125
      ],
      [
        2400.0,
        -2849.047607421875,
        1857.3123779296875
      ],
      [
        6992.10546875,
        -1390.916015625,
        590.90966796875
      ],
      [
        6992.10546875,
        -1390.916015625,
        590.90966796875
      ],
      [
        2400.0,
        -1319.93994140625,
        329.84539794921875
      ],
      [
        2400.0,
        -1246.433349609375,
        296.433349609375
      ],
      [
        650.0,
        -2378.125,
        1284.1875
      ],
      [
        650.0,
        -2598.9130859375,
        1493.904296875
      ],
      [
        650.0,
        -2378.125,
        1284.1875
      ],
      [
        2400.0,
        -1546.88427734375,
        433.001953125
      ],
      [
        650.0,
        -867.0938720703125,
        16.996383666992188
      ],
      [
        650.0,
        -843.0780639648438,
        0.0
      ],
      [
        650.0,
        -867.0938720703125,
        16.99639320373535
      ],
      [
        650.0,
        -843.0780639648438,
        0.0
      ],
      [
        650.0,
        -743.0372314453125,
        -300.0
      ],
      [
        4050.0,
        2236.2041015625,
        975.8950805664062
      ],
      [
        4050.0,
        2131.818115234375,
        953.685302734375
      ],
      [
        4050.0,
        610.1387329101562,
        261.0314636230469
      ],
      [
        4050.0,
        611.6770629882812,
        264.1081848144531
      ],
      [
        4050.0,
        1387.95849609375,
        795.417236328125
      ],
      [
        4050.0,
        935.8558959960938,
        606.6973876953125
      ],
      [
        4050.0,
        1360.935791015625,
        789.6677856445312
      ],
      [
        4050.0,
        902.4468994140625,
        603.3396606445312
      ],
      [
        4050.0,
        935.8558959960938,
        606.6973876953125
      ],
      [
        4050.0,
        1374.29296875,
        795.417236328125
      ],
      [
        3000.0,
        706.95654296875,
        120.86956787109375
      ],
      [
        3000.0,
        887.2413330078125,
        128.96551513671875
      ],
      [
        3000.0,
        656.95654296875,
        99.13043212890625
      ],
      [
        3000.0,
        666.9274291992188,
        119.07222747802734
      ],
      [
        3285.123046875,
        1852.6285400390625,
        488.7391357421875
      ],
      [
        3312.43017578125,
        1790.47265625,
        489.9930419921875
      ],
      [
        3000.0,
        887.2413940429688,
        128.96551513671875
      ],
      [
        3000.0,
        1690.0,
        195.17239379882812
      ],
      [
        3000.0,
        667.8261108398438,
        120.86956787109375
      ],
      [
        3000.0,
        706.95654296875,
        120.86956787109375
      ],
      [
        3000.0,
        667.8261108398438,
        120.86956787109375
      ],
      [
        4050.0,
        1360.935791015625,
        789.6677856445312
      ],
      [
        3437.258056640625,
        1506.344482421875,
        495.7249755859375
      ],
      [
        2963.7763671875,
        666.4061889648438,
        70.78150177001953
      ],
      [
        3000.0,
        662.6111450195312,
        110.4395980834961
      ],
      [
        1910.0,
        1624.5108642578125,
        1060.0
      ],
      [
        1910.0,
        1623.9998779296875,
        1059.421875
      ],
      [
        1910.0,
        1623.9998779296875,
        1059.421875
      ],
      [
        1910.0,
        1623.9998779296875,
        1060.0
      ],
      [
        1917.370849609375,
        1631.8814697265625,
        1060.0
      ],
      [
        1910.0,
        1624.5106201171875,
        1060.0
      ],
      [
        1910.0,
        1624.0,
        1060.0
      ],
      [
        1910.0,
        1643.306640625,
        1060.0
      ],
      [
        1368.283935546875,
        1690.0,
        207.65679931640625
      ],
      [
        1368.2840576171875,
        1690.0,
        227.65679931640625
      ],
      [
        1368.283935546875,
        1690.0,
        110.06968688964844
      ],
      [
        1368.2840576171875,
        1690.0,
        207.65679931640625
      ],
      [
        2955.163818359375,
        668.6528930664062,
        64.04132080078125
      ],
      [
        3000.0,
        666.9274291992188,
        119.07218170166016
      ],
      [
        1770.0,
        1288.2838134765625,
        206.61753845214844
      ],
      [
        1770.0,
        1288.28369140625,
        226.61752319335938
      ],
      [
        1770.0,
        1288.2838134765625,
        109.60779571533203
      ],
      [
        1770.0,
        1288.28369140625,
        206.61752319335938
      ],
      [
        1920.0,
        1138.283935546875,
        325.0
      ],
      [
        1920.0,
        1138.283935546875,
        410.0
      ],
      [
        980.0,
        1670.0,
        100.0
      ],
      [
        1013.3334350585938,
        1690.0,
        100.0
      ],
      [
        980.0,
        1670.0,
        100.0
      ],
      [
        941.5384521484375,
        1646.923095703125,
        100.0
      ],
      [
        980.0,
        1670.0,
        80.0
      ],
      [
        1013.3334350585938,
        1690.0,
        80.0
      ],
      [
        1013.3334350585938,
        1690.0,
        98.0
      ],
      [
        980.0,
        1670.0,
        98.0
      ],
      [
        980.0,
        1670.0,
        100.0
      ],
      [
        980.0,
        1690.0,
        98.0
      ],
      [
        980.0,
        1670.0,
        98.0
      ],
      [
        980.0,
        1670.0,
        80.0
      ],
      [
        980.0,
        1630.0,
        80.0
      ],
      [
        1030.0,
        1630.0,
        80.0
      ],
      [
        1030.0,
        1630.0,
        100.0
      ],
      [
        1030.0,
        1630.0,
        100.0
      ],
      [
        1030.0,
        1630.0,
        80.0
      ],
      [
        1029.2777099609375,
        1690.0,
        98.0
      ],
      [
        1029.2777099609375,
        1640.0,
        98.0
      ],
      [
        1029.2777099609375,
        1640.0,
        98.0
      ],
      [
        980.0,
        1630.0,
        100.0
      ],
      [
        1000.0,
        1630.0,
        100.0
      ],
      [
        980.0,
        1630.0,
        100.0
      ],
      [
        950.0,
        1630.0,
        100.0
      ],
      [
        1000.0,
        1630.0,
        98.0
      ],
      [
        980.0,
        1630.0,
        98.0
      ],
      [
        980.0,
        1630.0,
        100.0
      ],
      [
        980.0,
        1670.0,
        98.0
      ],
      [
        980.0,
        1630.0,
        98.0
      ],
      [
        980.0,
        1630.0,
        80.0
      ],
      [
        1183.0,
        1620.0,
        118.0
      ],
      [
        1036.5,
        1628.55859375,
        118.0
      ],
      [
        1183.0,
        1620.0,
        118.0
      ],
      [
        1200.0,
        1620.0,
        118.0
      ],
      [
        1036.5,
        1630.0,
        118.0
      ],
      [
        1036.5,
        1628.55859375,
        118.0
      ],
      [
        1033.75,
        1610.0,
        118.0
      ],
      [
        1033.75,
        1620.0,
        118.0
      ],
      [
        1033.75,
        1610.0,
        118.0
      ],
      [
        1200.0,
        1590.0,
        100.0
      ],
      [
        1030.0,
        1590.0,
        80.0
      ],
      [
        980.0,
        1622.9208984375,
        100.0
      ],
      [
        1000.0,
        1621.7525634765625,
        100.0
      ],
      [
        980.0,
        1622.9208984375,
        100.0
      ],
      [
        952.7433471679688,
        1624.5133056640625,
        100.0
      ],
      [
        1000.0,
        1620.7593994140625,
        98.0
      ],
      [
        980.0,
        1621.927734375,
        98.0
      ],
      [
        980.0,
        1622.9208984375,
        100.0
      ],
      [
        980.0,
        1630.0,
        98.0
      ],
      [
        980.0,
        1621.927734375,
        98.0
      ],
      [
        980.0,
        1620.0,
        80.0
      ],
      [
        980.0,
        1620.0,
        94.11782836914062
      ],
      [
        980.0,
        1620.0,
        100.0
      ],
      [
        980.0,
        1620.0,
        100.0
      ],
      [
        955.0,
        1620.0,
        100.0
      ],
      [
        980.0,
        1620.0,
        98.0
      ],
      [
        980.0,
        1620.0,
        100.0
      ],
      [
        980.0,
        1621.927734375,
        98.0
      ],
      [
        980.0,
        1620.0,
        98.0
      ],
      [
        980.0,
        1590.0,
        80.0
      ],
      [
        1030.0,
        1590.0,
        80.0
      ],
      [
        980.0,
        1620.0,
        89.33335876464844
      ],
      [
        980.0,
        1620.0,
        87.33335876464844
      ],
      [
        980.0,
        1610.0,
        87.33335876464844
      ],
      [
        980.0,
        1610.0,
        89.33335876464844
      ],
      [
        996.25,
        1618.125,
        98.0
      ],
      [
        996.25,
        1611.875,
        98.0
      ],
      [
        996.25,
        1620.0,
        98.0
      ],
      [
        996.25,
        1618.125,
        98.0
      ],
      [
        996.25,
        1610.0,
        98.0
      ],
      [
        996.25,
        1611.875,
        98.0
      ],
      [
        980.0,
        1610.0,
        100.0
      ],
      [
        960.0,
        1610.0,
        100.0
      ],
      [
        980.0,
        1610.0,
        100.0
      ],
      [
        980.0,
        1610.0,
        100.0
      ],
      [
        980.0,
        1610.0,
        98.0
      ],
      [
        980.0,
        1590.0,
        100.0
      ],
      [
        970.0,
        1590.0,
        100.0
      ],
      [
        980.0,
        1590.0,
        100.0
      ],
      [
        1000.0,
        1590.0,
        100.0
      ],
      [
        980.0,
        1590.0,
        98.0
      ],
      [
        1000.0,
        1590.0,
        98.0
      ],
      [
        980.0,
        1590.0,
        100.0
      ],
      [
        980.0,
        1610.0,
        98.0
      ],
      [
        980.0,
        1590.0,
        98.0
      ],
      [
        980.0,
        1590.0,
        87.33335876464844
      ],
      [
        980.0,
        1590.0,
        80.0
      ],
      [
        980.0,
        1570.0,
        100.0
      ],
      [
        1000.0,
        1570.0,
        100.0
      ],
      [
        980.0,
        1570.0,
        98.0
      ],
      [
        1000.0,
        1570.0,
        98.0
      ],
      [
        1075.0,
        1550.0,
        160.0
      ],
      [
        1175.0,
        1550.0,
        160.0
      ],
      [
        1175.0,
        1570.0,
        160.0
      ],
      [
        1075.0,
        1570.0,
        160.0
      ],
      [
        1075.0,
        1550.0,
        180.0
      ],
      [
        1175.0,
        1550.0,
        180.0
      ],
      [
        1175.0,
        1550.0,
        160.0
      ],
      [
        1075.0,
        1550.0,
        160.0
      ],
      [
        1030.0,
        1520.0,
        370.0852355957031
      ],
      [
        1030.0,
        1470.0,
        370.0852355957031
      ],
      [
        1050.0,
        1470.0,
        390.0852355957031
      ],
      [
        1030.0,
        1550.0,
        180.0
      ],
      [
        1030.0,
        1550.0,
        160.0
      ],
      [
        1030.0,
        1550.0,
        160.0
      ],
      [
        1030.0,
        1570.0,
        160.0
      ],
      [
        1030.0,
        1540.0,
        355.9431457519531
      ],
      [
        1030.0,
        1520.0,
        355.9431457519531
      ],
      [
        1030.0,
        1520.0,
        370.0852355957031
      ],
      [
        1030.0,
        1520.0,
        355.9431457519531
      ],
      [
        1030.0,
        1460.0,
        370.0852355957031
      ],
      [
        1050.0,
        1460.0,
        390.0852355957031
      ],
      [
        839.914794921875,
        1460.0,
        180.0
      ],
      [
        980.0,
        1520.0,
        80.0
      ],
      [
        1030.0,
        1520.0,
        80.0
      ],
      [
        980.0,
        1520.0,
        80.0
      ],
      [
        928.6475219726562,
        1520.0,
        74.86474609375
      ],
      [
        960.0,
        1550.0,
        80.0
      ],
      [
        929.0144653320312,
        1520.0,
        98.0
      ],
      [
        980.0,
        1520.0,
        98.0
      ],
      [
        980.0,
        1520.0,
        100.0
      ],
      [
        1000.0,
        1520.0,
        100.0
      ],
      [
        980.0,
        1520.0,
        98.0
      ],
      [
        1000.0,
        1520.0,
        98.0
      ],
      [
        980.0,
        1460.0,
        80.0
      ],
      [
        890.0,
        1460.0,
        71.0
      ],
      [
        980.0,
        1460.0,
        80.0
      ],
      [
        1030.0,
        1460.0,
        80.0
      ],
      [
        980.0,
        1460.0,
        98.0
      ],
      [
        890.0,
        1460.0,
        98.0
      ],
      [
        980.0,
        1460.0,
        98.0
      ],
      [
        980.0,
        1460.0,
        100.0
      ],
      [
        839.914794921875,
        1450.0,
        180.0
      ],
      [
        1050.0,
        1450.0,
        390.0852355957031
      ],
      [
        1080.0,
        1450.0,
        98.0
      ],
      [
        890.0,
        1450.0,
        98.0
      ],
      [
        980.0,
        1450.0,
        98.0
      ],
      [
        1080.0,
        1450.0,
        100.0
      ],
      [
        1090.0,
        1450.0,
        87.05882263183594
      ],
      [
        1030.0,
        1450.0,
        80.0
      ],
      [
        1030.0,
        1280.0,
        140.0
      ],
      [
        1030.0,
        1300.0,
        140.0
      ],
      [
        1030.0,
        1300.0,
        140.0
      ],
      [
        1030.0,
        1390.0,
        140.0
      ],
      [
        1200.0,
        1300.0,
        140.0
      ],
      [
        1030.0,
        1300.0,
        140.0
      ],
      [
        1200.0,
        1390.0,
        140.0
      ],
      [
        1200.0,
        1300.0,
        140.0
      ],
      [
        1030.0,
        1330.0,
        370.0852355957031
      ],
      [
        1030.0,
        1450.0,
        370.0852355957031
      ],
      [
        1430.0,
        1300.0,
        572.8280029296875
      ],
      [
        1630.0001220703125,
        1300.0,
        714.2494506835938
      ],
      [
        1410.0,
        1280.0,
        544.5437622070312
      ],
      [
        1630.0001220703125,
        1280.0,
        700.1072998046875
      ],
      [
        1030.0,
        1280.0,
        160.0
      ],
      [
        1030.0,
        1300.0,
        160.0
      ],
      [
        1770.0,
        1280.0,
        204.8837127685547
      ],
      [
        1770.0,
        1280.0,
        224.88372802734375
      ],
      [
        1770.0,
        1288.2838134765625,
        160.0
      ],
      [
        1770.0,
        1280.0,
        204.88372802734375
      ],
      [
        1770.0,
        1280.0,
        160.0
      ],
      [
        1770.0,
        1288.2838134765625,
        140.0
      ],
      [
        1770.0,
        1280.0,
        140.0
      ],
      [
        490.0,
        1130.0,
        190.0
      ],
      [
        490.0,
        1130.0,
        290.0
      ],
      [
        490.0,
        1130.0,
        290.0
      ],
      [
        440.0,
        1130.0,
        340.0
      ],
      [
        1030.0,
        1170.0,
        140.0
      ],
      [
        1200.0,
        1170.0,
        140.0
      ],
      [
        1200.0,
        1170.0,
        140.0
      ],
      [
        1200.0,
        1280.0,
        140.0
      ],
      [
        1000.0,
        1170.0,
        140.0
      ],
      [
        1000.0,
        1170.0,
        280.0
      ],
      [
        985.4663696289062,
        1170.0,
        280.0
      ],
      [
        985.4663696289062,
        1170.0,
        400.0
      ],
      [
        1030.0,
        1280.0,
        140.0
      ],
      [
        1030.0,
        1170.0,
        140.0
      ],
      [
        1000.0,
        1170.0,
        280.0
      ],
      [
        1030.0,
        1170.0,
        300.0
      ],
      [
        1770.0,
        1170.0,
        181.86045837402344
      ],
      [
        1770.0,
        1170.0,
        201.8604736328125
      ],
      [
        1770.0,
        1170.0,
        181.8604736328125
      ],
      [
        1770.0,
        1170.0,
        140.0
      ],
      [
        987.1072998046875,
        1130.0,
        140.0
      ],
      [
        987.1072998046875,
        1130.0,
        280.0
      ],
      [
        1001.373779296875,
        1170.0,
        280.9158630371094
      ],
      [
        1770.0,
        1166.1483154296875,
        181.05429077148438
      ],
      [
        1770.0,
        1166.1483154296875,
        201.05430603027344
      ],
      [
        1770.0,
        1166.1483154296875,
        181.05430603027344
      ],
      [
        1770.0,
        1166.1483154296875,
        140.0
      ],
      [
        1920.0,
        1130.0,
        325.0
      ],
      [
        1920.0,
        1130.0,
        410.0
      ],
      [
        1770.0,
        1130.0,
        173.48837280273438
      ],
      [
        1770.0,
        1130.0,
        193.48837280273438
      ],
      [
        1770.0,
        1130.0,
        173.48837280273438
      ],
      [
        1770.0,
        1130.0,
        140.0
      ],
      [
        980.0,
        1130.0,
        100.0
      ],
      [
        980.0,
        1130.0,
        98.0
      ],
      [
        980.0,
        1130.0,
        118.0
      ],
      [
        980.0,
        1130.0,
        120.0
      ],
      [
        980.0,
        1170.0,
        98.0
      ],
      [
        964.0,
        1130.0,
        98.0
      ],
      [
        964.0,
        1130.0,
        100.0
      ],
      [
        964.0,
        1130.0,
        100.0
      ],
      [
        968.667724609375,
        1130.0,
        108.66770935058594
      ],
      [
        980.0,
        1143.0740966796875,
        119.99999237060547
      ],
      [
        980.0,
        1143.0740966796875,
        119.99999237060547
      ],
      [
        968.667724609375,
        1130.0,
        108.66770935058594
      ],
      [
        980.0,
        1130.0,
        127.92337036132812
      ],
      [
        964.0,
        1130.0,
        80.0
      ],
      [
        964.0,
        1130.0,
        80.0
      ],
      [
        980.0,
        1130.0,
        80.0
      ],
      [
        1030.0,
        1390.0,
        98.0
      ],
      [
        1030.0,
        1390.0,
        100.0
      ],
      [
        1030.0,
        1390.0,
        100.0
      ],
      [
        1030.0,
        1410.0,
        100.0
      ],
      [
        1030.0,
        1440.0,
        100.0
      ],
      [
        1030.0,
        1450.0,
        100.0
      ],
      [
        1030.0,
        1410.0,
        98.0
      ],
      [
        1030.0,
        1390.0,
        98.0
      ],
      [
        1030.0,
        1440.0,
        98.0
      ],
      [
        1030.0,
        1450.0,
        98.0
      ],
      [
        1030.0,
        1440.0,
        100.0
      ],
      [
        1030.0,
        1440.0,
        98.0
      ],
      [
        1770.0,
        1170.0,
        97.39130401611328
      ],
      [
        1770.0,
        1170.0,
        97.07317352294922
      ],
      [
        1770.0,
        1170.0,
        98.60465240478516
      ],
      [
        1770.0,
        1170.0,
        140.0
      ],
      [
        1030.0,
        1140.0,
        118.0
      ],
      [
        1030.0,
        1130.0,
        118.0
      ],
      [
        1030.0,
        1140.0,
        120.0
      ],
      [
        1030.0,
        1130.0,
        120.0
      ],
      [
        1770.0,
        1170.0,
        118.0
      ],
      [
        1770.0,
        1170.0,
        120.0
      ],
      [
        1770.0,
        1130.0,
        120.0
      ],
      [
        1770.0,
        1130.0,
        118.0
      ],
      [
        1770.0,
        1130.0,
        93.91304016113281
      ],
      [
        1770.0,
        1130.0,
        93.17073059082031
      ],
      [
        1770.0,
        1130.0,
        94.88372039794922
      ],
      [
        1014.0,
        1130.0,
        80.0
      ],
      [
        987.1072998046875,
        1130.0,
        140.0
      ],
      [
        990.0,
        1130.0,
        120.0
      ],
      [
        990.0,
        1140.0,
        120.0
      ],
      [
        980.0,
        1130.0,
        120.0
      ],
      [
        990.0,
        1130.0,
        120.0
      ],
      [
        988.9999389648438,
        1140.0,
        118.0
      ],
      [
        988.9999389648438,
        1131.0,
        118.0
      ],
      [
        988.9999389648438,
        1131.0,
        118.0
      ],
      [
        980.0,
        1130.0,
        118.0
      ],
      [
        988.9999389648438,
        1130.0,
        118.0
      ],
      [
        1000.0,
        1130.0,
        100.0
      ],
      [
        980.0,
        1130.0,
        100.0
      ],
      [
        980.0,
        1130.0,
        98.0
      ],
      [
        1000.0,
        1130.0,
        98.0
      ],
      [
        1000.0,
        1130.0,
        98.0
      ],
      [
        1000.0,
        1130.0,
        100.0
      ],
      [
        1000.0,
        1386.0,
        98.0
      ],
      [
        1010.0,
        1386.0,
        98.0
      ],
      [
        1000.0,
        1386.0,
        98.0
      ],
      [
        1020.0,
        1246.0,
        100.0
      ],
      [
        1030.0,
        1246.0,
        100.0
      ],
      [
        1020.0,
        1246.0,
        100.0
      ],
      [
        1030.0,
        1206.0,
        120.0
      ],
      [
        1020.0,
        1206.0,
        120.0
      ],
      [
        1020.0000610351562,
        1140.0,
        118.0
      ],
      [
        1020.0000610351562,
        1130.0,
        118.0
      ],
      [
        1020.0000610351562,
        1140.0,
        120.0
      ],
      [
        1020.0000610351562,
        1130.0,
        120.0
      ],
      [
        990.0,
        1130.0,
        118.0
      ],
      [
        990.0,
        1130.0,
        118.0
      ],
      [
        1250.0,
        1105.8577880859375,
        138.5113525390625
      ],
      [
        1250.0,
        1105.8577880859375,
        140.0
      ],
      [
        1250.0,
        1105.8577880859375,
        118.5113525390625
      ],
      [
        1250.0,
        1105.8577880859375,
        138.5113525390625
      ],
      [
        1250.0,
        1105.8577880859375,
        118.5113525390625
      ],
      [
        1250.0,
        1105.8577880859375,
        98.5113525390625
      ],
      [
        1600.0,
        720.0,
        100.0
      ],
      [
        1600.0,
        720.0,
        240.0
      ],
      [
        1770.0,
        980.0,
        80.0
      ],
      [
        1758.0,
        980.0,
        80.0
      ],
      [
        1702.0,
        980.0,
        310.0
      ],
      [
        1690.0,
        982.5,
        80.0
      ],
      [
        1690.0,
        982.5,
        80.0
      ],
      [
        1690.0,
        970.0,
        80.0
      ],
      [
        1690.0,
        940.0,
        100.0
      ],
      [
        1690.0,
        960.0,
        100.0
      ],
      [
        1690.0,
        920.0,
        100.0
      ],
      [
        1690.0,
        840.0,
        100.0
      ],
      [
        1690.0,
        920.0,
        80.0
      ],
      [
        1690.0,
        970.0,
        80.0
      ],
      [
        1690.0,
        920.0,
        80.0
      ],
      [
        1690.0,
        920.0,
        100.0
      ],
      [
        1690.0,
        960.0,
        98.0
      ],
      [
        1690.0,
        940.0,
        98.0
      ],
      [
        1690.0,
        940.0,
        100.0
      ],
      [
        1690.0,
        940.0,
        98.0
      ],
      [
        1690.0,
        900.0,
        240.0
      ],
      [
        1770.0,
        840.0,
        240.0
      ],
      [
        1690.0,
        840.0,
        240.0
      ],
      [
        1770.0,
        840.0,
        118.0
      ],
      [
        1690.0,
        920.0,
        118.0
      ],
      [
        1690.0,
        940.0,
        118.0
      ],
      [
        1690.0,
        900.0,
        220.0
      ],
      [
        1690.0,
        900.0,
        240.0
      ],
      [
        1750.0,
        900.0,
        120.0
      ],
      [
        1750.0,
        900.0,
        118.0
      ],
      [
        1690.0,
        940.0,
        118.0
      ],
      [
        1690.0,
        940.0,
        120.0
      ],
      [
        1650.0,
        970.0,
        80.0
      ],
      [
        1650.0,
        1120.0,
        100.0
      ],
      [
        1681.6666259765625,
        995.0,
        83.33332824707031
      ],
      [
        1681.9998779296875,
        970.0,
        80.0
      ],
      [
        1681.6666259765625,
        995.0,
        83.33332824707031
      ],
      [
        1690.0,
        983.6363525390625,
        81.81817626953125
      ],
      [
        1685.9998779296875,
        920.0,
        80.0
      ],
      [
        1681.9998779296875,
        970.0,
        80.0
      ],
      [
        1685.9998779296875,
        920.0,
        80.0
      ],
      [
        1690.0,
        920.0,
        88.00027465820312
      ],
      [
        1650.0,
        940.0,
        100.0
      ],
      [
        1650.0,
        920.0,
        100.0
      ],
      [
        1650.0,
        840.0,
        100.0
      ],
      [
        1650.0,
        920.0,
        80.0
      ],
      [
        1650.0,
        970.0,
        80.0
      ],
      [
        1650.0,
        920.0,
        80.0
      ],
      [
        1650.0,
        920.0,
        100.0
      ],
      [
        1650.0,
        940.0,
        98.0
      ],
      [
        1650.0,
        940.0,
        100.0
      ],
      [
        1650.0,
        940.0,
        98.0
      ],
      [
        1650.0,
        963.0,
        100.0
      ],
      [
        1660.0,
        963.0,
        100.0
      ],
      [
        1650.0,
        900.0,
        240.0
      ],
      [
        1650.0,
        840.0,
        240.0
      ],
      [
        1650.0,
        900.0,
        220.0
      ],
      [
        1650.0,
        900.0,
        240.0
      ],
      [
        1650.0,
        920.0,
        118.0
      ],
      [
        1660.0,
        987.0,
        118.0
      ],
      [
        1650.0,
        987.0,
        118.0
      ],
      [
        1650.0,
        810.0,
        100.0
      ],
      [
        1650.0,
        720.0,
        100.0
      ],
      [
        1750.0,
        720.0,
        100.0
      ],
      [
        1650.0,
        810.0,
        240.0
      ],
      [
        1650.0,
        740.0,
        80.0
      ],
      [
        1650.0,
        740.0,
        100.0
      ],
      [
        1630.0,
        960.0,
        100.0
      ],
      [
        1630.0,
        940.0,
        100.0
      ],
      [
        1630.0,
        920.0,
        100.0
      ],
      [
        1630.0,
        840.0,
        100.0
      ],
      [
        1630.0,
        920.0,
        80.0
      ],
      [
        1630.0,
        920.0,
        100.0
      ],
      [
        1630.0,
        940.0,
        98.0
      ],
      [
        1630.0,
        960.0,
        98.0
      ],
      [
        1630.0,
        960.0,
        100.0
      ],
      [
        1630.0,
        960.0,
        98.0
      ],
      [
        1630.0,
        940.0,
        100.0
      ],
      [
        1630.0,
        940.0,
        98.0
      ],
      [
        1630.0,
        900.0,
        240.0
      ],
      [
        1650.0,
        840.0,
        240.0
      ],
      [
        1630.0,
        840.0,
        240.0
      ],
      [
        1630.0,
        900.0,
        220.0
      ],
      [
        1630.0,
        900.0,
        240.0
      ],
      [
        1600.0,
        1110.0,
        140.0
      ],
      [
        1600.0,
        980.0,
        140.0
      ],
      [
        1600.0,
        960.0,
        100.0
      ],
      [
        1600.0,
        940.0,
        100.0
      ],
      [
        1600.0,
        920.0,
        80.0
      ],
      [
        1600.0,
        970.0,
        80.0
      ],
      [
        1600.0,
        980.0,
        100.0
      ],
      [
        1600.0,
        970.0,
        80.0
      ],
      [
        1600.0,
        920.0,
        80.0
      ],
      [
        1600.0,
        920.0,
        100.0
      ],
      [
        1600.0,
        940.0,
        98.0
      ],
      [
        1600.0,
        960.0,
        98.0
      ],
      [
        1600.0,
        960.0,
        100.0
      ],
      [
        1600.0,
        960.0,
        98.0
      ],
      [
        1600.0,
        940.0,
        100.0
      ],
      [
        1600.0,
        940.0,
        98.0
      ],
      [
        1600.0,
        980.0,
        140.0
      ],
      [
        1600.0,
        980.0,
        100.0
      ],
      [
        1600.0,
        840.0,
        240.0
      ],
      [
        1600.0,
        720.0,
        100.0
      ],
      [
        1530.0,
        960.0,
        100.0
      ],
      [
        1530.0,
        960.0,
        98.0
      ],
      [
        1557.0,
        1110.0,
        140.0
      ],
      [
        1570.0,
        980.0,
        140.0
      ],
      [
        1570.0,
        980.0,
        140.0
      ],
      [
        1570.0,
        980.0,
        100.0
      ],
      [
        1570.0,
        980.0,
        100.0
      ],
      [
        1571.0,
        970.0,
        80.0
      ],
      [
        1571.0,
        970.0,
        80.0
      ],
      [
        1600.0,
        960.0,
        80.0
      ],
      [
        1572.0,
        960.0,
        80.0
      ],
      [
        1530.0,
        1110.0,
        140.0
      ],
      [
        1530.0,
        960.0,
        80.0
      ],
      [
        1530.0,
        940.0,
        100.0
      ],
      [
        1530.0,
        940.0,
        98.0
      ],
      [
        1530.0,
        840.0,
        220.0
      ],
      [
        1530.0,
        940.0,
        80.0
      ],
      [
        1600.0,
        940.0,
        80.0
      ],
      [
        1530.0,
        940.0,
        98.0
      ],
      [
        1530.0,
        960.0,
        98.0
      ],
      [
        1530.0,
        960.0,
        100.0
      ],
      [
        1530.0,
        940.0,
        100.0
      ],
      [
        1250.0,
        919.5372924804688,
        250.84054565429688
      ],
      [
        1250.0,
        919.5372924804688,
        160.0
      ],
      [
        1411.0897216796875,
        969.1033325195312,
        140.0
      ],
      [
        1411.0897216796875,
        969.1033325195312,
        515.0
      ],
      [
        1488.70166015625,
        992.9840087890625,
        140.0
      ],
      [
        1488.70166015625,
        992.9839477539062,
        515.0
      ],
      [
        1477.0,
        1110.0,
        140.0
      ],
      [
        1530.0,
        1005.691162109375,
        140.0
      ],
      [
        1488.7015380859375,
        992.9839477539062,
        140.0
      ],
      [
        1405.0,
        1030.0,
        140.0
      ],
      [
        1405.0,
        1030.0,
        465.0
      ],
      [
        1397.0,
        1110.0,
        140.0
      ],
      [
        1485.0,
        1030.0,
        140.0
      ],
      [
        1405.0,
        1030.0,
        140.0
      ],
      [
        1411.0897216796875,
        969.1033325195312,
        140.0
      ],
      [
        1439.7935791015625,
        977.935302734375,
        140.0
      ],
      [
        1446.5037841796875,
        980.0,
        140.0
      ],
      [
        1410.0,
        980.0,
        140.0
      ],
      [
        1410.0,
        980.0,
        140.0
      ],
      [
        1446.5037841796875,
        980.0,
        140.0
      ],
      [
        1446.5037841796875,
        980.0,
        100.0
      ],
      [
        1410.0,
        980.0,
        100.0
      ],
      [
        1410.0,
        980.0,
        100.0
      ],
      [
        1446.5037841796875,
        980.0,
        100.0
      ],
      [
        1414.0037841796875,
        970.0,
        80.0
      ],
      [
        1411.0001220703125,
        970.0,
        80.0
      ],
      [
        1411.0001220703125,
        970.0,
        80.0
      ],
      [
        1414.0037841796875,
        970.0,
        80.0
      ],
      [
        1411.0897216796875,
        969.1033935546875,
        80.0
      ],
      [
        1395.0,
        964.1526489257812,
        160.0
      ],
      [
        1395.0,
        964.1526489257812,
        161.1999969482422
      ],
      [
        1395.0,
        1110.0,
        140.0
      ],
      [
        1405.0,
        1030.0,
        140.0
      ],
      [
        1395.0,
        1030.0,
        140.0
      ],
      [
        1395.0,
        980.0,
        140.0
      ],
      [
        1395.0,
        980.0,
        140.0
      ],
      [
        1395.0,
        980.0,
        100.0
      ],
      [
        1395.0,
        980.0,
        100.0
      ],
      [
        1395.0,
        970.0,
        80.0
      ],
      [
        1395.0,
        970.0,
        80.0
      ],
      [
        1395.0,
        964.1527099609375,
        80.0
      ],
      [
        1250.0,
        1050.0,
        330.10211181640625
      ],
      [
        1250.0,
        1050.0,
        160.0
      ],
      [
        1380.0,
        1050.0,
        140.0
      ],
      [
        1395.0,
        1050.0,
        140.0
      ],
      [
        1380.0,
        1050.0,
        140.0
      ],
      [
        1250.0,
        1040.0,
        283.118408203125
      ],
      [
        1250.0,
        919.5372924804688,
        250.84054565429688
      ],
      [
        1390.0,
        962.6142578125,
        160.0
      ],
      [
        1395.0,
        964.1526489257812,
        160.0
      ],
      [
        1250.0,
        919.5852661132812,
        160.0
      ],
      [
        1250.0,
        919.5372924804688,
        160.0
      ],
      [
        1390.0,
        962.6142578125,
        160.0
      ],
      [
        1395.0,
        964.1526489257812,
        161.1999969482422
      ],
      [
        1390.0,
        962.6142578125,
        161.1999969482422
      ],
      [
        1250.0,
        919.5372924804688,
        161.1999969482422
      ],
      [
        1250.0,
        919.5852661132812,
        161.1999969482422
      ],
      [
        1390.0,
        962.6142578125,
        161.1999969482422
      ],
      [
        1250.0,
        1016.0,
        160.0
      ],
      [
        1250.0,
        1016.0,
        161.1999969482422
      ],
      [
        1258.0,
        1016.0,
        161.1999969482422
      ],
      [
        1258.0,
        1016.0,
        160.0
      ],
      [
        1250.0,
        1016.0,
        204.0
      ],
      [
        1250.0,
        919.5372924804688,
        160.0
      ],
      [
        1250.0,
        1016.0,
        80.0
      ],
      [
        1395.0,
        980.0,
        129.70704650878906
      ],
      [
        1380.0,
        980.0,
        120.88444519042969
      ],
      [
        1395.0,
        974.6153564453125,
        89.23075103759766
      ],
      [
        1380.0,
        959.5372924804688,
        80.0
      ],
      [
        1380.0,
        959.5372924804688,
        80.0
      ],
      [
        1250.0,
        919.5372924804688,
        80.0
      ],
      [
        1330.0,
        944.1526489257812,
        98.0
      ],
      [
        1380.0,
        959.5372924804688,
        98.0
      ],
      [
        1250.0,
        919.5372924804688,
        98.0
      ],
      [
        1330.0,
        944.1526489257812,
        98.0
      ],
      [
        1380.0,
        959.5372924804688,
        98.0
      ],
      [
        1381.5037841796875,
        960.0,
        98.0
      ],
      [
        1380.0,
        959.5372924804688,
        100.0
      ],
      [
        1330.0,
        944.1526489257812,
        100.0
      ],
      [
        1250.0,
        919.5372924804688,
        100.0
      ],
      [
        1330.0,
        944.1526489257812,
        100.0
      ],
      [
        1380.0,
        959.5372924804688,
        100.0
      ],
      [
        1381.5037841796875,
        960.0,
        100.0
      ],
      [
        1381.5037841796875,
        960.0,
        100.0
      ],
      [
        1381.5037841796875,
        960.0,
        98.0
      ],
      [
        1490.0,
        980.0,
        140.0
      ],
      [
        1490.0,
        980.0,
        100.0
      ],
      [
        1490.0,
        980.0,
        140.0
      ],
      [
        1488.7015380859375,
        992.9839477539062,
        140.0
      ],
      [
        1490.0,
        980.0,
        100.0
      ],
      [
        1491.0,
        970.0,
        80.0
      ],
      [
        1491.0,
        970.0,
        80.0
      ],
      [
        1530.0,
        960.0,
        80.0
      ],
      [
        1492.0,
        960.0,
        80.0
      ],
      [
        1480.0,
        960.0,
        80.0
      ],
      [
        1480.0,
        960.0,
        80.0
      ],
      [
        1412.0,
        960.0,
        80.0
      ],
      [
        1411.0897216796875,
        969.1033935546875,
        80.0
      ],
      [
        1381.5037841796875,
        960.0,
        80.0
      ],
      [
        1395.0,
        960.0,
        161.1999969482422
      ],
      [
        1390.0,
        960.0,
        161.1999969482422
      ],
      [
        1381.503662109375,
        960.0,
        161.1999969482422
      ],
      [
        1390.0,
        960.0,
        161.1999969482422
      ],
      [
        1390.0,
        960.0,
        160.0
      ],
      [
        1395.0,
        960.0,
        160.0
      ],
      [
        1390.0,
        960.0,
        160.0
      ],
      [
        1381.503662109375,
        960.0,
        160.0
      ],
      [
        1395.0,
        960.0,
        160.0
      ],
      [
        1395.0,
        960.0,
        161.1999969482422
      ],
      [
        1530.0,
        880.0,
        76.0
      ],
      [
        1280.0,
        790.0,
        180.0
      ],
      [
        1270.0,
        790.0,
        180.0
      ],
      [
        1270.0,
        750.0,
        185.0
      ],
      [
        1270.0,
        750.0,
        195.0
      ],
      [
        1270.0,
        750.0,
        190.0
      ],
      [
        1270.0,
        750.0,
        192.0
      ],
      [
        1270.0,
        750.0,
        185.0
      ],
      [
        1270.0,
        750.0,
        195.0
      ],
      [
        1280.0,
        790.0,
        180.0
      ],
      [
        1270.0,
        790.0,
        180.0
      ],
      [
        1281.0,
        870.0,
        179.49993896484375
      ],
      [
        1281.0,
        870.0,
        179.49993896484375
      ],
      [
        1299.0,
        870.0,
        170.49998474121094
      ],
      [
        1281.0,
        845.0,
        179.49993896484375
      ],
      [
        1299.0,
        845.0,
        170.49998474121094
      ],
      [
        1281.0,
        860.0,
        179.49993896484375
      ],
      [
        1281.0,
        845.0,
        179.49993896484375
      ],
      [
        1281.0,
        860.0,
        179.49993896484375
      ],
      [
        1296.0,
        850.0,
        171.99993896484375
      ],
      [
        1296.0,
        860.0,
        171.99993896484375
      ],
      [
        1299.0,
        845.0,
        170.49998474121094
      ],
      [
        1299.0,
        850.0,
        170.49998474121094
      ],
      [
        1299.0,
        870.0,
        170.49998474121094
      ],
      [
        1299.0,
        860.0,
        170.49998474121094
      ],
      [
        1299.0,
        860.0,
        170.49998474121094
      ],
      [
        1296.0,
        860.0,
        171.99993896484375
      ],
      [
        1299.0,
        850.0,
        170.49998474121094
      ],
      [
        1296.0,
        850.0,
        171.99993896484375
      ],
      [
        1310.0,
        820.0,
        180.0
      ],
      [
        1250.0,
        914.8063354492188,
        160.0
      ],
      [
        1250.0,
        914.8063354492188,
        161.1999969482422
      ],
      [
        1395.0,
        959.397216796875,
        160.0
      ],
      [
        1250.0,
        914.8063354492188,
        160.0
      ],
      [
        1395.0,
        959.397216796875,
        161.1999969482422
      ],
      [
        1250.0,
        914.8063354492188,
        161.1999969482422
      ],
      [
        1395.0,
        959.397216796875,
        160.0
      ],
      [
        1395.0,
        959.397216796875,
        161.1999969482422
      ],
      [
        1380.0,
        954.784423828125,
        80.0
      ],
      [
        1396.9600830078125,
        960.0,
        80.0
      ],
      [
        1380.0,
        954.784423828125,
        80.0
      ],
      [
        1250.0,
        914.8063354492188,
        80.0
      ],
      [
        1330.0,
        939.408203125,
        98.0
      ],
      [
        1380.0,
        954.784423828125,
        98.0
      ],
      [
        1250.0,
        914.8063354492188,
        98.0
      ],
      [
        1330.0,
        939.408203125,
        98.0
      ],
      [
        1380.0,
        954.784423828125,
        98.0
      ],
      [
        1396.9600830078125,
        960.0,
        98.0
      ],
      [
        1380.0,
        954.784423828125,
        100.0
      ],
      [
        1330.0,
        939.408203125,
        100.0
      ],
      [
        1250.0,
        914.8063354492188,
        100.0
      ],
      [
        1330.0,
        939.408203125,
        100.0
      ],
      [
        1380.0,
        954.784423828125,
        100.0
      ],
      [
        1396.9600830078125,
        960.0,
        100.0
      ],
      [
        1490.0,
        953.8461303710938,
        100.0
      ],
      [
        1445.0,
        940.0,
        100.0
      ],
      [
        1490.0,
        953.8461303710938,
        100.0
      ],
      [
        1510.0001220703125,
        960.0,
        100.0
      ],
      [
        1480.0,
        920.0,
        98.0
      ],
      [
        1480.0,
        920.0,
        100.0
      ],
      [
        1480.0,
        920.0,
        98.0
      ],
      [
        1500.0,
        920.0,
        98.0
      ],
      [
        1510.0,
        904.0,
        98.0
      ],
      [
        1520.0,
        904.0,
        98.0
      ],
      [
        1510.0,
        904.0,
        98.0
      ],
      [
        1510.0,
        920.0,
        90.0
      ],
      [
        1510.0,
        920.0,
        88.0
      ],
      [
        1510.0,
        920.0,
        90.0
      ],
      [
        1520.0,
        920.0,
        90.0
      ],
      [
        1445.0,
        940.0,
        98.0
      ],
      [
        1490.0,
        953.8461303710938,
        98.0
      ],
      [
        1510.0001220703125,
        960.0,
        98.0
      ],
      [
        1490.0,
        953.8461303710938,
        98.0
      ],
      [
        1445.0,
        940.0,
        98.0
      ],
      [
        1445.0,
        940.0,
        100.0
      ],
      [
        1290.0,
        700.0,
        258.0
      ],
      [
        1290.0,
        700.0,
        338.0
      ],
      [
        1290.0,
        700.0,
        258.0
      ],
      [
        650.0,
        505.8578186035156,
        80.0
      ],
      [
        650.0,
        505.85784912109375,
        78.0
      ],
      [
        630.0,
        485.8577880859375,
        60.0
      ],
      [
        620.0,
        475.8577880859375,
        80.0
      ],
      [
        630.0,
        485.8578186035156,
        80.0
      ],
      [
        650.0,
        505.85784912109375,
        80.0
      ],
      [
        630.0,
        485.8578186035156,
        78.0
      ],
      [
        650.0,
        505.8578186035156,
        78.0
      ],
      [
        630.0,
        281.61761474609375,
        80.0
      ],
      [
        630.0,
        281.61761474609375,
        78.0
      ],
      [
        650.0,
        283.51434326171875,
        78.0
      ],
      [
        650.0,
        283.51434326171875,
        80.0
      ],
      [
        621.0,
        289.8044738769531,
        78.0
      ],
      [
        630.0,
        281.61761474609375,
        78.0
      ],
      [
        630.0,
        281.61761474609375,
        80.0
      ],
      [
        650.0,
        283.51434326171875,
        60.0
      ],
      [
        650.0,
        283.51434326171875,
        150.0
      ],
      [
        650.0,
        480.0,
        98.0
      ],
      [
        624.1422119140625,
        480.0,
        98.0
      ],
      [
        620.0,
        475.8577880859375,
        98.0
      ],
      [
        650.0,
        460.0,
        98.0
      ],
      [
        650.0,
        460.0,
        100.0
      ],
      [
        620.0,
        475.8577880859375,
        100.0
      ],
      [
        624.1422119140625,
        480.0,
        100.0
      ],
      [
        650.0,
        480.0,
        100.0
      ],
      [
        650.0,
        480.0,
        100.0
      ],
      [
        624.1422119140625,
        480.0,
        100.0
      ],
      [
        624.1422119140625,
        480.0,
        98.0
      ],
      [
        650.0,
        480.0,
        98.0
      ],
      [
        763.9999389648438,
        306.0000915527344,
        80.0
      ],
      [
        763.9999389648438,
        300.0,
        80.0
      ],
      [
        763.9999389648438,
        310.0,
        80.0
      ],
      [
        763.9999389648438,
        306.0000915527344,
        80.0
      ],
      [
        770.0,
        310.0,
        78.0
      ],
      [
        770.0,
        310.0,
        80.0
      ],
      [
        770.0,
        310.0,
        78.0
      ],
      [
        770.0,
        310.0,
        80.0
      ],
      [
        760.0,
        320.0,
        80.0
      ],
      [
        770.0,
        320.0,
        80.0
      ],
      [
        770.0,
        320.0,
        78.0
      ],
      [
        760.0,
        320.0,
        78.0
      ],
      [
        770.0,
        320.0,
        78.0
      ],
      [
        770.0,
        320.0,
        80.0
      ],
      [
        794.3521728515625,
        650.2099609375,
        100.0
      ],
      [
        804.5620727539062,
        660.419921875,
        100.0
      ],
      [
        794.3521728515625,
        650.2099609375,
        100.0
      ],
      [
        804.5620727539062,
        660.419921875,
        100.0
      ],
      [
        824.1422119140625,
        680.0,
        100.0
      ],
      [
        1024.1422119140625,
        880.0,
        80.0
      ],
      [
        1074.1422119140625,
        930.0,
        80.0
      ],
      [
        1210.0,
        707.730224609375,
        78.0
      ],
      [
        1210.0,
        707.730224609375,
        80.0
      ],
      [
        1210.0,
        463.61309814453125,
        78.0
      ],
      [
        1230.0,
        707.730224609375,
        78.0
      ],
      [
        1210.0,
        707.730224609375,
        78.0
      ],
      [
        1230.0,
        707.730224609375,
        80.0
      ],
      [
        1230.0,
        707.730224609375,
        78.0
      ],
      [
        1210.0,
        463.61309814453125,
        78.0
      ],
      [
        1210.0,
        463.61309814453125,
        80.0
      ],
      [
        794.1422119140625,
        650.0,
        60.0
      ],
      [
        770.0,
        328.0721740722656,
        78.0
      ],
      [
        760.0,
        324.3941650390625,
        78.0
      ],
      [
        1192.89697265625,
        483.61309814453125,
        78.0
      ],
      [
        1190.0,
        482.547607421875,
        78.0
      ],
      [
        795.2718505859375,
        337.36712646484375,
        78.0
      ],
      [
        864.5260009765625,
        362.8387145996094,
        78.0
      ],
      [
        1190.0,
        482.547607421875,
        78.0
      ],
      [
        864.5260009765625,
        362.8387145996094,
        78.0
      ],
      [
        1191.0,
        482.9154357910156,
        78.0
      ],
      [
        1191.0,
        641.0,
        78.0
      ],
      [
        770.0,
        328.0721740722656,
        78.0
      ],
      [
        770.0,
        329.1376647949219,
        80.0
      ],
      [
        1191.0,
        483.61309814453125,
        78.0
      ],
      [
        1192.89697265625,
        483.61309814453125,
        78.0
      ],
      [
        844.1421508789062,
        700.0,
        60.0
      ],
      [
        850.8460083007812,
        706.7037963867188,
        78.19596862792969
      ],
      [
        852.9127807617188,
        707.368408203125,
        80.0
      ],
      [
        1190.468017578125,
        707.368408203125,
        80.0
      ],
      [
        1200.0,
        707.730224609375,
        60.0
      ],
      [
        1190.468017578125,
        707.368408203125,
        80.0
      ],
      [
        1190.468017578125,
        707.730224609375,
        80.0
      ],
      [
        852.9127807617188,
        707.368408203125,
        80.0
      ],
      [
        850.8460083007812,
        706.7037963867188,
        78.19596862792969
      ],
      [
        851.8724365234375,
        707.730224609375,
        78.31001281738281
      ],
      [
        853.2420043945312,
        707.730224609375,
        80.0
      ],
      [
        1210.0,
        825.0,
        60.0
      ],
      [
        1210.0,
        825.0,
        80.0
      ],
      [
        1250.0,
        825.0,
        80.0
      ],
      [
        1190.468017578125,
        713.2186279296875,
        80.0
      ],
      [
        867.0823364257812,
        722.9401245117188,
        80.0
      ],
      [
        1190.468017578125,
        713.2186279296875,
        80.0
      ],
      [
        1194.1214599609375,
        825.0,
        80.0
      ],
      [
        1210.0,
        755.230224609375,
        63.52632141113281
      ],
      [
        1200.0,
        755.230224609375,
        63.52632141113281
      ],
      [
        1194.1214599609375,
        825.0,
        80.0
      ],
      [
        1190.0,
        707.730224609375,
        100.0
      ],
      [
        854.0377807617188,
        707.730224609375,
        100.0
      ],
      [
        824.1422119140625,
        680.0,
        100.0
      ],
      [
        824.1422119140625,
        680.0,
        98.0
      ],
      [
        804.5620727539062,
        660.419921875,
        98.0
      ],
      [
        804.1421508789062,
        660.0,
        98.0
      ],
      [
        824.1422119140625,
        680.0,
        98.0
      ],
      [
        804.5620727539062,
        660.419921875,
        98.0
      ],
      [
        794.3521728515625,
        650.2099609375,
        98.0
      ],
      [
        794.3521728515625,
        650.2099609375,
        98.0
      ],
      [
        1004.0,
        640.0,
        100.0
      ],
      [
        1004.0,
        650.0,
        100.0
      ],
      [
        1004.0,
        650.0,
        100.0
      ],
      [
        853.2420043945312,
        707.730224609375,
        80.0
      ],
      [
        1190.468017578125,
        707.730224609375,
        80.0
      ],
      [
        854.0377807617188,
        707.730224609375,
        100.0
      ],
      [
        1014.1600952148438,
        867.8525390625,
        100.0
      ],
      [
        1200.0,
        867.8525390625,
        100.0
      ],
      [
        1250.0,
        867.8525390625,
        100.0
      ],
      [
        1014.1600952148438,
        867.8525390625,
        100.0
      ],
      [
        1200.0,
        867.8525390625,
        100.0
      ],
      [
        1190.0,
        825.0,
        100.0
      ],
      [
        1190.0,
        707.730224609375,
        100.0
      ],
      [
        1250.0,
        825.0,
        100.0
      ],
      [
        1250.0,
        825.0,
        98.0
      ],
      [
        1190.0,
        825.0,
        98.0
      ],
      [
        1190.0,
        825.0,
        100.0
      ],
      [
        1026.3074951171875,
        880.0,
        80.0
      ],
      [
        1200.0,
        1053.6925048828125,
        93.02027130126953
      ],
      [
        1250.0,
        1103.6925048828125,
        98.28343200683594
      ],
      [
        1186.0,
        1016.0,
        89.0526351928711
      ],
      [
        1250.0,
        1016.0,
        89.0526351928711
      ],
      [
        1200.0,
        930.0,
        100.0
      ],
      [
        1076.3074951171875,
        930.0,
        80.0
      ],
      [
        1076.3074951171875,
        930.0,
        100.0
      ],
      [
        1200.0,
        1053.6925048828125,
        93.02027130126953
      ],
      [
        1200.0,
        930.0,
        100.0
      ],
      [
        1200.0,
        1053.6925048828125,
        100.0
      ],
      [
        1186.0,
        1016.0,
        100.0
      ],
      [
        1200.0,
        1016.0,
        100.0
      ],
      [
        1200.0,
        1016.0,
        89.0526351928711
      ],
      [
        1250.0,
        1016.0,
        100.0
      ],
      [
        1137.0,
        900.0,
        100.0
      ],
      [
        1125.0,
        900.0,
        98.0
      ],
      [
        1125.0,
        910.0,
        98.0
      ],
      [
        1125.0,
        900.0,
        98.0
      ],
      [
        1125.0,
        910.0,
        98.0
      ],
      [
        1137.0,
        900.0,
        100.0
      ],
      [
        1137.0,
        887.8524780273438,
        100.0
      ],
      [
        1137.0,
        887.8524780273438,
        100.0
      ],
      [
        1095.0,
        910.0,
        84.0000228881836
      ],
      [
        1095.0,
        900.0,
        84.0000228881836
      ],
      [
        1013.6077270507812,
        869.4655151367188,
        96.28055572509766
      ],
      [
        1200.0,
        1055.8577880859375,
        93.2481918334961
      ],
      [
        1250.0,
        1105.8577880859375,
        98.5113525390625
      ],
      [
        1024.1422119140625,
        880.0,
        80.0
      ],
      [
        1013.6077270507812,
        869.4655151367188,
        96.28055572509766
      ],
      [
        1074.1422119140625,
        930.0,
        80.0
      ],
      [
        1074.1422119140625,
        930.0,
        100.0
      ],
      [
        1200.0,
        1055.8577880859375,
        100.0
      ],
      [
        1200.0,
        1055.8577880859375,
        93.2481918334961
      ],
      [
        930.0,
        640.0,
        120.0
      ],
      [
        930.0,
        366.79339599609375,
        120.0
      ],
      [
        930.0,
        387.9854736328125,
        120.0
      ],
      [
        660.1421508789062,
        516.0,
        140.0
      ],
      [
        660.0,
        515.8578491210938,
        140.0
      ],
      [
        660.1421508789062,
        516.0,
        190.0
      ],
      [
        660.1421508789062,
        516.0,
        140.0
      ],
      [
        868.9588623046875,
        344.4016418457031,
        140.0
      ],
      [
        930.0,
        366.79339599609375,
        220.0
      ],
      [
        930.0,
        366.79339599609375,
        140.0
      ],
      [
        930.0,
        600.0,
        140.0
      ],
      [
        880.0,
        640.0,
        140.0
      ],
      [
        880.0,
        640.0,
        140.0
      ],
      [
        840.0,
        640.0,
        140.0
      ],
      [
        930.0,
        366.79339599609375,
        120.0
      ],
      [
        930.0,
        387.9854736328125,
        100.0
      ],
      [
        930.0,
        387.9854736328125,
        120.0
      ],
      [
        930.0,
        640.0,
        120.0
      ],
      [
        930.0,
        640.0,
        100.0
      ],
      [
        1060.0,
        414.4813232421875,
        120.0
      ],
      [
        1060.0,
        414.4813232421875,
        220.0
      ],
      [
        1190.0,
        707.730224609375,
        120.0
      ],
      [
        1190.0,
        707.730224609375,
        120.0
      ],
      [
        1060.0,
        707.730224609375,
        120.0
      ],
      [
        1060.0,
        414.4813232421875,
        120.0
      ],
      [
        1060.0,
        435.79931640625,
        120.0
      ],
      [
        1190.0,
        568.0,
        220.0
      ],
      [
        1060.0,
        435.79931640625,
        100.0
      ],
      [
        1060.0,
        435.79931640625,
        120.0
      ],
      [
        1060.0,
        640.0,
        120.0
      ],
      [
        1060.0,
        640.0,
        100.0
      ],
      [
        1190.0,
        707.730224609375,
        118.0
      ],
      [
        1060.0,
        707.730224609375,
        118.0
      ],
      [
        1235.0,
        707.730224609375,
        120.0
      ],
      [
        1235.0,
        707.730224609375,
        118.0
      ],
      [
        1235.0,
        707.730224609375,
        120.0
      ],
      [
        1235.0,
        707.730224609375,
        118.0
      ],
      [
        1060.0,
        584.0,
        220.0
      ],
      [
        1036.0,
        650.0,
        118.0
      ],
      [
        1036.0,
        640.0,
        118.0
      ],
      [
        1036.0,
        650.0,
        118.0
      ],
      [
        1240.0,
        916.4603881835938,
        160.0
      ],
      [
        1240.0,
        916.4603881835938,
        161.1999969482422
      ],
      [
        1240.0,
        1095.8577880859375,
        160.0
      ],
      [
        1240.0,
        1095.8577880859375,
        284.24432373046875
      ],
      [
        1250.0,
        1050.0,
        140.0
      ],
      [
        1250.0,
        1105.8577880859375,
        140.0
      ],
      [
        1240.0,
        1095.8577880859375,
        160.0
      ],
      [
        1240.0,
        1016.0,
        204.0
      ],
      [
        1250.0,
        1016.0,
        139.99996948242188
      ],
      [
        1240.0,
        1016.0,
        160.00010681152344
      ],
      [
        1240.0,
        916.4603881835938,
        161.1999969482422
      ],
      [
        1250.0,
        919.5372924804688,
        161.1999969482422
      ],
      [
        1240.0,
        916.4603881835938,
        160.0
      ],
      [
        1250.0,
        919.5372924804688,
        160.0
      ],
      [
        1240.0,
        1016.0,
        100.0
      ],
      [
        1180.0,
        1035.8577880859375,
        380.0
      ],
      [
        1190.0,
        1045.85791015625,
        130.0
      ],
      [
        1094.14208984375,
        950.0,
        380.0
      ],
      [
        1084.1422119140625,
        940.0,
        130.0
      ],
      [
        1187.0400390625,
        1016.0,
        204.0
      ],
      [
        1191.199951171875,
        1016.0,
        100.0
      ],
      [
        1190.0,
        930.0,
        130.0
      ],
      [
        1170.000244140625,
        930.0,
        130.0
      ],
      [
        1190.0,
        930.0,
        130.0
      ],
      [
        1191.199951171875,
        930.0,
        100.0
      ],
      [
        1168.800048828125,
        930.0,
        100.0
      ],
      [
        1074.1422119140625,
        930.0,
        130.0
      ],
      [
        1084.1422119140625,
        940.0,
        145.0
      ],
      [
        1074.1422119140625,
        930.0,
        130.0
      ],
      [
        1094.1422119140625,
        950.0,
        380.0
      ],
      [
        1101.1422119140625,
        957.0,
        580.0
      ],
      [
        1171.9998779296875,
        957.0,
        580.0
      ],
      [
        1200.0,
        959.9998168945312,
        130.0
      ],
      [
        1200.0,
        961.1998901367188,
        100.0
      ],
      [
        1194.0799560546875,
        1016.0,
        204.0
      ],
      [
        1202.4000244140625,
        1016.0,
        100.0
      ],
      [
        1200.0,
        1016.0,
        130.0
      ],
      [
        1200.0,
        1055.8577880859375,
        130.0
      ],
      [
        1200.0,
        1016.0,
        100.0
      ],
      [
        1200.0,
        1055.8577880859375,
        130.0
      ],
      [
        1200.0,
        1016.0,
        130.0
      ],
      [
        1190.0,
        1016.0,
        145.0
      ],
      [
        1190.0,
        1045.85791015625,
        145.0
      ],
      [
        1180.0,
        1035.8577880859375,
        380.0
      ],
      [
        1173.0,
        1028.85791015625,
        580.0
      ],
      [
        1235.0,
        914.9219360351562,
        120.0
      ],
      [
        1235.0,
        1090.8577880859375,
        120.0
      ],
      [
        1235.0,
        1090.8577880859375,
        118.0
      ],
      [
        1235.0,
        914.9219360351562,
        118.0
      ],
      [
        1235.0,
        914.9219360351562,
        118.0
      ],
      [
        1234.1422119140625,
        1090.0,
        118.0
      ],
      [
        1215.0,
        1070.8577880859375,
        118.0
      ],
      [
        1215.0,
        908.76806640625,
        118.0
      ],
      [
        1215.0,
        908.76806640625,
        120.0
      ],
      [
        1215.0,
        1070.8577880859375,
        120.0
      ],
      [
        1234.1422119140625,
        1090.0,
        120.0
      ],
      [
        1235.0,
        914.9219360351562,
        120.0
      ],
      [
        1215.0,
        1070.8577880859375,
        120.0
      ],
      [
        1215.0,
        908.76806640625,
        120.0
      ],
      [
        1215.0,
        908.76806640625,
        118.0
      ],
      [
        1215.0,
        1070.8577880859375,
        118.0
      ],
      [
        1235.0,
        1016.0,
        120.0
      ],
      [
        1235.0,
        1016.0,
        118.0
      ],
      [
        1215.0,
        1016.0,
        118.0
      ],
      [
        1215.0,
        1016.0,
        120.0
      ],
      [
        1200.9599609375,
        1016.0,
        118.0
      ],
      [
        1200.7999267578125,
        1016.0,
        120.0
      ],
      [
        1235.0,
        1016.0,
        204.0
      ],
      [
        1235.0,
        1016.0,
        100.0
      ],
      [
        1173.0,
        1028.85791015625,
        580.0
      ],
      [
        1173.0,
        1028.85791015625,
        750.0
      ],
      [
        1101.1422119140625,
        957.0,
        580.0
      ],
      [
        1101.1422119140625,
        957.0,
        750.0
      ],
      [
        1215.0,
        900.0,
        120.0
      ],
      [
        1235.0,
        900.0,
        120.0
      ],
      [
        1235.0,
        900.0,
        118.0
      ],
      [
        1215.0,
        900.0,
        118.0
      ],
      [
        1235.0,
        900.0,
        120.0
      ],
      [
        1235.0,
        900.0,
        118.0
      ],
      [
        1215.0,
        900.0,
        120.0
      ],
      [
        1215.0,
        900.0,
        118.0
      ],
      [
        1014.2000122070312,
        870.0578002929688,
        120.0
      ],
      [
        1013.0952758789062,
        868.953125,
        120.0
      ],
      [
        866.452880859375,
        722.3107299804688,
        120.0
      ],
      [
        865.3554077148438,
        721.2131958007812,
        120.0
      ],
      [
        1031.99462890625,
        887.8524780273438,
        120.0
      ],
      [
        1014.2000122070312,
        870.0578002929688,
        120.0
      ],
      [
        866.452880859375,
        722.3107299804688,
        120.0
      ],
      [
        1013.0952758789062,
        868.953125,
        120.0
      ],
      [
        1014.2000122070312,
        867.8925170898438,
        118.0
      ],
      [
        1014.179931640625,
        867.8724365234375,
        118.0
      ],
      [
        866.4380493164062,
        720.1305541992188,
        118.0
      ],
      [
        866.452880859375,
        720.1453857421875,
        118.0
      ],
      [
        1034.159912109375,
        887.8524780273438,
        118.0
      ],
      [
        1014.2000122070312,
        867.8925170898438,
        118.0
      ],
      [
        1014.179931640625,
        867.8724365234375,
        118.0
      ],
      [
        866.452880859375,
        720.1453857421875,
        118.0
      ],
      [
        1200.0,
        867.8525390625,
        118.0
      ],
      [
        1250.0,
        867.8525390625,
        118.0
      ],
      [
        1014.1600952148438,
        867.8525390625,
        118.0
      ],
      [
        1200.0,
        867.8525390625,
        118.0
      ],
      [
        1190.0,
        825.0,
        118.0
      ],
      [
        1190.0,
        707.730224609375,
        118.0
      ],
      [
        1215.0,
        825.0,
        120.0
      ],
      [
        1235.0,
        825.0,
        120.0
      ],
      [
        1235.0,
        825.0,
        118.0
      ],
      [
        1215.0,
        825.0,
        118.0
      ],
      [
        1190.0,
        825.0,
        118.0
      ],
      [
        1250.0,
        825.0,
        118.0
      ],
      [
        1113.0,
        887.8524780273438,
        118.0
      ],
      [
        1034.159912109375,
        887.8524780273438,
        118.0
      ],
      [
        1034.159912109375,
        887.8524780273438,
        120.0
      ],
      [
        1235.0,
        887.8524780273438,
        120.0
      ],
      [
        1235.0,
        887.8524780273438,
        118.0
      ],
      [
        1113.0,
        887.8524780273438,
        118.0
      ],
      [
        1113.0,
        900.0,
        118.0
      ],
      [
        1014.2000122070312,
        870.0578002929688,
        118.0
      ],
      [
        1013.0952758789062,
        868.953125,
        118.0
      ],
      [
        865.3554077148438,
        721.2131958007812,
        118.0
      ],
      [
        866.452880859375,
        722.3107299804688,
        118.0
      ],
      [
        1031.99462890625,
        887.8524780273438,
        118.0
      ],
      [
        1014.2000122070312,
        870.0578002929688,
        118.0
      ],
      [
        1013.0952758789062,
        868.953125,
        118.0
      ],
      [
        866.452880859375,
        722.3107299804688,
        118.0
      ],
      [
        1031.99462890625,
        887.8524780273438,
        118.0
      ],
      [
        1031.99462890625,
        887.8524780273438,
        120.0
      ],
      [
        1100.0,
        747.730224609375,
        170.0
      ],
      [
        1150.0,
        747.730224609375,
        170.0
      ],
      [
        1150.0,
        747.730224609375,
        170.0
      ],
      [
        1150.0,
        785.0,
        170.0
      ],
      [
        1100.0,
        785.0,
        170.0
      ],
      [
        1100.0,
        747.730224609375,
        170.0
      ],
      [
        1100.0,
        785.0,
        170.0
      ],
      [
        1150.0,
        785.0,
        170.0
      ],
      [
        1120.0,
        750.0,
        170.0
      ],
      [
        1130.0,
        750.0,
        170.0
      ],
      [
        1130.0,
        760.0,
        170.0
      ],
      [
        1130.0,
        750.0,
        170.0
      ],
      [
        1120.0,
        750.0,
        170.0
      ],
      [
        1120.0,
        760.0,
        170.0
      ],
      [
        1120.0,
        760.0,
        170.0
      ],
      [
        1130.0,
        760.0,
        170.0
      ],
      [
        1150.0,
        825.0,
        120.0
      ],
      [
        1150.0,
        825.0,
        135.0
      ],
      [
        1150.0,
        825.0,
        170.0
      ],
      [
        1150.0,
        825.0,
        145.0
      ],
      [
        1150.0,
        825.0,
        145.0
      ],
      [
        1150.0,
        825.0,
        135.0
      ],
      [
        1100.0,
        825.0,
        120.0
      ],
      [
        1100.0,
        825.0,
        135.0
      ],
      [
        1100.0,
        825.0,
        170.0
      ],
      [
        1100.0,
        825.0,
        145.0
      ],
      [
        1100.0,
        825.0,
        135.0
      ],
      [
        1100.0,
        825.0,
        145.0
      ],
      [
        1130.0,
        760.0,
        180.0
      ],
      [
        1120.0,
        760.0,
        180.0
      ],
      [
        1120.0,
        760.0,
        180.0
      ],
      [
        1130.0,
        760.0,
        180.0
      ],
      [
        1190.0,
        737.730224609375,
        195.0
      ],
      [
        1160.0,
        707.730224609375,
        195.0
      ],
      [
        1090.0,
        707.730224609375,
        195.0
      ],
      [
        1060.0,
        737.730224609375,
        195.0
      ],
      [
        1190.0,
        785.0,
        195.0
      ],
      [
        1190.0,
        780.0,
        195.0
      ],
      [
        1190.0,
        737.730224609375,
        195.0
      ],
      [
        1190.0,
        780.0,
        195.0
      ],
      [
        1060.0,
        785.0,
        195.0
      ],
      [
        1060.0,
        780.0,
        195.0
      ],
      [
        1060.0,
        780.0,
        195.0
      ],
      [
        1060.0,
        737.730224609375,
        195.0
      ],
      [
        1100.0,
        785.0,
        195.0
      ],
      [
        1100.0,
        825.0,
        195.0
      ],
      [
        1150.0,
        825.0,
        195.0
      ],
      [
        1150.0,
        785.0,
        195.0
      ],
      [
        1150.0,
        785.0,
        195.0
      ],
      [
        1190.0,
        785.0,
        195.0
      ],
      [
        1060.0,
        785.0,
        195.0
      ],
      [
        1100.0,
        785.0,
        195.0
      ],
      [
        1088.730224609375,
        709.0,
        190.0
      ],
      [
        1161.269775390625,
        709.0,
        190.0
      ],
      [
        1161.269775390625,
        709.0,
        190.0
      ],
      [
        1161.269775390625,
        709.0,
        195.0
      ],
      [
        1088.730224609375,
        709.0,
        190.0
      ],
      [
        1088.730224609375,
        709.0,
        195.0
      ],
      [
        1088.730224609375,
        709.0,
        183.5
      ],
      [
        1161.269775390625,
        709.0,
        183.5
      ],
      [
        1161.269775390625,
        709.0,
        183.5
      ],
      [
        1161.269775390625,
        709.0,
        180.0
      ],
      [
        1088.730224609375,
        709.0,
        183.5
      ],
      [
        1088.730224609375,
        709.0,
        180.0
      ],
      [
        1190.0,
        784.0,
        180.0
      ],
      [
        1190.0,
        784.0,
        195.0
      ],
      [
        1060.0,
        784.0,
        195.0
      ],
      [
        1060.0,
        784.0,
        180.0
      ],
      [
        1060.0,
        739.0001220703125,
        190.0
      ],
      [
        1060.0,
        739.0001220703125,
        183.5
      ],
      [
        1190.0,
        739.0001220703125,
        183.5
      ],
      [
        1190.0,
        739.0001220703125,
        190.0
      ],
      [
        1189.0,
        770.0,
        183.5
      ],
      [
        1189.0,
        749.0,
        183.5
      ],
      [
        1189.0,
        749.0,
        180.0
      ],
      [
        1189.0,
        749.0,
        190.0
      ],
      [
        1189.0,
        770.0,
        190.0
      ],
      [
        1189.0,
        749.0,
        195.0
      ],
      [
        1190.0,
        770.0,
        183.5
      ],
      [
        1190.0,
        749.0,
        183.5
      ],
      [
        1189.0,
        749.0,
        183.5
      ],
      [
        1189.0,
        770.0,
        183.5
      ],
      [
        1190.0,
        749.0,
        190.0
      ],
      [
        1190.0,
        770.0,
        190.0
      ],
      [
        1189.0,
        770.0,
        190.0
      ],
      [
        1189.0,
        749.0,
        190.0
      ],
      [
        950.0,
        950.0,
        140.0
      ],
      [
        950.0,
        930.0,
        140.0
      ],
      [
        950.0,
        920.0,
        140.0
      ],
      [
        950.0,
        900.0,
        140.0
      ],
      [
        958.2842407226562,
        900.0,
        140.0
      ],
      [
        950.0,
        920.0,
        80.0
      ],
      [
        1010.0,
        900.0,
        80.0
      ],
      [
        950.0,
        900.0,
        80.0
      ],
      [
        1010.0,
        900.0,
        80.0
      ],
      [
        1044.1422119140625,
        900.0,
        80.0
      ],
      [
        950.0,
        970.0,
        78.88888549804688
      ],
      [
        950.0,
        930.0,
        78.88888549804688
      ],
      [
        950.0,
        1120.0,
        76.36363220214844
      ],
      [
        950.0,
        1120.0,
        78.8888931274414
      ],
      [
        950.0,
        920.0,
        78.88888549804688
      ],
      [
        950.0,
        920.0,
        80.0
      ],
      [
        950.0,
        930.0,
        80.0
      ],
      [
        950.0,
        930.0,
        78.88888549804688
      ],
      [
        950.0,
        1120.0,
        80.0
      ],
      [
        1010.0,
        1120.0,
        120.0
      ],
      [
        1010.0,
        1120.0,
        118.0
      ],
      [
        1010.0,
        1120.0,
        118.0
      ],
      [
        1010.0,
        1130.0,
        118.0
      ],
      [
        1010.0,
        1130.0,
        120.0
      ],
      [
        1010.0,
        1120.0,
        120.0
      ],
      [
        1020.4000244140625,
        1109.5999755859375,
        140.0
      ],
      [
        1020.4000244140625,
        940.4000244140625,
        140.0
      ],
      [
        1020.0,
        930.0,
        130.0
      ],
      [
        1018.0,
        930.0,
        80.0
      ],
      [
        1020.4000244140625,
        940.4000244140625,
        140.0
      ],
      [
        1084.542236328125,
        940.4000244140625,
        140.0
      ],
      [
        1189.5999755859375,
        1109.5999755859375,
        140.0
      ],
      [
        1189.5999755859375,
        1045.4578857421875,
        140.0
      ],
      [
        1189.199951171875,
        1079.5999755859375,
        140.0
      ],
      [
        1189.5999755859375,
        1080.0,
        140.0
      ],
      [
        1050.0,
        940.4000244140625,
        140.0
      ],
      [
        1050.4000244140625,
        940.7999877929688,
        140.0
      ],
      [
        1020.7999877929688,
        970.4000244140625,
        140.0
      ],
      [
        1020.3999633789062,
        970.0,
        140.0
      ],
      [
        1020.3999633789062,
        1080.0,
        140.0
      ],
      [
        1020.7999877929688,
        1079.5999755859375,
        140.0
      ],
      [
        1193.3333740234375,
        1083.3333740234375,
        140.0
      ],
      [
        1193.3333740234375,
        1049.191162109375,
        140.0
      ],
      [
        1193.33349609375,
        1083.7335205078125,
        140.0
      ],
      [
        1199.199951171875,
        1089.5999755859375,
        140.0
      ],
      [
        1199.199951171875,
        1119.199951171875,
        140.0
      ],
      [
        1199.199951171875,
        1089.5999755859375,
        140.0
      ],
      [
        1080.808837890625,
        936.6666870117188,
        140.0
      ],
      [
        1046.6666259765625,
        936.6666870117188,
        140.0
      ],
      [
        1046.2667236328125,
        936.6666870117188,
        140.0
      ],
      [
        1019.9999389648438,
        930.0,
        130.0
      ],
      [
        1020.3999633789062,
        930.7999877929688,
        140.0
      ],
      [
        1040.4000244140625,
        930.7999877929688,
        140.0
      ],
      [
        1040.4000244140625,
        930.7999877929688,
        140.0
      ],
      [
        1016.6666870117188,
        1083.3333740234375,
        140.0
      ],
      [
        1016.6666870117188,
        966.6666870117188,
        140.0
      ],
      [
        1016.6666870117188,
        966.2667236328125,
        140.0
      ],
      [
        1016.6666870117188,
        930.7999877929688,
        140.0
      ],
      [
        1016.6666870117188,
        1083.7332763671875,
        140.0
      ],
      [
        1010.7999877929688,
        960.4000244140625,
        140.0
      ],
      [
        1010.7999877929688,
        930.7999877929688,
        140.0
      ],
      [
        1010.7999877929688,
        1119.199951171875,
        140.0
      ],
      [
        1010.7999877929688,
        1089.5999755859375,
        140.0
      ],
      [
        1010.7999877929688,
        960.4000244140625,
        140.0
      ],
      [
        1010.7999877929688,
        930.7999877929688,
        140.0
      ],
      [
        1010.7999877929688,
        1089.5999755859375,
        140.0
      ],
      [
        1000.0,
        900.0,
        120.0
      ],
      [
        1000.0,
        900.0,
        118.0
      ],
      [
        980.0,
        900.0,
        120.0
      ],
      [
        1000.0,
        900.0,
        120.0
      ],
      [
        1000.0,
        1130.0,
        120.0
      ],
      [
        950.0,
        920.0,
        120.0
      ],
      [
        958.2843017578125,
        900.0,
        120.0
      ],
      [
        950.0,
        900.0,
        120.0
      ],
      [
        1000.0,
        900.0,
        118.0
      ],
      [
        980.0,
        900.0,
        118.0
      ],
      [
        1000.0,
        1130.0,
        118.0
      ],
      [
        958.2843017578125,
        900.0,
        118.0
      ],
      [
        950.0,
        920.0,
        118.0
      ],
      [
        950.0,
        900.0,
        118.0
      ],
      [
        980.0,
        900.0,
        120.0
      ],
      [
        980.0,
        900.0,
        118.0
      ],
      [
        958.2843017578125,
        900.0,
        120.0
      ],
      [
        958.2843017578125,
        900.0,
        118.0
      ],
      [
        950.0,
        1120.0,
        118.0
      ],
      [
        950.0,
        1120.0,
        120.0
      ],
      [
        971.7703247070312,
        1120.0,
        120.0
      ],
      [
        970.59326171875,
        1120.0,
        118.0
      ],
      [
        970.59326171875,
        1120.0,
        118.0
      ],
      [
        971.7703247070312,
        1120.0,
        120.0
      ],
      [
        975.3369750976562,
        1130.0,
        120.0
      ],
      [
        974.159912109375,
        1130.0,
        118.0
      ],
      [
        976.0,
        990.0,
        118.0
      ],
      [
        976.0,
        970.0,
        118.0
      ],
      [
        976.0,
        970.0,
        118.0
      ],
      [
        960.0,
        930.0,
        118.0
      ],
      [
        950.0,
        920.0,
        118.0
      ],
      [
        950.0,
        920.0,
        120.0
      ],
      [
        960.0,
        930.0,
        118.0
      ],
      [
        950.0,
        930.0,
        120.0
      ],
      [
        950.0,
        930.0,
        118.0
      ],
      [
        960.0,
        1120.0,
        98.0
      ],
      [
        964.0,
        1130.0,
        98.0
      ],
      [
        960.0,
        1120.0,
        98.0
      ],
      [
        950.0,
        1120.0,
        98.0
      ],
      [
        950.0,
        1120.0,
        100.0
      ],
      [
        950.0,
        920.0,
        98.88888549804688
      ],
      [
        960.0,
        930.0,
        98.0
      ],
      [
        950.0,
        920.0,
        98.0
      ],
      [
        950.0,
        920.0,
        98.88888549804688
      ],
      [
        950.0,
        920.0,
        100.0
      ],
      [
        950.0,
        1096.0,
        100.0
      ],
      [
        960.0,
        1096.0,
        100.0
      ],
      [
        960.0,
        1096.0,
        100.0
      ],
      [
        950.0,
        930.0,
        98.88888549804688
      ],
      [
        950.0,
        930.0,
        98.0
      ],
      [
        960.0,
        930.0,
        98.0
      ],
      [
        950.0,
        930.0,
        98.88888549804688
      ],
      [
        950.0,
        930.0,
        100.0
      ],
      [
        950.0,
        1120.0,
        100.0
      ],
      [
        956.0,
        1080.0,
        108.0
      ],
      [
        956.0,
        1070.0,
        108.0
      ],
      [
        956.0,
        990.0,
        108.0
      ],
      [
        956.0,
        970.0,
        108.0
      ],
      [
        960.0,
        1084.0,
        108.00000762939453
      ],
      [
        956.0,
        1070.0,
        108.0
      ],
      [
        950.0,
        1090.0,
        103.00000762939453
      ],
      [
        950.0,
        1086.0,
        105.0
      ],
      [
        956.0,
        1080.0,
        108.0
      ],
      [
        960.0,
        930.0,
        108.0
      ],
      [
        950.0,
        920.0,
        103.00000762939453
      ],
      [
        960.0,
        930.0,
        108.0
      ],
      [
        950.0,
        930.0,
        103.00000762939453
      ],
      [
        950.0,
        1120.0,
        140.0
      ],
      [
        950.0,
        920.0,
        140.0
      ],
      [
        950.0,
        930.0,
        140.0
      ],
      [
        1020.4000244140625,
        950.0,
        140.0
      ],
      [
        1020.3999633789062,
        970.0,
        140.0
      ],
      [
        1189.5999755859375,
        1080.0,
        140.0
      ],
      [
        1055.0,
        950.0,
        255.0000762939453
      ],
      [
        1050.0,
        950.0,
        380.0
      ],
      [
        1038.0,
        957.0,
        580.0
      ],
      [
        1049.0,
        957.0,
        580.0
      ],
      [
        1020.3999633789062,
        1080.0,
        140.0
      ],
      [
        1010.7999877929688,
        950.0,
        140.0
      ],
      [
        950.0,
        1120.0,
        140.0
      ],
      [
        950.0,
        1120.0,
        280.0
      ],
      [
        1010.7999877929688,
        940.4000244140625,
        140.0
      ],
      [
        1050.0,
        940.4000244140625,
        140.0
      ],
      [
        998.6842041015625,
        940.3999633789062,
        140.0
      ],
      [
        1001.8842163085938,
        943.5999755859375,
        220.0
      ],
      [
        1001.8842163085938,
        943.5999755859375,
        220.0
      ],
      [
        995.8233032226562,
        944.6067504882812,
        245.16859436035156
      ],
      [
        989.084228515625,
        930.7999877929688,
        140.0
      ],
      [
        995.4842529296875,
        937.2000122070312,
        220.0
      ],
      [
        995.4842529296875,
        937.2000122070312,
        220.0
      ],
      [
        986.7498168945312,
        940.6796264648438,
        263.4952392578125
      ],
      [
        958.2842407226562,
        900.0,
        220.0
      ],
      [
        950.0,
        900.0,
        249.50100708007812
      ],
      [
        950.0,
        924.7737426757812,
        337.72265625
      ],
      [
        958.2842407226562,
        900.0,
        140.0
      ],
      [
        958.2842407226562,
        900.0,
        220.0
      ],
      [
        760.0,
        900.0,
        140.0
      ],
      [
        780.0,
        900.0,
        140.0
      ],
      [
        930.0,
        900.0,
        140.0
      ],
      [
        900.0,
        1120.0,
        110.0
      ],
      [
        950.0,
        1120.0,
        110.0
      ],
      [
        950.0,
        930.0,
        110.0
      ],
      [
        780.0,
        930.0,
        110.0
      ],
      [
        930.0,
        900.0,
        96.66666412353516
      ],
      [
        930.0,
        900.0,
        76.66666412353516
      ],
      [
        950.0,
        920.0,
        110.0
      ],
      [
        930.0,
        900.0,
        96.66666412353516
      ],
      [
        930.0,
        900.0,
        110.0
      ],
      [
        930.0,
        900.0,
        80.0
      ],
      [
        930.0,
        900.0,
        140.0
      ],
      [
        930.0,
        900.0,
        120.0
      ],
      [
        930.0,
        900.0,
        118.0
      ],
      [
        822.5736083984375,
        1006.109130859375,
        140.0
      ],
      [
        865.0,
        990.0,
        140.0
      ],
      [
        865.0,
        990.0,
        140.0
      ],
      [
        907.4263916015625,
        1006.109130859375,
        140.0
      ],
      [
        925.0,
        1045.0,
        140.0
      ],
      [
        907.4263916015625,
        1083.890869140625,
        140.0
      ],
      [
        907.4263916015625,
        1006.109130859375,
        140.0
      ],
      [
        925.0,
        1045.0,
        140.0
      ],
      [
        780.0,
        950.0,
        120.0
      ],
      [
        780.0,
        950.0,
        118.0
      ],
      [
        824.0,
        950.0,
        118.0
      ],
      [
        824.0,
        930.0,
        118.0
      ],
      [
        760.0,
        900.0,
        120.0
      ],
      [
        780.0,
        900.0,
        120.0
      ],
      [
        780.0,
        900.0,
        118.0
      ],
      [
        760.0,
        900.0,
        118.0
      ],
      [
        885.0,
        1120.0,
        170.0
      ],
      [
        913.0569458007812,
        1120.0,
        280.0
      ],
      [
        913.0569458007812,
        1120.0,
        170.0
      ],
      [
        950.0,
        1120.0,
        170.0
      ],
      [
        892.7614135742188,
        900.0,
        453.3333435058594
      ],
      [
        760.0,
        615.8577880859375,
        98.0
      ],
      [
        760.0,
        644.163818359375,
        98.0
      ],
      [
        760.0,
        644.1637573242188,
        100.0
      ],
      [
        760.0,
        615.8578491210938,
        100.0
      ],
      [
        760.0,
        644.163818359375,
        100.0
      ],
      [
        760.0,
        644.1637573242188,
        98.0
      ],
      [
        760.0,
        630.0,
        60.0
      ],
      [
        760.0,
        615.8578491210938,
        80.0
      ],
      [
        770.0,
        680.0,
        80.0
      ],
      [
        766.0986328125,
        680.0,
        80.0
      ],
      [
        760.0,
        680.0,
        80.0
      ],
      [
        766.0986328125,
        680.0,
        80.0
      ],
      [
        770.0,
        680.0,
        78.0
      ],
      [
        766.0986328125,
        680.0,
        78.0
      ],
      [
        766.0986328125,
        680.0,
        78.0
      ],
      [
        760.0,
        680.0,
        78.0
      ],
      [
        770.0,
        680.0,
        80.0
      ],
      [
        770.0,
        680.0,
        78.0
      ],
      [
        1028.1990966796875,
        900.0,
        80.0
      ],
      [
        1014.2000122070312,
        884.2000122070312,
        118.0
      ],
      [
        1006.0111083984375,
        876.0111083984375,
        118.0
      ],
      [
        858.2843017578125,
        728.2843017578125,
        118.0
      ],
      [
        866.452880859375,
        736.452880859375,
        118.0
      ],
      [
        1017.8524780273438,
        887.8524780273438,
        118.0
      ],
      [
        1014.2000122070312,
        884.2000122070312,
        118.0
      ],
      [
        1006.0111083984375,
        876.0111083984375,
        118.0
      ],
      [
        866.452880859375,
        736.452880859375,
        118.0
      ],
      [
        1014.2000122070312,
        884.2000122070312,
        120.0
      ],
      [
        1006.0111083984375,
        876.0111083984375,
        120.0
      ],
      [
        866.452880859375,
        736.452880859375,
        120.0
      ],
      [
        858.2843017578125,
        728.2843017578125,
        120.0
      ],
      [
        1017.8524780273438,
        887.8524780273438,
        120.0
      ],
      [
        1014.2000122070312,
        884.2000122070312,
        120.0
      ],
      [
        866.452880859375,
        736.452880859375,
        120.0
      ],
      [
        1006.0111083984375,
        876.0111083984375,
        120.0
      ],
      [
        1017.8524780273438,
        887.8524780273438,
        118.0
      ],
      [
        1017.8524780273438,
        887.8524780273438,
        120.0
      ],
      [
        1000.0,
        882.0472412109375,
        120.0
      ],
      [
        1000.0,
        882.0472412109375,
        118.0
      ],
      [
        850.7107543945312,
        764.1421508789062,
        120.0
      ],
      [
        850.7107543945312,
        764.1421508789062,
        118.0
      ],
      [
        980.0,
        893.431396484375,
        120.0
      ],
      [
        980.0,
        893.431396484375,
        118.0
      ],
      [
        770.0,
        682.0499267578125,
        80.0
      ],
      [
        764.0150146484375,
        682.0499267578125,
        80.0
      ],
      [
        760.0,
        682.0499267578125,
        80.0
      ],
      [
        764.0150146484375,
        682.0499267578125,
        80.0
      ],
      [
        620.0,
        980.0,
        160.0
      ],
      [
        620.0,
        980.0,
        190.0
      ],
      [
        620.0,
        980.0,
        80.0
      ],
      [
        620.0,
        980.0,
        120.0
      ],
      [
        730.0,
        980.0,
        60.0
      ],
      [
        700.0,
        980.0,
        120.0
      ],
      [
        620.0,
        980.0,
        120.0
      ],
      [
        620.0,
        1000.0,
        120.0
      ],
      [
        620.0,
        1000.0,
        160.0
      ],
      [
        680.0,
        1000.0,
        160.0
      ],
      [
        620.0,
        1000.0,
        120.0
      ],
      [
        680.0,
        1000.0,
        160.0
      ],
      [
        620.0,
        1000.0,
        160.0
      ],
      [
        620.0,
        980.0,
        160.0
      ],
      [
        680.0,
        980.0,
        160.0
      ],
      [
        620.0,
        940.0,
        78.0
      ],
      [
        620.0,
        940.0,
        80.0
      ],
      [
        620.0,
        970.0,
        60.0
      ],
      [
        620.0,
        980.0,
        80.0
      ],
      [
        720.0,
        979.0,
        78.0
      ],
      [
        760.0,
        940.0,
        80.0
      ],
      [
        620.0,
        940.0,
        80.0
      ],
      [
        620.0,
        980.0,
        80.0
      ],
      [
        760.0,
        940.0,
        78.0
      ],
      [
        620.0,
        540.0,
        80.0
      ],
      [
        620.0,
        560.0,
        80.0
      ],
      [
        620.0,
        604.1421508789062,
        80.0
      ],
      [
        670.0,
        540.0,
        60.0
      ],
      [
        684.1421508789062,
        540.0,
        80.0
      ],
      [
        744.8577270507812,
        681.0,
        78.0
      ],
      [
        740.0194091796875,
        676.1616821289062,
        78.0
      ],
      [
        740.0194091796875,
        676.1616821289062,
        78.0
      ],
      [
        740.0097045898438,
        676.1519775390625,
        78.0
      ],
      [
        639.9603271484375,
        540.0,
        78.0
      ],
      [
        744.8577270507812,
        681.0,
        78.0
      ],
      [
        760.0,
        696.142333984375,
        78.0
      ],
      [
        620.0,
        556.14208984375,
        78.0
      ],
      [
        620.0,
        540.0,
        78.0
      ],
      [
        740.0097045898438,
        676.1519775390625,
        78.0
      ],
      [
        687.3342895507812,
        595.192138671875,
        80.0
      ],
      [
        694.4053344726562,
        588.12109375,
        80.0
      ],
      [
        639.9603271484375,
        540.0,
        80.0
      ],
      [
        639.9603271484375,
        540.0,
        78.0
      ],
      [
        620.0,
        520.0,
        60.0
      ],
      [
        630.0,
        487.2720031738281,
        78.0
      ],
      [
        650.0,
        507.2720031738281,
        78.0
      ],
      [
        650.0,
        507.27203369140625,
        78.0
      ],
      [
        620.0,
        560.0,
        78.0
      ],
      [
        620.0,
        560.0,
        80.0
      ],
      [
        620.0,
        560.0,
        78.0
      ],
      [
        740.0,
        676.1422729492188,
        78.0
      ],
      [
        620.0,
        590.0,
        60.0
      ],
      [
        620.0,
        604.1421508789062,
        80.0
      ],
      [
        620.0,
        930.0,
        60.0
      ],
      [
        620.0,
        920.0,
        80.0
      ],
      [
        721.0000610351562,
        704.1422119140625,
        78.0
      ],
      [
        721.0000610351562,
        750.0,
        78.0
      ],
      [
        721.0000610351562,
        704.1422119140625,
        78.0
      ],
      [
        721.0000610351562,
        657.1543579101562,
        78.0
      ],
      [
        721.0000610351562,
        657.1422729492188,
        78.0
      ],
      [
        721.0000610351562,
        657.1543579101562,
        78.0
      ],
      [
        720.0,
        656.1539306640625,
        80.0
      ],
      [
        620.0,
        750.0,
        100.0
      ],
      [
        620.0,
        750.0,
        140.0
      ],
      [
        620.0,
        750.0,
        140.0
      ],
      [
        620.0,
        750.0,
        240.0
      ],
      [
        620.0,
        920.0,
        240.0
      ],
      [
        620.0,
        920.0,
        160.0
      ],
      [
        620.0,
        920.0,
        140.0
      ],
      [
        620.0,
        920.0,
        160.0
      ],
      [
        620.0,
        920.0,
        80.0
      ],
      [
        620.0,
        920.0,
        140.0
      ],
      [
        670.7326049804688,
        555.0899658203125,
        100.0
      ],
      [
        670.7326049804688,
        555.0900268554688,
        98.0
      ],
      [
        666.0545654296875,
        559.7703247070312,
        100.0
      ],
      [
        666.0545654296875,
        559.7703857421875,
        98.0
      ],
      [
        677.8142700195312,
        562.1563720703125,
        100.0
      ],
      [
        677.8394165039062,
        562.1814575195312,
        99.9787368774414
      ],
      [
        360.0,
        980.0,
        100.0
      ],
      [
        360.0,
        980.0,
        80.0
      ],
      [
        360.0,
        980.0,
        190.0
      ],
      [
        360.0,
        980.0,
        120.0
      ],
      [
        360.0,
        980.0,
        190.0
      ],
      [
        360.0,
        980.0,
        340.0
      ],
      [
        490.0,
        1000.0,
        190.0
      ],
      [
        490.0,
        1000.0,
        290.0
      ],
      [
        490.0,
        1000.0,
        290.0
      ],
      [
        440.0,
        1000.0,
        340.0
      ],
      [
        360.0,
        980.0,
        80.0
      ],
      [
        360.0,
        970.0,
        60.0
      ],
      [
        360.0,
        980.0,
        80.0
      ],
      [
        360.0,
        980.0,
        120.0
      ],
      [
        360.0,
        960.0,
        105.0
      ],
      [
        360.0,
        980.0,
        100.0
      ],
      [
        360.0,
        960.0,
        100.0
      ],
      [
        360.0,
        960.0,
        100.0
      ],
      [
        360.0,
        960.0,
        105.0
      ],
      [
        360.0,
        540.0,
        80.0
      ],
      [
        360.0,
        560.0,
        80.0
      ],
      [
        360.0,
        560.0,
        78.0
      ],
      [
        360.0,
        560.0,
        80.0
      ],
      [
        360.0,
        520.0,
        60.0
      ],
      [
        456.27862548828125,
        481.1797790527344,
        78.0
      ],
      [
        498.0239562988281,
        511.0,
        78.0
      ],
      [
        480.0,
        511.0,
        78.0
      ],
      [
        480.0,
        497.90484619140625,
        78.0
      ],
      [
        456.9799499511719,
        481.1797790527344,
        78.0
      ],
      [
        500.0,
        511.0,
        78.0
      ],
      [
        500.0,
        511.0,
        78.0
      ],
      [
        500.0,
        510.0,
        80.0
      ],
      [
        360.0,
        930.0,
        60.0
      ],
      [
        489.8018798828125,
        930.0,
        60.0
      ],
      [
        499.802001953125,
        920.0,
        80.0
      ],
      [
        546.4309692382812,
        743.2847290039062,
        80.0
      ],
      [
        556.4309692382812,
        753.2847290039062,
        80.0
      ],
      [
        546.4309692382812,
        743.2847290039062,
        80.0
      ],
      [
        410.03387451171875,
        750.0,
        360.0
      ],
      [
        410.03387451171875,
        750.0,
        460.0
      ],
      [
        549.9862060546875,
        799.9862060546875,
        240.0
      ],
      [
        549.9862060546875,
        799.9862060546875,
        260.0
      ],
      [
        559.7156982421875,
        750.0,
        81.70327758789062
      ],
      [
        553.146240234375,
        750.0,
        80.0
      ],
      [
        379.9999694824219,
        510.0,
        220.0
      ],
      [
        379.9999694824219,
        510.0,
        80.0
      ],
      [
        550.0,
        680.0,
        100.0
      ],
      [
        550.0,
        680.0,
        140.0
      ],
      [
        550.0,
        680.0,
        140.0
      ],
      [
        550.0,
        680.0,
        240.0
      ],
      [
        550.0,
        746.853759765625,
        80.0
      ],
      [
        550.0,
        739.7156982421875,
        81.85070037841797
      ],
      [
        550.0,
        739.7156982421875,
        81.85070037841797
      ],
      [
        550.0,
        739.7156982421875,
        80.0
      ],
      [
        560.8578491210938,
        719.1421508789062,
        90.00000762939453
      ],
      [
        570.5001831054688,
        709.4998168945312,
        95.0
      ],
      [
        560.8578491210938,
        719.1421508789062,
        90.0
      ],
      [
        524.7213745117188,
        500.0,
        215.0
      ],
      [
        455.27862548828125,
        500.0,
        215.0
      ],
      [
        615.0,
        469.052978515625,
        155.7938995361328
      ],
      [
        605.0,
        464.5886535644531,
        152.93675231933594
      ],
      [
        605.0,
        464.58868408203125,
        152.93675231933594
      ],
      [
        605.0,
        480.2136535644531,
        152.93673706054688
      ],
      [
        559.7213745117188,
        500.0,
        145.0
      ],
      [
        559.7213745117188,
        500.0,
        140.0
      ],
      [
        615.7213745117188,
        495.0,
        156.0
      ],
      [
        615.7213745117188,
        485.0,
        156.0
      ],
      [
        615.7213745117188,
        485.0,
        156.0
      ],
      [
        620.0,
        485.0,
        157.2224578857422
      ],
      [
        559.7213745117188,
        500.0,
        130.0
      ],
      [
        458.4035949707031,
        486.5,
        90.0
      ],
      [
        455.2785949707031,
        486.5,
        87.5
      ],
      [
        610.132080078125,
        930.0,
        60.0
      ],
      [
        600.1320190429688,
        920.0,
        80.0
      ],
      [
        330.0,
        970.0,
        60.0
      ],
      [
        330.0,
        980.0,
        80.0
      ],
      [
        116.02175903320312,
        980.0,
        130.0
      ],
      [
        116.02175903320312,
        980.0,
        155.0
      ],
      [
        116.02175903320312,
        980.0,
        155.0
      ],
      [
        116.02175903320312,
        980.0,
        175.0
      ],
      [
        256.0217590332031,
        980.0,
        120.0
      ],
      [
        256.0217590332031,
        980.0,
        140.0
      ]
    ]
  },
  "sectors": [
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": 300.0,
      "bbox_min": [
        -6971.595703125,
        -5072.0185546875,
        -300.0
      ],
      "bbox_max": [
        7986.5068359375,
        7450.0,
        2163.576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9429216384887695,
        0.10439633578062057,
        0.3162280023097992
      ],
      "plane_d": 3636.306884765625,
      "bbox_min": [
        -4100.0,
        -2269.10009765625,
        -300.0
      ],
      "bbox_max": [
        -3509.2900390625,
        2200.0,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7483099102973938,
        -0.5793927907943726,
        0.3230113983154297
      ],
      "plane_d": -109.43359375,
      "bbox_min": [
        -4116.7685546875,
        -4714.78125,
        150.83631896972656
      ],
      "bbox_max": [
        -3000.0,
        -2365.345947265625,
        1420.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7659041285514832,
        0.6426700949668884,
        0.019128073006868362
      ],
      "plane_d": 4341.03076171875,
      "bbox_min": [
        -4116.7685546875,
        -3619.13720703125,
        150.83631896972656
      ],
      "bbox_max": [
        -3000.0,
        -2365.345947265625,
        1420.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8395622968673706,
        0.49151238799095154,
        0.231409952044487
      ],
      "plane_d": 4493.8125,
      "bbox_min": [
        -4116.7685546875,
        -3619.13720703125,
        630.2245483398438
      ],
      "bbox_max": [
        -3000.0,
        -2426.19775390625,
        1420.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8469141721725464,
        0.5269691348075867,
        0.07099299877882004
      ],
      "plane_d": 4842.2216796875,
      "bbox_min": [
        -4110.7685546875,
        -3559.13720703125,
        1220.0
      ],
      "bbox_max": [
        -3605.179443359375,
        -2760.515625,
        1371.9029541015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7499687671661377,
        0.6611047983169556,
        -0.022072862833738327
      ],
      "plane_d": 4375.75,
      "bbox_min": [
        -3661.619384765625,
        -3619.13720703125,
        630.2245483398438
      ],
      "bbox_max": [
        -3000.0,
        -2426.19775390625,
        1420.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.31618040800094604,
        0.5486864447593689,
        0.7739335298538208
      ],
      "plane_d": -131.23565673828125,
      "bbox_min": [
        -3625.179443359375,
        -3619.13720703125,
        667.6585693359375
      ],
      "bbox_max": [
        -3000.0,
        -3212.1396484375,
        1420.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.965404748916626,
        -0.2439502775669098,
        0.09209758043289185
      ],
      "plane_d": 2003.16259765625,
      "bbox_min": [
        -3260.67529296875,
        -3618.21142578125,
        667.6585693359375
      ],
      "bbox_max": [
        -3000.0,
        -3212.1396484375,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8451709151268005,
        -0.3576369881629944,
        0.3972178101539612
      ],
      "plane_d": 904.6746826171875,
      "bbox_min": [
        -3260.67529296875,
        -3618.21142578125,
        1052.5999755859375
      ],
      "bbox_max": [
        -3003.01416015625,
        -3212.1396484375,
        1402.623779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16772790253162384,
        0.9131852984428406,
        0.3714297413825989
      ],
      "plane_d": 2361.634521484375,
      "bbox_min": [
        -3080.0,
        -3580.0,
        667.6585693359375
      ],
      "bbox_max": [
        -3000.0,
        -3408.73486328125,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.011314941570162773,
        0.9574529528617859,
        0.2883673906326294
      ],
      "plane_d": 3096.69091796875,
      "bbox_min": [
        -3625.179443359375,
        -3619.13720703125,
        1220.0
      ],
      "bbox_max": [
        -3260.67529296875,
        -3559.13720703125,
        1420.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8705313205718994,
        0.4785127639770508,
        0.11489474773406982
      ],
      "plane_d": 4224.23291015625,
      "bbox_min": [
        -3661.619384765625,
        -2969.13720703125,
        630.2245483398438
      ],
      "bbox_max": [
        -3195.179443359375,
        -2426.19775390625,
        1091.7215576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7204000949859619,
        0.6658127307891846,
        0.19420866668224335
      ],
      "plane_d": 4133.04052734375,
      "bbox_min": [
        -3505.179443359375,
        -2969.13720703125,
        642.3209228515625
      ],
      "bbox_max": [
        -3195.179443359375,
        -2619.13720703125,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6317505836486816,
        0.763104259967804,
        0.13624615967273712
      ],
      "plane_d": 4182.1328125,
      "bbox_min": [
        -3658.444091796875,
        -3214.59765625,
        150.83631896972656
      ],
      "bbox_max": [
        -3000.0,
        -2365.345947265625,
        1220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.965404748916626,
        -0.2439502775669098,
        0.09209758043289185
      ],
      "plane_d": 2003.16259765625,
      "bbox_min": [
        -3003.01416015625,
        -3214.59765625,
        1181.8935546875
      ],
      "bbox_max": [
        -3000.0,
        -3210.00390625,
        1220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8705313205718994,
        0.4785127639770508,
        0.11489474773406982
      ],
      "plane_d": 4224.23291015625,
      "bbox_min": [
        -3658.444091796875,
        -3052.4541015625,
        150.83631896972656
      ],
      "bbox_max": [
        -3000.0,
        -2365.345947265625,
        1057.6986083984375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7204000949859619,
        0.6658127307891846,
        0.19420866668224335
      ],
      "plane_d": 4133.04052734375,
      "bbox_min": [
        -3452.1201171875,
        -3052.4541015625,
        150.83631896972656
      ],
      "bbox_max": [
        -3000.0,
        -2659.722412109375,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3703444004058838,
        0.8832541108131409,
        0.2875887453556061
      ],
      "plane_d": 4875.603515625,
      "bbox_min": [
        -3833.671875,
        -4714.78125,
        960.6837768554688
      ],
      "bbox_max": [
        -3000.0,
        -3527.920166015625,
        1390.1221923828125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16772790253162384,
        0.9131852984428406,
        0.3714297413825989
      ],
      "plane_d": 2361.634521484375,
      "bbox_min": [
        -3080.0,
        -3580.0,
        960.6837768554688
      ],
      "bbox_max": [
        -3000.0,
        -3527.920166015625,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34176069498062134,
        0.1286875456571579,
        0.930934488773346
      ],
      "plane_d": 470.6300048828125,
      "bbox_min": [
        -6971.595703125,
        -2771.56982421875,
        0.0
      ],
      "bbox_max": [
        -3577.691162109375,
        2921.382080078125,
        1650.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9600966572761536,
        0.2609225809574127,
        0.10066688805818558
      ],
      "plane_d": 4053.39990234375,
      "bbox_min": [
        -4912.15185546875,
        -2769.29443359375,
        0.0
      ],
      "bbox_max": [
        -3577.691162109375,
        2200.0,
        1400.274658203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8469141721725464,
        0.5269691348075867,
        0.07099299877882004
      ],
      "plane_d": 4842.2216796875,
      "bbox_min": [
        -4205.1796875,
        -2769.29443359375,
        1220.0
      ],
      "bbox_max": [
        -4102.099609375,
        -2619.13720703125,
        1400.274658203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8395622968673706,
        0.49151238799095154,
        0.231409952044487
      ],
      "plane_d": 4493.8125,
      "bbox_min": [
        -4205.1796875,
        -2769.29443359375,
        1371.9029541015625
      ],
      "bbox_max": [
        -4110.7685546875,
        -2619.13720703125,
        1400.274658203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9880585670471191,
        0.11992283910512924,
        0.09674030542373657
      ],
      "plane_d": 3834.25,
      "bbox_min": [
        -3714.01416015625,
        -2363.246337890625,
        2.0755615234375
      ],
      "bbox_max": [
        -3605.362548828125,
        -2269.30224609375,
        1182.983154296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7714905142784119,
        0.08541621267795563,
        0.6304812431335449
      ],
      "plane_d": 2975.195556640625,
      "bbox_min": [
        -4912.15185546875,
        -2428.59033203125,
        0.0
      ],
      "bbox_max": [
        -3577.691162109375,
        2200.0,
        1181.5667724609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9880585670471191,
        0.11992283910512924,
        0.09674030542373657
      ],
      "plane_d": 3834.25,
      "bbox_min": [
        -3714.02197265625,
        -2428.59033203125,
        0.0
      ],
      "bbox_max": [
        -3577.691162109375,
        -2269.13720703125,
        1181.5667724609375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7659041285514832,
        0.6426700949668884,
        0.019128073006868362
      ],
      "plane_d": 4341.03076171875,
      "bbox_min": [
        -3662.39306640625,
        -2427.53564453125,
        1172.1954345703125
      ],
      "bbox_max": [
        -3660.1962890625,
        -2424.958984375,
        1174.1900634765625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9600966572761536,
        0.2609225809574127,
        0.10066688805818558
      ],
      "plane_d": 4053.39990234375,
      "bbox_min": [
        -4912.15185546875,
        -2771.56982421875,
        1000.0
      ],
      "bbox_max": [
        -3660.219970703125,
        2154.178466796875,
        1403.2762451171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9880585670471191,
        0.11992283910512924,
        0.09674030542373657
      ],
      "plane_d": 3834.25,
      "bbox_min": [
        -3725.151611328125,
        -2362.283203125,
        1179.1334228515625
      ],
      "bbox_max": [
        -3709.690185546875,
        -2323.6279296875,
        1299.78955078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9880585670471191,
        0.11992283910512924,
        0.09674030542373657
      ],
      "plane_d": 3834.25,
      "bbox_min": [
        -3725.158447265625,
        -2384.52392578125,
        1181.5667724609375
      ],
      "bbox_max": [
        -3697.73974609375,
        -2329.19677734375,
        1299.8638916015625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8705313205718994,
        0.4785127639770508,
        0.11489474773406982
      ],
      "plane_d": 4224.23291015625,
      "bbox_min": [
        -3712.849365234375,
        -2384.52392578125,
        1181.5667724609375
      ],
      "bbox_max": [
        -3697.73974609375,
        -2363.246337890625,
        1220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7659041285514832,
        0.6426700949668884,
        0.019128073006868362
      ],
      "plane_d": 4341.03076171875,
      "bbox_min": [
        -3712.849365234375,
        -2378.302978515625,
        1210.5587158203125
      ],
      "bbox_max": [
        -3702.450439453125,
        -2366.191162109375,
        1220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9880585670471191,
        0.11992283910512924,
        0.09674030542373657
      ],
      "plane_d": 3834.25,
      "bbox_min": [
        -3725.1884765625,
        -2428.069091796875,
        1173.7484130859375
      ],
      "bbox_max": [
        -3660.219970703125,
        -2323.558349609375,
        1300.001953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5384978652000427,
        -0.7894291281700134,
        0.29465529322624207
      ],
      "plane_d": -215.739501953125,
      "bbox_min": [
        -3725.1884765625,
        -2329.1435546875,
        1299.9984130859375
      ],
      "bbox_max": [
        -3725.179443359375,
        -2329.13720703125,
        1300.001953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7659041285514832,
        0.6426700949668884,
        0.019128073006868362
      ],
      "plane_d": 4341.03076171875,
      "bbox_min": [
        -3703.801513671875,
        -2428.069091796875,
        1173.7484130859375
      ],
      "bbox_max": [
        -3660.219970703125,
        -2376.973876953125,
        1220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8705313205718994,
        0.4785127639770508,
        0.11489474773406982
      ],
      "plane_d": 4224.23291015625,
      "bbox_min": [
        -3697.79833984375,
        -2384.901123046875,
        1181.5367431640625
      ],
      "bbox_max": [
        -3697.488525390625,
        -2384.451171875,
        1182.312255859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -3000.0,
      "bbox_min": [
        -5072.0185546875,
        0.0,
        400.0
      ],
      "bbox_max": [
        -1550.0,
        1852.5999755859375,
        0.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3703444004058838,
        0.8832541108131409,
        0.2875887453556061
      ],
      "plane_d": 4875.603515625,
      "bbox_min": [
        -2881.897705078125,
        -5072.0185546875,
        1052.5999755859375
      ],
      "bbox_max": [
        -1550.0,
        -3350.0,
        1652.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5160083770751953,
        0.7518967390060425,
        0.41034960746765137
      ],
      "plane_d": 1040.8973388671875,
      "bbox_min": [
        -2100.0,
        -3623.86962890625,
        1052.5999755859375
      ],
      "bbox_max": [
        -1550.0,
        -3350.0,
        1652.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3156070411205292,
        0.8320549726486206,
        0.45615431666374207
      ],
      "plane_d": 1686.0640869140625,
      "bbox_min": [
        -2860.521728515625,
        -3539.687744140625,
        0.0
      ],
      "bbox_max": [
        -1701.24462890625,
        -2671.68505859375,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16772790253162384,
        0.9131852984428406,
        0.3714297413825989
      ],
      "plane_d": 2361.634521484375,
      "bbox_min": [
        -2860.521728515625,
        -3539.687744140625,
        11.2554931640625
      ],
      "bbox_max": [
        -2100.0,
        -3114.76806640625,
        1052.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6317505836486816,
        0.763104259967804,
        0.13624615967273712
      ],
      "plane_d": 4182.1328125,
      "bbox_min": [
        -3000.0,
        -4764.30029296875,
        0.0
      ],
      "bbox_max": [
        -2852.99609375,
        -3005.550537109375,
        1390.1104736328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.965404748916626,
        -0.2439502775669098,
        0.09209758043289185
      ],
      "plane_d": 2003.16259765625,
      "bbox_min": [
        -3000.0,
        -4764.30029296875,
        0.0
      ],
      "bbox_max": [
        -2853.27587890625,
        -3111.68505859375,
        1390.1104736328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16772790253162384,
        0.9131852984428406,
        0.3714297413825989
      ],
      "plane_d": 2361.634521484375,
      "bbox_min": [
        -3000.0,
        -4764.30029296875,
        0.0
      ],
      "bbox_max": [
        -2853.27587890625,
        -3111.68505859375,
        1390.1104736328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3703444004058838,
        0.8832541108131409,
        0.2875887453556061
      ],
      "plane_d": 4875.603515625,
      "bbox_min": [
        -3000.0,
        -4764.30029296875,
        1191.9580078125
      ],
      "bbox_max": [
        -2880.93603515625,
        -4650.2626953125,
        1390.1104736328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7204000949859619,
        0.6658127307891846,
        0.19420866668224335
      ],
      "plane_d": 4133.04052734375,
      "bbox_min": [
        -3000.0,
        -3124.58837890625,
        0.0
      ],
      "bbox_max": [
        -2852.99609375,
        -3005.550537109375,
        311.6372375488281
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.16772790253162384,
        0.9131852984428406,
        0.3714297413825989
      ],
      "plane_d": 2361.634521484375,
      "bbox_min": [
        -2861.24462890625,
        -3124.58837890625,
        0.0
      ],
      "bbox_max": [
        -2852.99609375,
        -3108.556396484375,
        35.3218994140625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3156070411205292,
        0.8320549726486206,
        0.45615431666374207
      ],
      "plane_d": 1686.0640869140625,
      "bbox_min": [
        -2861.24462890625,
        -3114.76806640625,
        0.0
      ],
      "bbox_max": [
        -2852.99609375,
        -3108.556396484375,
        11.255549430847168
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        -2823.71630859375,
        -940.0,
        100.0
      ],
      "bbox_max": [
        -2395.35791015625,
        -503.75830078125,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4086940288543701,
        0.6119945645332336,
        0.677075982093811
      ],
      "plane_d": 614.1734008789062,
      "bbox_min": [
        -900.0,
        -2100.0,
        287.1609191894531
      ],
      "bbox_max": [
        -800.0,
        -1855.504150390625,
        508.155517578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        -2906.989501953125,
        -863.1936645507812,
        100.0
      ],
      "bbox_max": [
        -1471.0003662109375,
        670.86279296875,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.01264164224267006,
        -0.2850233018398285,
        0.9584372639656067
      ],
      "plane_d": 1473.4520263671875,
      "bbox_min": [
        200.0,
        2700.0,
        -33.027774810791016
      ],
      "bbox_max": [
        7681.30224609375,
        7450.0,
        2163.576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509035348892212,
        -0.9807853102684021,
        -0.0
      ],
      "plane_d": 7345.86865234375,
      "bbox_min": [
        200.0,
        6871.484375,
        -22.699951171875
      ],
      "bbox_max": [
        3108.39404296875,
        7450.0,
        680.7955932617188
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.19509035348892212,
        -0.9807853102684021,
        -0.0
      ],
      "plane_d": 7345.86865234375,
      "bbox_min": [
        200.0,
        2700.0,
        547.115966796875
      ],
      "bbox_max": [
        7681.30224609375,
        7450.0,
        2163.576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1491488516330719,
        -0.38985106348991394,
        0.9087193608283997
      ],
      "plane_d": 568.5120849609375,
      "bbox_min": [
        4832.6005859375,
        2700.0,
        1325.890869140625
      ],
      "bbox_max": [
        7681.30224609375,
        3895.50634765625,
        2163.576171875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.027883131057024002,
        0.7254633903503418,
        0.6876956224441528
      ],
      "plane_d": 797.6543579101562,
      "bbox_min": [
        2400.0,
        -2849.047607421875,
        252.5999755859375
      ],
      "bbox_max": [
        7600.0,
        -1150.0,
        2100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04072042927145958,
        0.6873272061347961,
        0.7252056002616882
      ],
      "plane_d": 709.023681640625,
      "bbox_min": [
        2400.0,
        -2849.047607421875,
        329.84539794921875
      ],
      "bbox_max": [
        7550.0,
        -1319.93994140625,
        2100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06764065474271774,
        0.8608478903770447,
        0.5043467879295349
      ],
      "plane_d": 1372.294189453125,
      "bbox_min": [
        2400.0,
        -2050.0,
        329.84539794921875
      ],
      "bbox_max": [
        6992.10546875,
        -1319.93994140625,
        1100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04531257599592209,
        0.41337791085243225,
        0.9094314575195312
      ],
      "plane_d": 354.4123840332031,
      "bbox_min": [
        2400.0,
        -1700.0,
        329.84539794921875
      ],
      "bbox_max": [
        6992.10546875,
        -1319.93994140625,
        590.90966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.02753951959311962,
        0.7068385481834412,
        0.7068385481834412
      ],
      "plane_d": 737.5914916992188,
      "bbox_min": [
        2400.0,
        -2050.0,
        252.5999755859375
      ],
      "bbox_max": [
        7600.0,
        -1150.0,
        1152.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.06764065474271774,
        0.8608478903770447,
        0.5043467879295349
      ],
      "plane_d": 1372.294189453125,
      "bbox_min": [
        2400.0,
        -2050.0,
        296.433349609375
      ],
      "bbox_max": [
        7600.0,
        -1246.433349609375,
        1100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04531257599592209,
        0.41337791085243225,
        0.9094314575195312
      ],
      "plane_d": 354.4123840332031,
      "bbox_min": [
        2400.0,
        -1390.916015625,
        296.433349609375
      ],
      "bbox_max": [
        7600.0,
        -1246.433349609375,
        602.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04531257599592209,
        0.41337791085243225,
        0.9094314575195312
      ],
      "plane_d": 354.4123840332031,
      "bbox_min": [
        2400.0,
        -1350.0,
        252.5999755859375
      ],
      "bbox_max": [
        7600.0,
        -1150.0,
        602.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08598994463682175,
        0.7953926920890808,
        0.5999636054039001
      ],
      "plane_d": 1176.970947265625,
      "bbox_min": [
        650.0,
        -2850.0,
        -300.0
      ],
      "bbox_max": [
        2400.0,
        -696.68505859375,
        1857.3123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0527450367808342,
        0.6877358555793762,
        0.7240422368049622
      ],
      "plane_d": 740.0001220703125,
      "bbox_min": [
        650.0,
        -2850.0,
        1100.0
      ],
      "bbox_max": [
        2400.0,
        -2050.0,
        1857.3123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.04072042927145958,
        0.6873272061347961,
        0.7252056002616882
      ],
      "plane_d": 709.023681640625,
      "bbox_min": [
        2300.0,
        -2850.0,
        1100.0
      ],
      "bbox_max": [
        2400.0,
        -2050.0,
        1857.3123779296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10580915957689285,
        0.4114800691604614,
        0.9052561521530151
      ],
      "plane_d": 498.47637939453125,
      "bbox_min": [
        650.0,
        -1700.0,
        252.5999755859375
      ],
      "bbox_max": [
        2400.0,
        -1546.88427734375,
        502.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07845357060432434,
        0.30509722232818604,
        0.9490841627120972
      ],
      "plane_d": 299.4117431640625,
      "bbox_min": [
        650.0,
        -1600.0,
        -300.0
      ],
      "bbox_max": [
        2400.0,
        -696.68505859375,
        433.001953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.027094179764389992,
        0.9482963681221008,
        0.31622782349586487
      ],
      "plane_d": 817.0990600585938,
      "bbox_min": [
        650.0,
        -843.0780639648438,
        -300.0
      ],
      "bbox_max": [
        2273.75537109375,
        -696.68505859375,
        0.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.10580915957689285,
        0.4114800691604614,
        0.9052561521530151
      ],
      "plane_d": 498.47637939453125,
      "bbox_min": [
        650.0,
        -1600.0,
        252.5999755859375
      ],
      "bbox_max": [
        2400.0,
        -1150.0,
        433.001953125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.012344446033239365,
        0.7703109979629517,
        0.6375489234924316
      ],
      "plane_d": 1063.4288330078125,
      "bbox_min": [
        -800.0,
        -2598.9130859375,
        -300.0
      ],
      "bbox_max": [
        650.0,
        -743.0372314453125,
        1493.904296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4086940288543701,
        0.6119945645332336,
        0.677075982093811
      ],
      "plane_d": 614.1734008789062,
      "bbox_min": [
        -800.0,
        -2500.0,
        0.0
      ],
      "bbox_max": [
        0.0,
        -1371.68505859375,
        1352.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.08598994463682175,
        0.7953926920890808,
        0.5999636054039001
      ],
      "plane_d": 1176.970947265625,
      "bbox_min": [
        0.0,
        -2598.9130859375,
        -300.0
      ],
      "bbox_max": [
        650.0,
        -743.0372314453125,
        1493.904296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0527450367808342,
        0.6877358555793762,
        0.7240422368049622
      ],
      "plane_d": 740.0001220703125,
      "bbox_min": [
        0.0,
        -2598.9130859375,
        1284.1875
      ],
      "bbox_max": [
        650.0,
        -2378.125,
        1493.904296875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07845357060432434,
        0.30509722232818604,
        0.9490841627120972
      ],
      "plane_d": 299.4117431640625,
      "bbox_min": [
        499.2938232421875,
        -1600.0,
        -300.0
      ],
      "bbox_max": [
        650.0,
        -743.0372314453125,
        252.5999755859375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.016502970829606056,
        0.5776039958000183,
        0.8161502480506897
      ],
      "plane_d": 497.69219970703125,
      "bbox_min": [
        523.75537109375,
        -867.0938720703125,
        0.0
      ],
      "bbox_max": [
        650.0,
        -843.0780639648438,
        16.99639320373535
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.12591767311096191,
        -0.43786942958831787,
        0.8901770114898682
      ],
      "plane_d": 367.447509765625,
      "bbox_min": [
        4050.0,
        610.1387329101562,
        261.0314636230469
      ],
      "bbox_max": [
        7986.5068359375,
        2700.0,
        1793.450439453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.1491488516330719,
        -0.38985106348991394,
        0.9087193608283997
      ],
      "plane_d": 568.5120849609375,
      "bbox_min": [
        4050.0,
        610.1387329101562,
        261.0314636230469
      ],
      "bbox_max": [
        7986.5068359375,
        2700.0,
        1793.450439453125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.46037399768829346,
        -0.18474237620830536,
        0.8682891130447388
      ],
      "plane_d": 1430.2772216796875,
      "bbox_min": [
        4050.0,
        610.1387329101562,
        261.0314636230469
      ],
      "bbox_max": [
        4137.6171875,
        2280.14306640625,
        1031.6990966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.010667763650417328,
        -0.8943762183189392,
        0.4471881091594696
      ],
      "plane_d": 472.1678466796875,
      "bbox_min": [
        4050.0,
        610.1387329101562,
        261.0314636230469
      ],
      "bbox_max": [
        4077.6171875,
        611.6770629882812,
        264.1081848144531
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.46037399768829346,
        -0.18474237620830536,
        0.8682891130447388
      ],
      "plane_d": 1430.2772216796875,
      "bbox_min": [
        4050.0,
        902.4468994140625,
        603.3396606445312
      ],
      "bbox_max": [
        4137.6171875,
        2280.14306640625,
        1031.6990966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4713583290576935,
        -0.3486906588077545,
        0.8100841641426086
      ],
      "plane_d": 1743.8494873046875,
      "bbox_min": [
        4050.0,
        902.4468994140625,
        603.3396606445312
      ],
      "bbox_max": [
        4137.6171875,
        1360.935791015625,
        831.6990966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.26363566517829895,
        -0.09646245092153549,
        0.9597871899604797
      ],
      "plane_d": 575.6990966796875,
      "bbox_min": [
        4050.0,
        902.4468994140625,
        603.3396606445312
      ],
      "bbox_max": [
        4077.6171875,
        935.8558959960938,
        611.6990966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4713583290576935,
        -0.3486906588077545,
        0.8100841641426086
      ],
      "plane_d": 1743.8494873046875,
      "bbox_min": [
        4050.0,
        1340.1431884765625,
        789.6677856445312
      ],
      "bbox_max": [
        4137.6171875,
        1374.29296875,
        831.6990966796875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.26363566517829895,
        -0.09646245092153549,
        0.9597871899604797
      ],
      "plane_d": 575.6990966796875,
      "bbox_min": [
        3000.0,
        610.0,
        99.13043212890625
      ],
      "bbox_max": [
        4050.0,
        2236.2041015625,
        975.8950805664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7753851413726807,
        -0.028329361230134964,
        0.6308528780937195
      ],
      "plane_d": 2269.93212890625,
      "bbox_min": [
        3000.0,
        610.0,
        99.13043212890625
      ],
      "bbox_max": [
        4050.0,
        1852.6285400390625,
        489.9930419921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.010667763650417328,
        -0.8943762183189392,
        0.4471881091594696
      ],
      "plane_d": 472.1678466796875,
      "bbox_min": [
        3000.0,
        610.0,
        99.13043212890625
      ],
      "bbox_max": [
        4050.0,
        1852.6285400390625,
        489.9930419921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5038637518882751,
        -0.7725911140441895,
        0.3862955570220947
      ],
      "plane_d": 1980.8563232421875,
      "bbox_min": [
        3000.0,
        610.0,
        99.13043212890625
      ],
      "bbox_max": [
        3312.43017578125,
        1852.6285400390625,
        489.9930419921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.46037399768829346,
        -0.18474237620830536,
        0.8682891130447388
      ],
      "plane_d": 1430.2772216796875,
      "bbox_min": [
        3240.0,
        1790.47265625,
        460.0
      ],
      "bbox_max": [
        3312.43017578125,
        1852.6285400390625,
        489.9930419921875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7398530840873718,
        -0.055298302322626114,
        0.6704919338226318
      ],
      "plane_d": 2182.15185546875,
      "bbox_min": [
        3000.0,
        660.0,
        119.07222747802734
      ],
      "bbox_max": [
        3240.0,
        1690.0,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7727262377738953,
        0.0,
        0.6347393989562988
      ],
      "plane_d": 2241.4580078125,
      "bbox_min": [
        3000.0,
        660.0,
        119.07222747802734
      ],
      "bbox_max": [
        3180.0,
        706.95654296875,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5038637518882751,
        -0.7725911140441895,
        0.3862955570220947
      ],
      "plane_d": 1980.8563232421875,
      "bbox_min": [
        3000.0,
        660.0,
        119.07222747802734
      ],
      "bbox_max": [
        3180.0,
        667.8261108398438,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.46037399768829346,
        -0.18474237620830536,
        0.8682891130447388
      ],
      "plane_d": 1430.2772216796875,
      "bbox_min": [
        3240.0,
        935.8558959960938,
        460.0
      ],
      "bbox_max": [
        4050.0,
        2236.2041015625,
        975.8950805664062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4713583290576935,
        -0.3486906588077545,
        0.8100841641426086
      ],
      "plane_d": 1743.8494873046875,
      "bbox_min": [
        3437.258056640625,
        935.8558959960938,
        495.7249755859375
      ],
      "bbox_max": [
        4050.0,
        1506.344482421875,
        789.6677856445312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.4713583290576935,
        -0.3486906588077545,
        0.8100841641426086
      ],
      "plane_d": 1743.8494873046875,
      "bbox_min": [
        3240.0,
        1360.935791015625,
        460.0
      ],
      "bbox_max": [
        4050.0,
        1690.0,
        795.417236328125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -60.0,
      "bbox_min": [
        -309.5032958984375,
        250.0,
        59.99999237060547
      ],
      "bbox_max": [
        3000.0,
        1737.94091796875,
        1180.0
      ],
      "face_count": 16
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 2162.533447265625,
      "bbox_min": [
        -309.5032958984375,
        250.0,
        59.99999237060547
      ],
      "bbox_max": [
        3000.0,
        1737.94091796875,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7398530840873718,
        -0.055298302322626114,
        0.6704919338226318
      ],
      "plane_d": 2182.15185546875,
      "bbox_min": [
        1368.283935546875,
        656.95654296875,
        60.0
      ],
      "bbox_max": [
        3000.0,
        1690.1553955078125,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5038637518882751,
        -0.7725911140441895,
        0.3862955570220947
      ],
      "plane_d": 1980.8563232421875,
      "bbox_min": [
        2963.7763671875,
        656.95654296875,
        70.78150177001953
      ],
      "bbox_max": [
        3000.0,
        666.4061889648438,
        110.4395980834961
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1549.9998779296875,
      "bbox_min": [
        1368.283935546875,
        1470.0,
        110.06968688964844
      ],
      "bbox_max": [
        2011.0,
        1690.1553955078125,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1910.0,
      "bbox_min": [
        1770.0,
        1470.0,
        500.0
      ],
      "bbox_max": [
        2011.0,
        1690.1553955078125,
        1180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5996253490447998,
        0.5996253490447998,
        -0.5299990773200989
      ],
      "plane_d": 732.9856567382812,
      "bbox_min": [
        1910.0,
        1579.9000244140625,
        980.0
      ],
      "bbox_max": [
        2011.0,
        1690.1553955078125,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071055173873901,
        -0.7071080207824707,
        0.0
      ],
      "plane_d": 2498.914794921875,
      "bbox_min": [
        1910.0,
        1579.9000244140625,
        980.0
      ],
      "bbox_max": [
        1945.0999755859375,
        1631.8814697265625,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1060.0,
      "bbox_min": [
        1910.0,
        1588.9000244140625,
        1060.0
      ],
      "bbox_max": [
        1945.0999755859375,
        1631.8814697265625,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1060.0,
      "bbox_min": [
        1910.0,
        1579.9000244140625,
        1060.0
      ],
      "bbox_max": [
        1945.0999755859375,
        1624.0,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1060.0,
      "bbox_min": [
        1910.0,
        1624.5106201171875,
        1060.0
      ],
      "bbox_max": [
        1917.370849609375,
        1643.306640625,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1579.9000244140625,
      "bbox_min": [
        1770.0,
        1579.9000244140625,
        1059.421875
      ],
      "bbox_max": [
        1910.0,
        1682.0577392578125,
        1180.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 1060.0,
      "bbox_min": [
        1840.0,
        1579.9000244140625,
        1059.421875
      ],
      "bbox_max": [
        1910.0,
        1682.0577392578125,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071055173873901,
        -0.7071080207824707,
        0.0
      ],
      "plane_d": 2498.914794921875,
      "bbox_min": [
        1909.7445068359375,
        1623.9998779296875,
        1059.421875
      ],
      "bbox_max": [
        1910.0,
        1624.25537109375,
        1060.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 1689.9998779296875,
      "bbox_min": [
        1368.283935546875,
        1690.0,
        110.06968688964844
      ],
      "bbox_max": [
        1480.0,
        1690.0,
        250.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7753851413726807,
        -0.028329361230134964,
        0.6308528780937195
      ],
      "plane_d": 2269.93212890625,
      "bbox_min": [
        1770.0,
        662.6111450195312,
        60.0
      ],
      "bbox_max": [
        3000.0,
        1400.0,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5038637518882751,
        -0.7725911140441895,
        0.3862955570220947
      ],
      "plane_d": 1980.8563232421875,
      "bbox_min": [
        2955.163818359375,
        662.6111450195312,
        64.04132080078125
      ],
      "bbox_max": [
        3000.0,
        668.6528930664062,
        119.07218170166016
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1770.0,
      "bbox_min": [
        1770.0,
        666.9274291992188,
        60.0
      ],
      "bbox_max": [
        3000.0,
        1400.0,
        410.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1920.0,
      "bbox_min": [
        1920.0,
        666.9274291992188,
        60.0
      ],
      "bbox_max": [
        3000.0,
        1195.85791015625,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7727262377738953,
        0.0,
        0.6347393989562988
      ],
      "plane_d": 2241.4580078125,
      "bbox_min": [
        2950.0,
        666.9274291992188,
        60.0
      ],
      "bbox_max": [
        3000.0,
        720.0,
        120.86956787109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5038637518882751,
        -0.7725911140441895,
        0.3862955570220947
      ],
      "plane_d": 1980.8563232421875,
      "bbox_min": [
        2950.0,
        666.9274291992188,
        60.0
      ],
      "bbox_max": [
        3000.0,
        670.0,
        120.86956787109375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 360.0,
      "bbox_min": [
        -309.5032958984375,
        250.0,
        59.99999237060547
      ],
      "bbox_max": [
        1920.0,
        1737.94091796875,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1630.0,
      "bbox_min": [
        780.0,
        1570.0,
        60.0
      ],
      "bbox_max": [
        1368.2840576171875,
        1737.94091796875,
        429.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 1689.9998779296875,
      "bbox_min": [
        780.0,
        1630.0,
        60.0
      ],
      "bbox_max": [
        1368.2840576171875,
        1737.94091796875,
        379.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 95.0,
      "bbox_min": [
        966.79248046875,
        1690.0,
        80.0
      ],
      "bbox_max": [
        1065.6220703125,
        1737.94091796875,
        95.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        966.79248046875,
        1690.0,
        80.0
      ],
      "bbox_max": [
        1043.20751953125,
        1737.94091796875,
        95.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.2588212490081787,
        -0.9659253358840942,
        0.0
      ],
      "plane_d": 1397.29833984375,
      "bbox_min": [
        966.79248046875,
        1690.0,
        80.0
      ],
      "bbox_max": [
        1043.20751953125,
        1737.94091796875,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.2588212490081787,
        -0.9659253358840942,
        0.0
      ],
      "plane_d": 1917.529052734375,
      "bbox_min": [
        966.79248046875,
        1715.8818359375,
        80.0
      ],
      "bbox_max": [
        1043.20751953125,
        1737.94091796875,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071014642715454,
        -0.7071121335029602,
        0.0
      ],
      "plane_d": 491.2655029296875,
      "bbox_min": [
        966.79248046875,
        1721.7926025390625,
        80.0
      ],
      "bbox_max": [
        1043.20751953125,
        1737.94091796875,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071041464805603,
        -0.7071094512939453,
        -5.75447211303981e-06
      ],
      "plane_d": 1912.5379638671875,
      "bbox_min": [
        966.79248046875,
        1721.7926025390625,
        80.0
      ],
      "bbox_max": [
        982.94091796875,
        1737.94091796875,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -980.0,
      "bbox_min": [
        980.0,
        1690.0,
        80.0
      ],
      "bbox_max": [
        980.0,
        1696.69873046875,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 379.0,
      "bbox_min": [
        940.0,
        1630.0,
        80.0
      ],
      "bbox_max": [
        1258.199951171875,
        1690.0,
        379.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1258.199951171875,
      "bbox_min": [
        940.0,
        1630.0,
        80.0
      ],
      "bbox_max": [
        1258.199951171875,
        1690.0,
        379.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5144957304000854,
        -0.8574929237365723,
        0.0
      ],
      "plane_d": 927.807373046875,
      "bbox_min": [
        940.0,
        1630.0,
        80.0
      ],
      "bbox_max": [
        1057.5947265625,
        1690.0,
        216.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        940.0,
        1646.923095703125,
        80.0
      ],
      "bbox_max": [
        1013.3334350585938,
        1690.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        980.0,
        1670.0,
        80.0
      ],
      "bbox_max": [
        1013.3334350585938,
        1690.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        980.0,
        1670.0,
        80.0
      ],
      "bbox_max": [
        1013.3334350585938,
        1690.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -980.0,
      "bbox_min": [
        980.0,
        1670.0,
        98.0
      ],
      "bbox_max": [
        980.0,
        1690.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -980.0,
      "bbox_min": [
        980.0,
        1670.0,
        80.0
      ],
      "bbox_max": [
        980.0,
        1690.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1037.5947265625,
      "bbox_min": [
        941.5384521484375,
        1630.0,
        80.0
      ],
      "bbox_max": [
        1057.5947265625,
        1690.0,
        179.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7241379618644714,
        0.0,
        0.6896552443504333
      ],
      "plane_d": 642.396240234375,
      "bbox_min": [
        1037.5947265625,
        1630.0,
        158.0
      ],
      "bbox_max": [
        1057.5947265625,
        1690.0,
        179.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        941.5384521484375,
        1630.0,
        80.0
      ],
      "bbox_max": [
        1037.5947265625,
        1690.0,
        121.03141784667969
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9405532479286194,
        0.0,
        0.3396463692188263
      ],
      "plane_d": 934.80517578125,
      "bbox_min": [
        941.5384521484375,
        1630.0,
        80.0
      ],
      "bbox_max": [
        1037.5947265625,
        1690.0,
        121.03141784667969
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        1029.2777099609375,
        1640.0,
        98.0
      ],
      "bbox_max": [
        1030.0,
        1690.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1640.0,
      "bbox_min": [
        1029.2777099609375,
        1640.0,
        98.0
      ],
      "bbox_max": [
        1030.0,
        1640.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        941.5384521484375,
        1630.0,
        80.0
      ],
      "bbox_max": [
        1030.0,
        1690.0,
        100.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        980.0,
        1630.0,
        80.0
      ],
      "bbox_max": [
        1030.0,
        1690.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -980.0,
      "bbox_min": [
        980.0,
        1630.0,
        98.0
      ],
      "bbox_max": [
        1030.0,
        1670.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1640.0,
      "bbox_min": [
        1000.0,
        1640.0,
        98.0
      ],
      "bbox_max": [
        1030.0,
        1640.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -980.0,
      "bbox_min": [
        980.0,
        1630.0,
        80.0
      ],
      "bbox_max": [
        980.0,
        1670.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1590.0,
      "bbox_min": [
        950.0,
        1570.0,
        80.0
      ],
      "bbox_max": [
        1225.0,
        1630.0,
        329.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        950.0,
        1590.0,
        80.0
      ],
      "bbox_max": [
        1225.0,
        1630.0,
        329.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05225301533937454,
        -0.8944270610809326,
        0.4441506266593933
      ],
      "plane_d": 1458.3773193359375,
      "bbox_min": [
        1020.0,
        1590.0,
        118.0
      ],
      "bbox_max": [
        1225.0,
        1630.0,
        329.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1620.0,
      "bbox_min": [
        1036.5,
        1620.0,
        118.0
      ],
      "bbox_max": [
        1200.0,
        1630.0,
        121.03141784667969
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9405532479286194,
        0.0,
        0.3396463692188263
      ],
      "plane_d": 934.80517578125,
      "bbox_min": [
        1036.5,
        1628.55859375,
        118.0
      ],
      "bbox_max": [
        1037.5947265625,
        1630.0,
        121.03141784667969
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1610.0,
      "bbox_min": [
        1020.0,
        1590.0,
        118.0
      ],
      "bbox_max": [
        1225.0,
        1620.0,
        329.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.47058823704719543,
        0.0,
        0.8823529481887817
      ],
      "plane_d": 382.3529357910156,
      "bbox_min": [
        1033.75,
        1610.0,
        118.0
      ],
      "bbox_max": [
        1037.5,
        1620.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1020.0,
      "bbox_min": [
        1020.0,
        1590.0,
        118.0
      ],
      "bbox_max": [
        1020.0,
        1610.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11684125661849976,
        0.0,
        0.9931506514549255
      ],
      "plane_d": 40.894447326660156,
      "bbox_min": [
        950.0,
        1590.0,
        80.0
      ],
      "bbox_max": [
        1200.0,
        1630.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1620.0,
      "bbox_min": [
        950.0,
        1590.0,
        80.0
      ],
      "bbox_max": [
        1200.0,
        1630.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.05225301533937454,
        -0.8944270610809326,
        0.4441506266593933
      ],
      "plane_d": 1458.3773193359375,
      "bbox_min": [
        950.0,
        1620.0,
        80.0
      ],
      "bbox_max": [
        1183.0,
        1630.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        950.0,
        1620.0,
        80.0
      ],
      "bbox_max": [
        1036.5,
        1630.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        950.0,
        1620.0,
        80.0
      ],
      "bbox_max": [
        1036.5,
        1630.0,
        118.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        980.0,
        1620.0,
        80.0
      ],
      "bbox_max": [
        1030.0,
        1630.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        980.0,
        1620.0,
        80.0
      ],
      "bbox_max": [
        1000.0,
        1630.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -980.0,
      "bbox_min": [
        980.0,
        1621.927734375,
        98.0
      ],
      "bbox_max": [
        980.0,
        1630.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -980.0,
      "bbox_min": [
        980.0,
        1620.0,
        80.0
      ],
      "bbox_max": [
        980.0,
        1630.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9405532479286194,
        0.0,
        0.3396463692188263
      ],
      "plane_d": 934.80517578125,
      "bbox_min": [
        1030.0,
        1620.0,
        100.0
      ],
      "bbox_max": [
        1036.5,
        1630.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        952.7433471679688,
        1620.0,
        94.11782836914062
      ],
      "bbox_max": [
        1000.0,
        1624.5133056640625,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        980.0,
        1620.0,
        94.11782836914062
      ],
      "bbox_max": [
        1000.0,
        1622.9208984375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -980.0,
      "bbox_min": [
        980.0,
        1620.0,
        98.0
      ],
      "bbox_max": [
        980.0,
        1622.9208984375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -980.0,
      "bbox_min": [
        980.0,
        1620.0,
        94.11782836914062
      ],
      "bbox_max": [
        980.0,
        1621.927734375,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        955.0,
        1590.0,
        80.0
      ],
      "bbox_max": [
        1037.5,
        1620.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.47058823704719543,
        0.0,
        -0.8823529481887817
      ],
      "plane_d": -384.1176452636719,
      "bbox_min": [
        955.0,
        1590.0,
        80.0
      ],
      "bbox_max": [
        1037.5,
        1620.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1610.0,
      "bbox_min": [
        955.0,
        1590.0,
        87.33335876464844
      ],
      "bbox_max": [
        1037.5,
        1620.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -980.0,
      "bbox_min": [
        980.0,
        1610.0,
        87.33335876464844
      ],
      "bbox_max": [
        1000.0,
        1620.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 97.99999237060547,
      "bbox_min": [
        996.25,
        1610.0,
        98.0
      ],
      "bbox_max": [
        1000.0,
        1620.0,
        98.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        955.0,
        1610.0,
        89.33335876464844
      ],
      "bbox_max": [
        1000.0,
        1620.0,
        100.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -980.0,
      "bbox_min": [
        980.0,
        1610.0,
        89.33335876464844
      ],
      "bbox_max": [
        996.25,
        1620.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        980.0,
        1610.0,
        98.0
      ],
      "bbox_max": [
        996.25,
        1620.0,
        98.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        960.0,
        1590.0,
        87.33335876464844
      ],
      "bbox_max": [
        1000.0,
        1610.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        980.0,
        1590.0,
        87.33335876464844
      ],
      "bbox_max": [
        1000.0,
        1610.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -980.0,
      "bbox_min": [
        980.0,
        1590.0,
        98.0
      ],
      "bbox_max": [
        980.0,
        1610.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -980.0,
      "bbox_min": [
        980.0,
        1590.0,
        87.33335876464844
      ],
      "bbox_max": [
        980.0,
        1610.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -980.0,
      "bbox_min": [
        980.0,
        1590.0,
        80.0
      ],
      "bbox_max": [
        980.0,
        1620.0,
        87.33335876464844
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11684125661849976,
        0.0,
        0.9931506514549255
      ],
      "plane_d": 40.894447326660156,
      "bbox_min": [
        970.0,
        1570.0,
        80.0
      ],
      "bbox_max": [
        1200.0,
        1590.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        970.0,
        1570.0,
        80.0
      ],
      "bbox_max": [
        1030.0,
        1590.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -980.0,
      "bbox_min": [
        970.0,
        1570.0,
        80.0
      ],
      "bbox_max": [
        1000.0,
        1590.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        970.0,
        1570.0,
        100.0
      ],
      "bbox_max": [
        980.0,
        1590.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        980.0,
        1570.0,
        98.0
      ],
      "bbox_max": [
        1000.0,
        1590.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        980.0,
        1570.0,
        98.0
      ],
      "bbox_max": [
        1000.0,
        1590.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1460.0,
      "bbox_min": [
        839.914794921875,
        1450.0,
        71.0
      ],
      "bbox_max": [
        1200.0,
        1570.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        839.914794921875,
        1460.0,
        71.0
      ],
      "bbox_max": [
        1200.0,
        1570.0,
        780.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1200.0,
      "bbox_min": [
        1030.0,
        1460.0,
        100.0
      ],
      "bbox_max": [
        1200.0,
        1570.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1470.0,
      "bbox_min": [
        1030.0,
        1460.0,
        160.0
      ],
      "bbox_max": [
        1200.0,
        1570.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1075.0,
      "bbox_min": [
        1030.0,
        1470.0,
        160.0
      ],
      "bbox_max": [
        1200.0,
        1570.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1175.0,
      "bbox_min": [
        1075.0,
        1470.0,
        160.0
      ],
      "bbox_max": [
        1200.0,
        1570.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        1075.0,
        1550.0,
        160.0
      ],
      "bbox_max": [
        1175.0,
        1570.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1550.0,
      "bbox_min": [
        1075.0,
        1550.0,
        160.0
      ],
      "bbox_max": [
        1175.0,
        1550.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        1175.0,
        1550.0,
        160.0
      ],
      "bbox_max": [
        1200.0,
        1570.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1550.0,
      "bbox_min": [
        1175.0,
        1550.0,
        160.0
      ],
      "bbox_max": [
        1200.0,
        1550.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.70710688829422,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": -466.63031005859375,
      "bbox_min": [
        1030.0,
        1470.0,
        160.0
      ],
      "bbox_max": [
        1075.0,
        1570.0,
        390.0852355957031
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        1030.0,
        1550.0,
        160.0
      ],
      "bbox_max": [
        1075.0,
        1570.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        -0.7071067094802856
      ],
      "plane_d": -476.6302490234375,
      "bbox_min": [
        1030.0,
        1520.0,
        355.9431457519531
      ],
      "bbox_max": [
        1050.0,
        1540.0,
        390.0852355957031
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9999999403953552,
        -0.0
      ],
      "plane_d": 1519.9998779296875,
      "bbox_min": [
        1030.0,
        1520.0,
        355.9431457519531
      ],
      "bbox_max": [
        1050.0,
        1520.0,
        390.0852355957031
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.70710688829422,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": -466.63031005859375,
      "bbox_min": [
        1030.0,
        1460.0,
        370.0852355957031
      ],
      "bbox_max": [
        1050.0,
        1470.0,
        390.0852355957031
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.70710688829422,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": -466.63031005859375,
      "bbox_min": [
        839.914794921875,
        1460.0,
        71.0
      ],
      "bbox_max": [
        1030.0,
        1570.0,
        370.0852355957031
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        -0.7071067094802856
      ],
      "plane_d": -476.6302490234375,
      "bbox_min": [
        854.056884765625,
        1520.0,
        74.86474609375
      ],
      "bbox_max": [
        1030.0,
        1570.0,
        355.9431457519531
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        928.6475219726562,
        1520.0,
        74.86474609375
      ],
      "bbox_max": [
        1030.0,
        1570.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09950371831655502,
        0.0,
        0.9950371980667114
      ],
      "plane_d": 17.910667419433594,
      "bbox_min": [
        928.6475219726562,
        1520.0,
        74.86474609375
      ],
      "bbox_max": [
        980.0,
        1550.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1550.0,
      "bbox_min": [
        960.0,
        1550.0,
        78.0
      ],
      "bbox_max": [
        980.0,
        1550.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -980.0,
      "bbox_min": [
        929.0144653320312,
        1520.0,
        80.0
      ],
      "bbox_max": [
        1030.0,
        1570.0,
        180.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1550.0,
      "bbox_min": [
        929.0144653320312,
        1520.0,
        80.0
      ],
      "bbox_max": [
        980.0,
        1550.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.27883198857307434,
        -0.9603399634361267,
        0.0
      ],
      "plane_d": 1215.2716064453125,
      "bbox_min": [
        945.5584716796875,
        1540.0,
        140.0
      ],
      "bbox_max": [
        980.0,
        1550.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        980.0,
        1520.0,
        98.0
      ],
      "bbox_max": [
        1030.0,
        1570.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1550.0,
      "bbox_min": [
        980.0,
        1550.0,
        160.0
      ],
      "bbox_max": [
        1030.0,
        1550.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        980.0,
        1520.0,
        98.0
      ],
      "bbox_max": [
        1000.0,
        1570.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        980.0,
        1520.0,
        98.0
      ],
      "bbox_max": [
        1000.0,
        1570.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09950371831655502,
        0.0,
        0.9950371980667114
      ],
      "plane_d": 17.910667419433594,
      "bbox_min": [
        890.0,
        1460.0,
        71.0
      ],
      "bbox_max": [
        1030.0,
        1520.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        980.0,
        1460.0,
        80.0
      ],
      "bbox_max": [
        1030.0,
        1520.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        890.0,
        1460.0,
        98.0
      ],
      "bbox_max": [
        1000.0,
        1520.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        980.0,
        1460.0,
        100.0
      ],
      "bbox_max": [
        1000.0,
        1520.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.70710688829422,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": -466.63031005859375,
      "bbox_min": [
        839.914794921875,
        1450.0,
        71.0
      ],
      "bbox_max": [
        1090.0,
        1460.0,
        390.0852355957031
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        980.0,
        1450.0,
        100.0
      ],
      "bbox_max": [
        1090.0,
        1460.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.09950371831655502,
        0.0,
        0.9950371980667114
      ],
      "plane_d": 17.910667419433594,
      "bbox_min": [
        890.0,
        1450.0,
        71.0
      ],
      "bbox_max": [
        1090.0,
        1460.0,
        87.05882263183594
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11684099584817886,
        0.0,
        0.9931507110595703
      ],
      "plane_d": 40.8941650390625,
      "bbox_min": [
        980.0,
        1450.0,
        80.0
      ],
      "bbox_max": [
        1090.0,
        1460.0,
        87.05882263183594
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        980.0,
        1450.0,
        80.0
      ],
      "bbox_max": [
        1030.0,
        1460.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1280.0,
      "bbox_min": [
        360.0,
        1130.0,
        140.0
      ],
      "bbox_max": [
        1920.0,
        1450.0,
        784.9600830078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        839.914794921875,
        1280.0,
        140.0
      ],
      "bbox_max": [
        1770.0,
        1450.0,
        784.9600830078125
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1300.0,
      "bbox_min": [
        1030.0,
        1280.0,
        140.0
      ],
      "bbox_max": [
        1770.0,
        1450.0,
        784.9600830078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1200.0,
      "bbox_min": [
        1030.0,
        1300.0,
        140.0
      ],
      "bbox_max": [
        1630.0001220703125,
        1450.0,
        784.9600830078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1310.0,
      "bbox_min": [
        1030.0,
        1310.0,
        370.0852355957031
      ],
      "bbox_max": [
        1175.0,
        1450.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1075.0,
      "bbox_min": [
        1030.0,
        1310.0,
        370.0852355957031
      ],
      "bbox_max": [
        1175.0,
        1450.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1175.0,
      "bbox_min": [
        1175.0,
        1310.0,
        515.0
      ],
      "bbox_max": [
        1175.0,
        1380.0,
        780.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.70710688829422,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": -466.63031005859375,
      "bbox_min": [
        1030.0,
        1330.0,
        370.0852355957031
      ],
      "bbox_max": [
        1050.0,
        1450.0,
        390.0852355957031
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000008344650269,
        -0.4999992549419403,
        0.7071068286895752
      ],
      "plane_d": 959.9495849609375,
      "bbox_min": [
        1430.0,
        1300.0,
        572.8280029296875
      ],
      "bbox_max": [
        1630.0001220703125,
        1400.0,
        784.9600830078125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000008344650269,
        -0.4999992549419403,
        0.7071068286895752
      ],
      "plane_d": 959.9495849609375,
      "bbox_min": [
        1030.0,
        1280.0,
        140.0
      ],
      "bbox_max": [
        1770.0,
        1300.0,
        714.2494506835938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        1030.0,
        1280.0,
        140.0
      ],
      "bbox_max": [
        1770.0,
        1300.0,
        226.61752319335938
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1770.0,
      "bbox_min": [
        1770.0,
        1280.0,
        160.0
      ],
      "bbox_max": [
        1770.0,
        1288.2838134765625,
        226.61752319335938
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1770.0,
      "bbox_min": [
        1770.0,
        1280.0,
        140.0
      ],
      "bbox_max": [
        1770.0,
        1288.2838134765625,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.70710688829422,
        0.0,
        -0.7071067690849304
      ],
      "plane_d": -466.63031005859375,
      "bbox_min": [
        839.914794921875,
        1280.0,
        160.0
      ],
      "bbox_max": [
        1030.0,
        1450.0,
        370.0852355957031
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        980.0,
        1280.0,
        160.0
      ],
      "bbox_max": [
        1030.0,
        1300.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -490.0,
      "bbox_min": [
        440.0,
        1130.0,
        190.0
      ],
      "bbox_max": [
        490.0,
        1240.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": -551.5433349609375,
      "bbox_min": [
        440.0,
        1130.0,
        290.0
      ],
      "bbox_max": [
        490.0,
        1240.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1170.0,
      "bbox_min": [
        805.3590087890625,
        1130.0,
        140.0
      ],
      "bbox_max": [
        1920.0,
        1280.0,
        700.1072998046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1200.0,
      "bbox_min": [
        805.3590087890625,
        1170.0,
        140.0
      ],
      "bbox_max": [
        1770.0,
        1280.0,
        700.1072998046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5000002384185791,
        -0.8660252690315247,
        0.0
      ],
      "plane_d": 612.3018798828125,
      "bbox_min": [
        805.3590087890625,
        1170.0,
        140.0
      ],
      "bbox_max": [
        1030.0,
        1280.0,
        400.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000002384185791,
        -0.8660252690315247,
        -0.0
      ],
      "plane_d": 1452.3023681640625,
      "bbox_min": [
        805.3590087890625,
        1192.0,
        140.0
      ],
      "bbox_max": [
        840.0,
        1212.0,
        320.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1000.0,
      "bbox_min": [
        910.0,
        1170.0,
        140.0
      ],
      "bbox_max": [
        1030.0,
        1280.0,
        400.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25617516040802,
        -0.9666303992271423,
        0.0
      ],
      "plane_d": 1383.4095458984375,
      "bbox_min": [
        910.0,
        1170.0,
        280.0
      ],
      "bbox_max": [
        985.4663696289062,
        1190.0,
        400.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        1000.0,
        1170.0,
        140.0
      ],
      "bbox_max": [
        1030.0,
        1280.0,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547002553939819,
        0.0,
        -0.8320503234863281
      ],
      "plane_d": -321.7261657714844,
      "bbox_min": [
        1000.0,
        1170.0,
        280.0
      ],
      "bbox_max": [
        1030.0,
        1280.0,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5000008344650269,
        -0.4999992549419403,
        0.7071068286895752
      ],
      "plane_d": 959.9495849609375,
      "bbox_min": [
        1400.0,
        1170.0,
        140.0
      ],
      "bbox_max": [
        1770.0,
        1280.0,
        700.1072998046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1770.0,
      "bbox_min": [
        1770.0,
        1170.0,
        140.0
      ],
      "bbox_max": [
        1770.0,
        1280.0,
        224.88372802734375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9418852925300598,
        -0.33593469858169556,
        0.0
      ],
      "plane_d": -550.1356201171875,
      "bbox_min": [
        985.4663696289062,
        1130.0,
        140.0
      ],
      "bbox_max": [
        1920.0,
        1170.0,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1000.0,
      "bbox_min": [
        985.4663696289062,
        1166.1483154296875,
        140.0
      ],
      "bbox_max": [
        1001.373779296875,
        1170.0,
        400.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.25617516040802,
        -0.9666303992271423,
        0.0
      ],
      "plane_d": 1383.4095458984375,
      "bbox_min": [
        985.4663696289062,
        1166.1483154296875,
        280.0
      ],
      "bbox_max": [
        1000.0,
        1170.0,
        400.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547002553939819,
        0.0,
        -0.8320503234863281
      ],
      "plane_d": -321.7261657714844,
      "bbox_min": [
        1000.0,
        1166.1483154296875,
        280.0
      ],
      "bbox_max": [
        1001.373779296875,
        1170.0,
        280.9158630371094
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1166.1483154296875,
      "bbox_min": [
        1000.0,
        1130.0,
        140.0
      ],
      "bbox_max": [
        1920.0,
        1170.0,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1770.0,
      "bbox_min": [
        1000.0,
        1166.1483154296875,
        140.0
      ],
      "bbox_max": [
        1770.0,
        1170.0,
        300.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.5547002553939819,
        0.0,
        -0.8320503234863281
      ],
      "plane_d": -321.7261657714844,
      "bbox_min": [
        1000.0,
        1166.1483154296875,
        280.0
      ],
      "bbox_max": [
        1030.0,
        1170.0,
        300.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1920.0,
      "bbox_min": [
        1770.0,
        1130.0,
        140.0
      ],
      "bbox_max": [
        1920.0,
        1166.1483154296875,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1770.0,
      "bbox_min": [
        1770.0,
        1130.0,
        140.0
      ],
      "bbox_max": [
        1770.0,
        1166.1483154296875,
        201.05430603027344
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -980.0,
      "bbox_min": [
        760.0,
        1130.0,
        60.0
      ],
      "bbox_max": [
        1770.0,
        1450.0,
        140.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.09950372576713562,
        0.0,
        0.9950372576713562
      ],
      "plane_d": 17.910667419433594,
      "bbox_min": [
        760.0,
        1130.0,
        60.0
      ],
      "bbox_max": [
        980.0,
        1450.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        760.0,
        1130.0,
        80.0
      ],
      "bbox_max": [
        980.0,
        1450.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944271802902222,
        -0.4472135901451111
      ],
      "plane_d": 1091.201171875,
      "bbox_min": [
        760.0,
        1130.0,
        98.0
      ],
      "bbox_max": [
        980.0,
        1170.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9284767508506775,
        -0.371390700340271,
        0.0
      ],
      "plane_d": -475.3800964355469,
      "bbox_min": [
        964.0,
        1130.0,
        98.0
      ],
      "bbox_max": [
        980.0,
        1170.0,
        127.92337036132812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8304547071456909,
        -0.3321818709373474,
        -0.4472138285636902
      ],
      "plane_d": -380.4714660644531,
      "bbox_min": [
        964.0,
        1130.0,
        100.0
      ],
      "bbox_max": [
        980.0,
        1170.0,
        127.92337036132812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8237894773483276,
        -0.29381439089775085,
        -0.48481348156929016
      ],
      "plane_d": -413.284423828125,
      "bbox_min": [
        968.667724609375,
        1130.0,
        108.66770935058594
      ],
      "bbox_max": [
        980.0,
        1143.0740966796875,
        127.92337036132812
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9284767508506775,
        -0.371390700340271,
        0.0
      ],
      "plane_d": -475.3800964355469,
      "bbox_min": [
        964.0,
        1130.0,
        80.0
      ],
      "bbox_max": [
        980.0,
        1170.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        964.0,
        1130.0,
        80.0
      ],
      "bbox_max": [
        980.0,
        1170.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        980.0,
        1130.0,
        80.0
      ],
      "bbox_max": [
        1770.0,
        1450.0,
        140.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1170.0,
      "bbox_min": [
        1030.0,
        1130.0,
        80.0
      ],
      "bbox_max": [
        1770.0,
        1450.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1200.0,
      "bbox_min": [
        1030.0,
        1170.0,
        80.0
      ],
      "bbox_max": [
        1770.0,
        1450.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1300.0,
      "bbox_min": [
        1030.0,
        1300.0,
        80.0
      ],
      "bbox_max": [
        1200.0,
        1450.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.11684099584817886,
        0.0,
        0.9931507110595703
      ],
      "plane_d": 40.8941650390625,
      "bbox_min": [
        1030.0,
        1390.0,
        80.0
      ],
      "bbox_max": [
        1090.0,
        1450.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1390.0,
      "bbox_min": [
        1030.0,
        1390.0,
        98.0
      ],
      "bbox_max": [
        1090.0,
        1450.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        1030.0,
        1390.0,
        98.0
      ],
      "bbox_max": [
        1090.0,
        1450.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 97.99999237060547,
      "bbox_min": [
        1030.0,
        1390.0,
        98.0
      ],
      "bbox_max": [
        1090.0,
        1450.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1440.0,
      "bbox_min": [
        1030.0,
        1440.0,
        98.0
      ],
      "bbox_max": [
        1070.0,
        1440.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1770.0,
      "bbox_min": [
        1770.0,
        1170.0,
        97.07317352294922
      ],
      "bbox_max": [
        1770.0,
        1288.2838134765625,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1030.0,
        1130.0,
        93.17073059082031
      ],
      "bbox_max": [
        1770.0,
        1170.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        1030.0,
        1130.0,
        118.0
      ],
      "bbox_max": [
        1770.0,
        1170.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1770.0,
      "bbox_min": [
        1770.0,
        1130.0,
        118.0
      ],
      "bbox_max": [
        1770.0,
        1170.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1770.0,
      "bbox_min": [
        1770.0,
        1130.0,
        120.0
      ],
      "bbox_max": [
        1770.0,
        1170.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1770.0,
      "bbox_min": [
        1770.0,
        1130.0,
        93.17073059082031
      ],
      "bbox_max": [
        1770.0,
        1170.0,
        118.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        980.0,
        1130.0,
        80.0
      ],
      "bbox_max": [
        1030.0,
        1450.0,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.8944271802902222,
        0.0,
        -0.4472135901451111
      ],
      "plane_d": -831.8172607421875,
      "bbox_min": [
        980.0,
        1130.0,
        80.0
      ],
      "bbox_max": [
        1030.0,
        1450.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8304547071456909,
        -0.3321818709373474,
        -0.4472138285636902
      ],
      "plane_d": -380.4714660644531,
      "bbox_min": [
        980.0,
        1130.0,
        100.0
      ],
      "bbox_max": [
        1000.0,
        1170.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8237894773483276,
        -0.29381439089775085,
        -0.48481348156929016
      ],
      "plane_d": -413.284423828125,
      "bbox_min": [
        980.0,
        1130.0,
        118.0
      ],
      "bbox_max": [
        1000.0,
        1166.1483154296875,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        980.0,
        1130.0,
        118.0
      ],
      "bbox_max": [
        990.0,
        1140.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 117.99999237060547,
      "bbox_min": [
        980.0,
        1130.0,
        118.0
      ],
      "bbox_max": [
        988.9999389648438,
        1140.0,
        118.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        980.0,
        1130.0,
        80.0
      ],
      "bbox_max": [
        1030.0,
        1450.0,
        120.0
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 97.99999237060547,
      "bbox_min": [
        980.0,
        1130.0,
        80.0
      ],
      "bbox_max": [
        1030.0,
        1450.0,
        100.0
      ],
      "face_count": 10
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1000.0,
      "bbox_min": [
        980.0,
        1130.0,
        98.0
      ],
      "bbox_max": [
        1030.0,
        1440.0,
        100.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1390.0,
      "bbox_min": [
        1000.0,
        1140.0,
        98.0
      ],
      "bbox_max": [
        1030.0,
        1390.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1140.0,
      "bbox_min": [
        1000.0,
        1140.0,
        98.0
      ],
      "bbox_max": [
        1030.0,
        1390.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.44721361994743347,
        0.8944272398948669
      ],
      "plane_d": 532.1842041015625,
      "bbox_min": [
        1000.0,
        1246.0,
        98.0
      ],
      "bbox_max": [
        1030.0,
        1390.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.44721361994743347,
        -0.8944272398948669
      ],
      "plane_d": 646.6708984375,
      "bbox_min": [
        1020.0,
        1246.0,
        98.0
      ],
      "bbox_max": [
        1030.0,
        1250.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        -0.0,
        -0.0
      ],
      "plane_d": 1019.9999389648438,
      "bbox_min": [
        1020.0,
        1246.0,
        98.0
      ],
      "bbox_max": [
        1020.0,
        1250.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1280.0,
      "bbox_min": [
        980.0,
        1280.0,
        98.0
      ],
      "bbox_max": [
        1000.0,
        1280.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.44721361994743347,
        0.8944272398948669
      ],
      "plane_d": 532.1842041015625,
      "bbox_min": [
        1000.0,
        1350.0,
        80.0
      ],
      "bbox_max": [
        1010.0,
        1390.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 999.9999389648438,
      "bbox_min": [
        1000.0,
        1350.0,
        80.0
      ],
      "bbox_max": [
        1000.0,
        1390.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        -0.0,
        -0.0
      ],
      "plane_d": 1019.9999389648438,
      "bbox_min": [
        988.9999389648438,
        1130.0,
        100.0
      ],
      "bbox_max": [
        1030.0,
        1250.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        1020.0,
        1206.0,
        120.0
      ],
      "bbox_max": [
        1030.0,
        1210.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1020.0,
        1130.0,
        118.0
      ],
      "bbox_max": [
        1030.0,
        1210.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        1020.0,
        1130.0,
        118.0
      ],
      "bbox_max": [
        1030.0,
        1206.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1200.0,
      "bbox_min": [
        1020.0,
        1200.0,
        118.0
      ],
      "bbox_max": [
        1030.0,
        1200.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        988.9999389648438,
        1130.0,
        118.0
      ],
      "bbox_max": [
        1020.0000610351562,
        1140.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        990.0,
        1130.0,
        120.0
      ],
      "bbox_max": [
        1020.0000610351562,
        1140.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 620.0,
      "bbox_min": [
        360.0,
        281.61761474609375,
        59.99999237060547
      ],
      "bbox_max": [
        1920.0,
        1130.0,
        810.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 101.92391967773438,
      "bbox_min": [
        620.0,
        281.61761474609375,
        59.99999237060547
      ],
      "bbox_max": [
        1920.0,
        1130.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1250.0,
      "bbox_min": [
        620.0,
        281.61761474609375,
        59.99999237060547
      ],
      "bbox_max": [
        1920.0,
        1130.0,
        810.0
      ],
      "face_count": 10
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 720.0,
      "bbox_min": [
        1250.0,
        502.3577880859375,
        60.0
      ],
      "bbox_max": [
        1920.0,
        1130.0,
        515.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1600.0,
      "bbox_min": [
        1250.0,
        720.0,
        60.0
      ],
      "bbox_max": [
        1920.0,
        1130.0,
        515.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1650.0,
      "bbox_min": [
        1600.0,
        720.0,
        60.0
      ],
      "bbox_max": [
        1920.0,
        1130.0,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1770.0,
      "bbox_min": [
        1650.0,
        720.0,
        60.0
      ],
      "bbox_max": [
        1920.0,
        1130.0,
        410.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1920.0,
      "bbox_min": [
        1770.0,
        830.0,
        140.0
      ],
      "bbox_max": [
        1920.0,
        1130.0,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1910.0,
      "bbox_min": [
        1770.0,
        830.0,
        140.0
      ],
      "bbox_max": [
        1910.0,
        970.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -160.0,
      "bbox_min": [
        1770.0,
        920.0,
        160.0
      ],
      "bbox_max": [
        1910.0,
        970.0,
        160.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1690.0,
      "bbox_min": [
        1650.0,
        840.0,
        80.0
      ],
      "bbox_max": [
        1770.0,
        1120.0,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 970.0,
      "bbox_min": [
        1690.0,
        840.0,
        80.0
      ],
      "bbox_max": [
        1770.0,
        998.5078125,
        410.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7808688282966614,
        -0.6246950626373291,
        -0.0
      ],
      "plane_d": 1941.239990234375,
      "bbox_min": [
        1690.0,
        970.0,
        80.0
      ],
      "bbox_max": [
        1770.0,
        998.5078125,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        1690.0,
        970.0,
        80.0
      ],
      "bbox_max": [
        1770.0,
        998.5078125,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.780868411064148,
        -0.6246957182884216,
        -0.0
      ],
      "plane_d": 1951.2398681640625,
      "bbox_min": [
        1690.0,
        980.0,
        80.0
      ],
      "bbox_max": [
        1770.0,
        998.5078125,
        410.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1758.0,
        980.0,
        80.0
      ],
      "bbox_max": [
        1770.0,
        995.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6497217416763306,
        -0.5197782516479492,
        0.5547000765800476
      ],
      "plane_d": 1443.252197265625,
      "bbox_min": [
        1690.0,
        980.0,
        310.0
      ],
      "bbox_max": [
        1714.8062744140625,
        998.5078125,
        325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6497217416763306,
        -0.5197782516479492,
        0.5547000765800476
      ],
      "plane_d": 1443.252197265625,
      "bbox_min": [
        1702.0,
        970.0,
        80.0
      ],
      "bbox_max": [
        1770.0,
        980.0,
        325.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1750.0,
        970.0,
        80.0
      ],
      "bbox_max": [
        1770.0,
        980.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7273929715156555,
        -0.5819143652915955,
        0.36369648575782776
      ],
      "plane_d": 1771.92919921875,
      "bbox_min": [
        1690.0,
        970.0,
        80.0
      ],
      "bbox_max": [
        1710.0,
        995.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1690.0,
        970.0,
        80.0
      ],
      "bbox_max": [
        1700.0,
        982.5,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1690.0,
        840.0,
        80.0
      ],
      "bbox_max": [
        1770.0,
        970.0,
        240.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1690.0,
        920.0,
        80.0
      ],
      "bbox_max": [
        1770.0,
        970.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -920.0,
      "bbox_min": [
        1690.0,
        920.0,
        80.0
      ],
      "bbox_max": [
        1750.0,
        960.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 97.99999237060547,
      "bbox_min": [
        1690.0,
        920.0,
        98.0
      ],
      "bbox_max": [
        1720.0,
        960.0,
        100.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1700.0,
      "bbox_min": [
        1690.0,
        920.0,
        98.0
      ],
      "bbox_max": [
        1720.0,
        960.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -960.0,
      "bbox_min": [
        1700.0,
        960.0,
        98.0
      ],
      "bbox_max": [
        1720.0,
        960.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 940.0,
      "bbox_min": [
        1690.0,
        940.0,
        98.0
      ],
      "bbox_max": [
        1700.0,
        940.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -240.0,
      "bbox_min": [
        1690.0,
        840.0,
        118.0
      ],
      "bbox_max": [
        1770.0,
        940.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -900.0,
      "bbox_min": [
        1690.0,
        840.0,
        118.0
      ],
      "bbox_max": [
        1770.0,
        940.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1750.0,
      "bbox_min": [
        1750.0,
        840.0,
        118.0
      ],
      "bbox_max": [
        1750.0,
        900.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -940.0,
      "bbox_min": [
        1690.0,
        900.0,
        118.0
      ],
      "bbox_max": [
        1770.0,
        940.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1750.0,
      "bbox_min": [
        1750.0,
        900.0,
        118.0
      ],
      "bbox_max": [
        1750.0,
        920.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.13216373324394226,
        0.991227924823761
      ],
      "plane_d": 48.90058898925781,
      "bbox_min": [
        1650.0,
        840.0,
        80.0
      ],
      "bbox_max": [
        1690.0,
        1120.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8921462297439575,
        -0.07137169688940048,
        0.44607311487197876
      ],
      "plane_d": 1534.1346435546875,
      "bbox_min": [
        1680.0,
        970.0,
        80.0
      ],
      "bbox_max": [
        1690.0,
        1120.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1680.0,
        970.0,
        80.0
      ],
      "bbox_max": [
        1690.0,
        995.0,
        83.33332824707031
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7273929715156555,
        -0.5819143652915955,
        0.36369648575782776
      ],
      "plane_d": 1771.92919921875,
      "bbox_min": [
        1680.0,
        982.5,
        80.0
      ],
      "bbox_max": [
        1690.0,
        995.0,
        83.33332824707031
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1680.0,
        970.0,
        80.0
      ],
      "bbox_max": [
        1681.9998779296875,
        995.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8921462297439575,
        -0.07137169688940048,
        0.44607311487197876
      ],
      "plane_d": 1534.1346435546875,
      "bbox_min": [
        1650.0,
        840.0,
        80.0
      ],
      "bbox_max": [
        1690.0,
        1120.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7273929715156555,
        -0.5819143652915955,
        0.36369648575782776
      ],
      "plane_d": 1771.92919921875,
      "bbox_min": [
        1681.6666259765625,
        920.0,
        80.0
      ],
      "bbox_max": [
        1690.0,
        995.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -920.0,
      "bbox_min": [
        1685.9998779296875,
        920.0,
        80.0
      ],
      "bbox_max": [
        1690.0,
        920.0,
        88.00027465820312
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1650.0,
        840.0,
        80.0
      ],
      "bbox_max": [
        1690.0,
        990.0,
        240.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1650.0,
        920.0,
        80.0
      ],
      "bbox_max": [
        1690.0,
        970.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -920.0,
      "bbox_min": [
        1650.0,
        920.0,
        80.0
      ],
      "bbox_max": [
        1690.0,
        963.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        1650.0,
        940.0,
        98.0
      ],
      "bbox_max": [
        1690.0,
        963.0,
        100.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.5547002553939819,
        -0.8320503234863281
      ],
      "plane_d": -450.9713134765625,
      "bbox_min": [
        1650.0,
        960.0,
        98.0
      ],
      "bbox_max": [
        1660.0,
        963.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -240.0,
      "bbox_min": [
        1650.0,
        840.0,
        100.0
      ],
      "bbox_max": [
        1690.0,
        990.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -900.0,
      "bbox_min": [
        1650.0,
        900.0,
        100.0
      ],
      "bbox_max": [
        1690.0,
        990.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 117.99999237060547,
      "bbox_min": [
        1650.0,
        920.0,
        100.0
      ],
      "bbox_max": [
        1690.0,
        990.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5547002553939819,
        0.8320503234863281
      ],
      "plane_d": 449.3072204589844,
      "bbox_min": [
        1650.0,
        987.0,
        118.0
      ],
      "bbox_max": [
        1660.0,
        990.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.5547002553939819,
        0.8320503234863281
      ],
      "plane_d": 449.3072204589844,
      "bbox_min": [
        1650.0,
        960.0,
        100.0
      ],
      "bbox_max": [
        1660.0,
        990.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.5547002553939819,
        -0.8320503234863281
      ],
      "plane_d": -450.9713134765625,
      "bbox_min": [
        1650.0,
        963.0,
        100.0
      ],
      "bbox_max": [
        1660.0,
        990.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 100.0,
      "bbox_min": [
        1650.0,
        720.0,
        80.0
      ],
      "bbox_max": [
        1770.0,
        840.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -240.0,
      "bbox_min": [
        1650.0,
        810.0,
        118.0
      ],
      "bbox_max": [
        1770.0,
        840.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 117.99999237060547,
      "bbox_min": [
        1750.0,
        810.0,
        118.0
      ],
      "bbox_max": [
        1770.0,
        840.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 740.0,
      "bbox_min": [
        1650.0,
        740.0,
        80.0
      ],
      "bbox_max": [
        1750.0,
        740.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.13216373324394226,
        0.991227924823761
      ],
      "plane_d": 48.90058898925781,
      "bbox_min": [
        1600.0,
        840.0,
        80.0
      ],
      "bbox_max": [
        1650.0,
        1120.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1630.0,
      "bbox_min": [
        1600.0,
        840.0,
        80.0
      ],
      "bbox_max": [
        1650.0,
        1120.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1630.0,
        840.0,
        80.0
      ],
      "bbox_max": [
        1650.0,
        995.0,
        240.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -920.0,
      "bbox_min": [
        1630.0,
        920.0,
        80.0
      ],
      "bbox_max": [
        1650.0,
        960.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        1630.0,
        940.0,
        98.0
      ],
      "bbox_max": [
        1650.0,
        960.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 940.0,
      "bbox_min": [
        1630.0,
        940.0,
        98.0
      ],
      "bbox_max": [
        1650.0,
        940.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        1630.0,
        840.0,
        118.0
      ],
      "bbox_max": [
        1650.0,
        995.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1630.0,
        920.0,
        118.0
      ],
      "bbox_max": [
        1650.0,
        995.0,
        118.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -240.0,
      "bbox_min": [
        1630.0,
        840.0,
        220.0
      ],
      "bbox_max": [
        1650.0,
        900.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -900.0,
      "bbox_min": [
        1630.0,
        900.0,
        220.0
      ],
      "bbox_max": [
        1650.0,
        900.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        1600.0,
        840.0,
        80.0
      ],
      "bbox_max": [
        1630.0,
        1110.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1600.0,
        840.0,
        80.0
      ],
      "bbox_max": [
        1630.0,
        980.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1600.0,
        920.0,
        80.0
      ],
      "bbox_max": [
        1630.0,
        980.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": 831.8173217773438,
      "bbox_min": [
        1600.0,
        920.0,
        80.0
      ],
      "bbox_max": [
        1630.0,
        980.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -920.0,
      "bbox_min": [
        1600.0,
        920.0,
        80.0
      ],
      "bbox_max": [
        1630.0,
        960.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        1600.0,
        940.0,
        98.0
      ],
      "bbox_max": [
        1630.0,
        960.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -960.0,
      "bbox_min": [
        1600.0,
        940.0,
        98.0
      ],
      "bbox_max": [
        1630.0,
        960.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 940.0,
      "bbox_min": [
        1600.0,
        940.0,
        98.0
      ],
      "bbox_max": [
        1630.0,
        940.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        1600.0,
        980.0,
        100.0
      ],
      "bbox_max": [
        1630.0,
        980.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -240.0,
      "bbox_min": [
        1600.0,
        840.0,
        220.0
      ],
      "bbox_max": [
        1630.0,
        900.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -900.0,
      "bbox_min": [
        1600.0,
        900.0,
        220.0
      ],
      "bbox_max": [
        1630.0,
        900.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 100.0,
      "bbox_min": [
        1600.0,
        720.0,
        80.0
      ],
      "bbox_max": [
        1650.0,
        840.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -240.0,
      "bbox_min": [
        1600.0,
        810.0,
        240.0
      ],
      "bbox_max": [
        1650.0,
        840.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 740.0,
      "bbox_min": [
        1600.0,
        740.0,
        80.0
      ],
      "bbox_max": [
        1650.0,
        740.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1530.0,
      "bbox_min": [
        1250.0,
        720.0,
        60.0
      ],
      "bbox_max": [
        1600.0,
        1130.0,
        515.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 960.0,
      "bbox_min": [
        1530.0,
        840.0,
        80.0
      ],
      "bbox_max": [
        1600.0,
        1110.0,
        515.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.9950371980667114,
        -0.09950372576713562,
        0.0
      ],
      "plane_d": 1659.7220458984375,
      "bbox_min": [
        1530.0,
        960.0,
        80.0
      ],
      "bbox_max": [
        1600.0,
        1110.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        1557.0,
        960.0,
        80.0
      ],
      "bbox_max": [
        1600.0,
        1110.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        1570.0,
        960.0,
        80.0
      ],
      "bbox_max": [
        1600.0,
        980.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": 831.8173217773438,
      "bbox_min": [
        1570.0,
        960.0,
        80.0
      ],
      "bbox_max": [
        1600.0,
        980.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1571.0,
        960.0,
        80.0
      ],
      "bbox_max": [
        1600.0,
        970.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        1530.0,
        960.0,
        80.0
      ],
      "bbox_max": [
        1572.0,
        1110.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": 831.8173217773438,
      "bbox_min": [
        1530.0,
        960.0,
        80.0
      ],
      "bbox_max": [
        1572.0,
        980.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1530.0,
        960.0,
        80.0
      ],
      "bbox_max": [
        1572.0,
        970.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -940.0,
      "bbox_min": [
        1530.0,
        840.0,
        80.0
      ],
      "bbox_max": [
        1600.0,
        960.0,
        220.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -220.0,
      "bbox_min": [
        1530.0,
        840.0,
        80.0
      ],
      "bbox_max": [
        1600.0,
        940.0,
        220.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -920.0,
      "bbox_min": [
        1530.0,
        920.0,
        80.0
      ],
      "bbox_max": [
        1600.0,
        940.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1530.0,
        920.0,
        80.0
      ],
      "bbox_max": [
        1600.0,
        940.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        1530.0,
        940.0,
        80.0
      ],
      "bbox_max": [
        1600.0,
        960.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        1530.0,
        940.0,
        100.0
      ],
      "bbox_max": [
        1600.0,
        960.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1530.0,
        940.0,
        80.0
      ],
      "bbox_max": [
        1600.0,
        960.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -220.0,
      "bbox_min": [
        1530.0,
        720.0,
        80.0
      ],
      "bbox_max": [
        1600.0,
        840.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 760.0,
      "bbox_min": [
        1530.0,
        720.0,
        80.0
      ],
      "bbox_max": [
        1600.0,
        760.0,
        220.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 135.0,
      "bbox_min": [
        1530.0,
        720.0,
        105.0
      ],
      "bbox_max": [
        1600.0,
        760.0,
        135.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -110.0,
      "bbox_min": [
        1530.0,
        720.0,
        105.0
      ],
      "bbox_max": [
        1600.0,
        760.0,
        130.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 105.0,
      "bbox_min": [
        1535.0,
        720.0,
        105.0
      ],
      "bbox_max": [
        1600.0,
        725.0,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 130.0,
      "bbox_min": [
        1530.0,
        720.0,
        130.0
      ],
      "bbox_max": [
        1600.0,
        760.0,
        130.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.2940859794616699,
        -0.955778956413269,
        0.0
      ],
      "plane_d": 511.26690673828125,
      "bbox_min": [
        1250.0,
        720.0,
        60.0
      ],
      "bbox_max": [
        1530.0,
        1130.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9950371980667114,
        -0.09950372576713562,
        0.0
      ],
      "plane_d": 1500.51611328125,
      "bbox_min": [
        1250.0,
        919.5372924804688,
        80.0
      ],
      "bbox_max": [
        1530.0,
        1130.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9950371980667114,
        -0.09950372576713562,
        0.0
      ],
      "plane_d": 1580.1190185546875,
      "bbox_min": [
        1397.0,
        969.1033325195312,
        80.0
      ],
      "bbox_max": [
        1530.0,
        1110.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        1477.0,
        992.9839477539062,
        140.0
      ],
      "bbox_max": [
        1530.0,
        1110.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        1397.0,
        969.1033325195312,
        80.0
      ],
      "bbox_max": [
        1488.7015380859375,
        1110.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        1397.0,
        1030.0,
        140.0
      ],
      "bbox_max": [
        1485.0,
        1110.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1405.0,
      "bbox_min": [
        1405.0,
        1030.0,
        465.0
      ],
      "bbox_max": [
        1405.0,
        1100.0,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        1405.0,
        969.1033325195312,
        80.0
      ],
      "bbox_max": [
        1488.7015380859375,
        1030.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": 831.8173217773438,
      "bbox_min": [
        1410.0,
        969.1033935546875,
        80.0
      ],
      "bbox_max": [
        1446.5037841796875,
        980.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1411.0001220703125,
        969.1033935546875,
        80.0
      ],
      "bbox_max": [
        1414.0037841796875,
        970.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1395.0,
      "bbox_min": [
        1250.0,
        919.5372924804688,
        80.0
      ],
      "bbox_max": [
        1411.0897216796875,
        1130.0,
        465.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1030.0,
      "bbox_min": [
        1395.0,
        964.1527099609375,
        80.0
      ],
      "bbox_max": [
        1411.0897216796875,
        1110.0,
        465.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        1395.0,
        1030.0,
        140.0
      ],
      "bbox_max": [
        1405.0,
        1110.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        1395.0,
        964.1527099609375,
        80.0
      ],
      "bbox_max": [
        1411.0897216796875,
        1030.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        1395.0,
        964.1527099609375,
        80.0
      ],
      "bbox_max": [
        1411.0897216796875,
        980.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": 831.8173217773438,
      "bbox_min": [
        1395.0,
        964.1527099609375,
        80.0
      ],
      "bbox_max": [
        1411.0897216796875,
        980.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1395.0,
        964.1527099609375,
        80.0
      ],
      "bbox_max": [
        1411.0897216796875,
        970.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1050.0,
      "bbox_min": [
        1250.0,
        919.5372924804688,
        80.0
      ],
      "bbox_max": [
        1395.0,
        1130.0,
        330.10211181640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944271802902222,
        0.0,
        -0.4472135901451111
      ],
      "plane_d": -1171.6995849609375,
      "bbox_min": [
        1380.0,
        1050.0,
        140.0
      ],
      "bbox_max": [
        1395.0,
        1130.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        1380.0,
        1050.0,
        140.0
      ],
      "bbox_max": [
        1395.0,
        1110.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.25881895422935486,
        0.965925931930542
      ],
      "plane_d": -4.2996978759765625,
      "bbox_min": [
        1250.0,
        919.5372924804688,
        80.0
      ],
      "bbox_max": [
        1395.0,
        1050.0,
        283.118408203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        1250.0,
        919.5372924804688,
        80.0
      ],
      "bbox_max": [
        1395.0,
        1050.0,
        204.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -161.19998168945312,
      "bbox_min": [
        1250.0,
        919.5372924804688,
        160.0
      ],
      "bbox_max": [
        1395.0,
        1016.0,
        204.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -982.6386108398438,
      "bbox_min": [
        1390.0,
        982.6386108398438,
        160.0
      ],
      "bbox_max": [
        1395.0,
        982.6386108398438,
        161.1999969482422
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1016.0,
      "bbox_min": [
        1250.0,
        1016.0,
        161.1999969482422
      ],
      "bbox_max": [
        1258.0,
        1016.0,
        204.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944271802902222,
        0.0,
        -0.4472135901451111
      ],
      "plane_d": -1171.6995849609375,
      "bbox_min": [
        1250.0,
        962.6142578125,
        80.0
      ],
      "bbox_max": [
        1395.0,
        1050.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        1380.0,
        980.0,
        120.88444519042969
      ],
      "bbox_max": [
        1395.0,
        980.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.29408586025238037,
        -0.9557790756225586,
        0.0
      ],
      "plane_d": 521.2672119140625,
      "bbox_min": [
        1250.0,
        919.5372924804688,
        80.0
      ],
      "bbox_max": [
        1395.0,
        980.0,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        1380.0,
        970.0,
        80.0
      ],
      "bbox_max": [
        1395.0,
        980.0,
        129.70704650878906
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": 831.8173217773438,
      "bbox_min": [
        1380.0,
        970.0,
        80.0
      ],
      "bbox_max": [
        1395.0,
        980.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1250.0,
        919.5372924804688,
        80.0
      ],
      "bbox_max": [
        1395.0,
        974.6153564453125,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.2940855622291565,
        0.9557791948318481,
        0.0
      ],
      "plane_d": -511.7098693847656,
      "bbox_min": [
        1250.0,
        919.5372924804688,
        80.0
      ],
      "bbox_max": [
        1395.0,
        974.6153564453125,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 97.99999237060547,
      "bbox_min": [
        1250.0,
        919.5372924804688,
        98.0
      ],
      "bbox_max": [
        1381.5037841796875,
        960.0,
        100.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1250.0,
        919.5372924804688,
        98.0
      ],
      "bbox_max": [
        1381.5037841796875,
        960.0,
        100.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -960.0,
      "bbox_min": [
        1380.0,
        960.0,
        98.0
      ],
      "bbox_max": [
        1381.5037841796875,
        960.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": 831.8173217773438,
      "bbox_min": [
        1380.0,
        970.0,
        80.0
      ],
      "bbox_max": [
        1395.0,
        974.6153564453125,
        89.23075103759766
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 960.0,
      "bbox_min": [
        1250.0,
        720.0,
        60.0
      ],
      "bbox_max": [
        1530.0,
        1005.691162109375,
        515.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.9950371980667114,
        -0.09950372576713562,
        0.0
      ],
      "plane_d": 1580.1190185546875,
      "bbox_min": [
        1381.503662109375,
        960.0,
        80.0
      ],
      "bbox_max": [
        1530.0,
        1005.691162109375,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        1488.7015380859375,
        960.0,
        80.0
      ],
      "bbox_max": [
        1530.0,
        1005.691162109375,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": 831.8173217773438,
      "bbox_min": [
        1490.0,
        960.0,
        80.0
      ],
      "bbox_max": [
        1530.0,
        980.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1490.0,
        960.0,
        80.0
      ],
      "bbox_max": [
        1530.0,
        980.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 140.0,
      "bbox_min": [
        1490.0,
        960.0,
        140.0
      ],
      "bbox_max": [
        1520.0,
        980.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9950371980667114,
        -0.09950372576713562,
        0.0
      ],
      "plane_d": 1500.51611328125,
      "bbox_min": [
        1381.503662109375,
        960.0,
        80.0
      ],
      "bbox_max": [
        1492.0,
        992.9839477539062,
        515.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1411.0897216796875,
        960.0,
        80.0
      ],
      "bbox_max": [
        1492.0,
        992.9839477539062,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": 831.8173217773438,
      "bbox_min": [
        1411.0897216796875,
        960.0,
        80.0
      ],
      "bbox_max": [
        1491.0,
        992.9839477539062,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        1411.0897216796875,
        960.0,
        100.0
      ],
      "bbox_max": [
        1490.0,
        992.9839477539062,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        1446.5037841796875,
        980.0,
        140.0
      ],
      "bbox_max": [
        1490.0,
        992.9839477539062,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 140.0,
      "bbox_min": [
        1411.0897216796875,
        960.0,
        140.0
      ],
      "bbox_max": [
        1439.7935791015625,
        977.935302734375,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1381.503662109375,
        960.0,
        80.0
      ],
      "bbox_max": [
        1412.0,
        969.1033935546875,
        161.1999969482422
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -161.19998168945312,
      "bbox_min": [
        1381.503662109375,
        960.0,
        160.0
      ],
      "bbox_max": [
        1395.0,
        964.1526489257812,
        161.1999969482422
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        1381.503662109375,
        960.0,
        160.0
      ],
      "bbox_max": [
        1395.0,
        964.1526489257812,
        161.1999969482422
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1395.0,
      "bbox_min": [
        1395.0,
        960.0,
        160.0
      ],
      "bbox_max": [
        1395.0,
        964.1526489257812,
        161.1999969482422
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -350.0,
      "bbox_min": [
        1250.0,
        720.0,
        60.0
      ],
      "bbox_max": [
        1530.0,
        960.0,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -880.0,
      "bbox_min": [
        1250.0,
        720.0,
        60.0
      ],
      "bbox_max": [
        1530.0,
        960.0,
        350.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        -0.09950372576713562,
        0.9950372576713562
      ],
      "plane_d": 11.940444946289062,
      "bbox_min": [
        1250.0,
        720.0,
        60.0
      ],
      "bbox_max": [
        1530.0,
        880.0,
        195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 180.0,
      "bbox_min": [
        1250.0,
        750.0,
        160.0
      ],
      "bbox_max": [
        1330.0,
        880.0,
        195.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        -0.24253565073013306,
        -0.9701426029205322
      ],
      "plane_d": 375.9302673339844,
      "bbox_min": [
        1250.0,
        750.0,
        180.0
      ],
      "bbox_max": [
        1285.0999755859375,
        830.0,
        195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        -0.0,
        -0.0
      ],
      "plane_d": 1279.9998779296875,
      "bbox_min": [
        1250.0,
        750.0,
        180.0
      ],
      "bbox_max": [
        1285.0999755859375,
        830.0,
        195.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 760.0,
      "bbox_min": [
        1280.0,
        755.0,
        185.0
      ],
      "bbox_max": [
        1285.0999755859375,
        760.0,
        195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1285.0999755859375,
      "bbox_min": [
        1280.0,
        755.0,
        185.0
      ],
      "bbox_max": [
        1285.0999755859375,
        760.0,
        195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -185.0,
      "bbox_min": [
        1280.0,
        755.0,
        185.0
      ],
      "bbox_max": [
        1285.0999755859375,
        760.0,
        195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 195.0,
      "bbox_min": [
        1280.0,
        755.0,
        195.0
      ],
      "bbox_max": [
        1285.0999755859375,
        760.0,
        195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -185.0,
      "bbox_min": [
        1250.0,
        750.0,
        185.0
      ],
      "bbox_max": [
        1270.0,
        770.0,
        195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 195.0,
      "bbox_min": [
        1250.0,
        750.0,
        185.0
      ],
      "bbox_max": [
        1270.0,
        770.0,
        195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -750.0,
      "bbox_min": [
        1250.0,
        750.0,
        185.0
      ],
      "bbox_max": [
        1270.0,
        770.0,
        195.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 770.0,
      "bbox_min": [
        1250.0,
        750.0,
        185.0
      ],
      "bbox_max": [
        1270.0,
        770.0,
        195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1252.0,
      "bbox_min": [
        1250.0,
        750.0,
        185.0
      ],
      "bbox_max": [
        1252.0,
        770.0,
        195.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -188.5,
      "bbox_min": [
        1250.0,
        756.0,
        188.5
      ],
      "bbox_max": [
        1252.0,
        764.0,
        193.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 193.0,
      "bbox_min": [
        1250.0,
        756.0,
        188.5
      ],
      "bbox_max": [
        1252.0,
        764.0,
        193.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 764.0,
      "bbox_min": [
        1250.0,
        756.0,
        188.5
      ],
      "bbox_max": [
        1252.0,
        764.0,
        193.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -756.0,
      "bbox_min": [
        1250.0,
        756.0,
        188.5
      ],
      "bbox_max": [
        1252.0,
        756.0,
        193.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -185.0,
      "bbox_min": [
        1270.0,
        750.0,
        180.0
      ],
      "bbox_max": [
        1280.0,
        790.0,
        195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.24253565073013306,
        0.9701426029205322
      ],
      "plane_d": -366.22882080078125,
      "bbox_min": [
        1270.0,
        770.0,
        180.0
      ],
      "bbox_max": [
        1280.0,
        790.0,
        185.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 195.0,
      "bbox_min": [
        1270.0,
        750.0,
        185.0
      ],
      "bbox_max": [
        1280.0,
        770.0,
        195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -750.0,
      "bbox_min": [
        1270.0,
        750.0,
        185.0
      ],
      "bbox_max": [
        1280.0,
        750.0,
        195.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1330.0,
      "bbox_min": [
        1270.0,
        790.0,
        160.0
      ],
      "bbox_max": [
        1330.0,
        880.0,
        180.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -160.0,
      "bbox_min": [
        1270.0,
        790.0,
        160.0
      ],
      "bbox_max": [
        1330.0,
        880.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44721361994743347,
        0.0,
        0.8944272398948669
      ],
      "plane_d": 442.741455078125,
      "bbox_min": [
        1270.0,
        790.0,
        160.0
      ],
      "bbox_max": [
        1330.0,
        880.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1320.0,
      "bbox_min": [
        1310.0,
        820.0,
        160.0
      ],
      "bbox_max": [
        1320.0,
        880.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -820.0,
      "bbox_min": [
        1310.0,
        820.0,
        160.0
      ],
      "bbox_max": [
        1320.0,
        820.0,
        165.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1310.0,
      "bbox_min": [
        1270.0,
        790.0,
        160.0
      ],
      "bbox_max": [
        1330.0,
        880.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44721361994743347,
        0.0,
        0.8944272398948669
      ],
      "plane_d": -733.4302978515625,
      "bbox_min": [
        1270.0,
        790.0,
        165.0
      ],
      "bbox_max": [
        1310.0,
        880.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.24253565073013306,
        0.9701426029205322
      ],
      "plane_d": -366.22882080078125,
      "bbox_min": [
        1270.0,
        790.0,
        170.0
      ],
      "bbox_max": [
        1300.0,
        870.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        -0.0,
        -0.0
      ],
      "plane_d": 1279.9998779296875,
      "bbox_min": [
        1270.0,
        790.0,
        170.0
      ],
      "bbox_max": [
        1300.0,
        870.0,
        180.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -170.0,
      "bbox_min": [
        1280.0,
        830.0,
        170.0
      ],
      "bbox_max": [
        1300.0,
        870.0,
        180.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 840.0,
      "bbox_min": [
        1280.0,
        830.0,
        170.0
      ],
      "bbox_max": [
        1300.0,
        870.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 870.0,
      "bbox_min": [
        1280.0,
        845.0,
        170.0
      ],
      "bbox_max": [
        1299.0,
        870.0,
        180.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1281.0,
      "bbox_min": [
        1280.0,
        845.0,
        170.0
      ],
      "bbox_max": [
        1299.0,
        870.0,
        180.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -860.0,
      "bbox_min": [
        1280.0,
        860.0,
        170.0
      ],
      "bbox_max": [
        1281.0,
        860.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1296.0,
      "bbox_min": [
        1296.0,
        845.0,
        170.0
      ],
      "bbox_max": [
        1299.0,
        870.0,
        171.99993896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1299.0,
      "bbox_min": [
        1296.0,
        845.0,
        170.0
      ],
      "bbox_max": [
        1299.0,
        870.0,
        171.99993896484375
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -860.0,
      "bbox_min": [
        1296.0,
        850.0,
        170.0
      ],
      "bbox_max": [
        1299.0,
        860.0,
        171.99993896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 850.0,
      "bbox_min": [
        1296.0,
        850.0,
        170.0
      ],
      "bbox_max": [
        1299.0,
        850.0,
        171.99993896484375
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -830.0,
      "bbox_min": [
        1280.0,
        830.0,
        170.0
      ],
      "bbox_max": [
        1300.0,
        830.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        -0.0
      ],
      "plane_d": -1269.9998779296875,
      "bbox_min": [
        1270.0,
        790.0,
        170.0
      ],
      "bbox_max": [
        1280.0,
        870.0,
        180.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 870.0,
      "bbox_min": [
        1270.0,
        870.0,
        170.0
      ],
      "bbox_max": [
        1280.0,
        870.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 840.0,
      "bbox_min": [
        1280.0,
        820.0,
        165.0
      ],
      "bbox_max": [
        1310.0,
        880.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1300.0,
      "bbox_min": [
        1280.0,
        840.0,
        170.0
      ],
      "bbox_max": [
        1300.0,
        880.0,
        180.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 870.0,
      "bbox_min": [
        1280.0,
        845.0,
        170.49998474121094
      ],
      "bbox_max": [
        1300.0,
        870.0,
        180.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1281.0,
      "bbox_min": [
        1280.0,
        845.0,
        170.49998474121094
      ],
      "bbox_max": [
        1300.0,
        870.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -860.0,
      "bbox_min": [
        1280.0,
        860.0,
        179.49993896484375
      ],
      "bbox_max": [
        1281.0,
        860.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1299.0,
      "bbox_min": [
        1296.0,
        845.0,
        170.49998474121094
      ],
      "bbox_max": [
        1300.0,
        870.0,
        180.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -173.60000610351562,
      "bbox_min": [
        1299.0,
        850.0,
        173.60000610351562
      ],
      "bbox_max": [
        1300.0,
        860.0,
        178.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 178.0,
      "bbox_min": [
        1299.0,
        850.0,
        173.60000610351562
      ],
      "bbox_max": [
        1300.0,
        860.0,
        178.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 860.0,
      "bbox_min": [
        1299.0,
        850.0,
        173.60000610351562
      ],
      "bbox_max": [
        1300.0,
        860.0,
        178.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -850.0,
      "bbox_min": [
        1299.0,
        850.0,
        173.60000610351562
      ],
      "bbox_max": [
        1300.0,
        850.0,
        178.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -173.60000610351562,
      "bbox_min": [
        1296.0,
        850.0,
        170.49998474121094
      ],
      "bbox_max": [
        1299.0,
        860.0,
        173.60000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1296.0,
      "bbox_min": [
        1296.0,
        850.0,
        170.49998474121094
      ],
      "bbox_max": [
        1299.0,
        860.0,
        173.60000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -860.0,
      "bbox_min": [
        1296.0,
        850.0,
        170.49998474121094
      ],
      "bbox_max": [
        1299.0,
        860.0,
        173.60000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 850.0,
      "bbox_min": [
        1296.0,
        850.0,
        170.49998474121094
      ],
      "bbox_max": [
        1299.0,
        850.0,
        173.60000610351562
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -830.0,
      "bbox_min": [
        1280.0,
        820.0,
        165.0
      ],
      "bbox_max": [
        1310.0,
        830.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -820.0,
      "bbox_min": [
        1300.0,
        820.0,
        165.0
      ],
      "bbox_max": [
        1310.0,
        830.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1300.0,
      "bbox_min": [
        1300.0,
        820.0,
        170.0
      ],
      "bbox_max": [
        1300.0,
        830.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -820.0,
      "bbox_min": [
        1310.0,
        820.0,
        160.0
      ],
      "bbox_max": [
        1330.0,
        820.0,
        180.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.293938547372818,
        -0.9558243155479431,
        0.0
      ],
      "plane_d": 506.970947265625,
      "bbox_min": [
        1250.0,
        880.0,
        76.0
      ],
      "bbox_max": [
        1530.0,
        960.0,
        161.1999969482422
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        1250.0,
        914.8063354492188,
        80.0
      ],
      "bbox_max": [
        1396.9600830078125,
        960.0,
        161.1999969482422
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1395.0,
      "bbox_min": [
        1395.0,
        959.397216796875,
        160.0
      ],
      "bbox_max": [
        1395.0,
        960.0,
        161.1999969482422
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        1250.0,
        914.8063354492188,
        80.0
      ],
      "bbox_max": [
        1396.9600830078125,
        960.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 97.99999237060547,
      "bbox_min": [
        1250.0,
        914.8063354492188,
        98.0
      ],
      "bbox_max": [
        1396.9600830078125,
        960.0,
        100.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1250.0,
        914.8063354492188,
        100.0
      ],
      "bbox_max": [
        1396.9600830078125,
        960.0,
        100.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.09950372576713562,
        0.9950372576713562
      ],
      "plane_d": 11.940444946289062,
      "bbox_min": [
        1480.0,
        880.0,
        76.0
      ],
      "bbox_max": [
        1530.0,
        920.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.29408586025238037,
        0.9557790756225586,
        0.0
      ],
      "plane_d": -473.4782409667969,
      "bbox_min": [
        1250.0,
        880.0,
        80.0
      ],
      "bbox_max": [
        1530.0,
        960.0,
        161.1999969482422
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        1250.0,
        880.0,
        80.0
      ],
      "bbox_max": [
        1530.0,
        960.0,
        125.0
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -920.0,
      "bbox_min": [
        1380.0,
        890.0,
        80.0
      ],
      "bbox_max": [
        1530.0,
        960.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1480.0,
      "bbox_min": [
        1480.0,
        890.0,
        88.0
      ],
      "bbox_max": [
        1520.0,
        920.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        1480.0,
        890.0,
        88.0
      ],
      "bbox_max": [
        1520.0,
        920.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.44721361994743347,
        0.8944272398948669
      ],
      "plane_d": -491.9349670410156,
      "bbox_min": [
        1500.0,
        900.0,
        98.0
      ],
      "bbox_max": [
        1520.0,
        904.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -900.0,
      "bbox_min": [
        1500.0,
        900.0,
        98.0
      ],
      "bbox_max": [
        1510.0,
        904.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1509.9998779296875,
      "bbox_min": [
        1510.0,
        900.0,
        98.0
      ],
      "bbox_max": [
        1510.0,
        904.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1509.9998779296875,
      "bbox_min": [
        1510.0,
        900.0,
        88.0
      ],
      "bbox_max": [
        1520.0,
        920.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.44721361994743347,
        0.8944272398948669
      ],
      "plane_d": -491.9349670410156,
      "bbox_min": [
        1510.0,
        904.0,
        90.0
      ],
      "bbox_max": [
        1520.0,
        920.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        1445.0,
        920.0,
        80.0
      ],
      "bbox_max": [
        1530.0,
        960.0,
        100.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 940.0,
      "bbox_min": [
        1445.0,
        920.0,
        98.0
      ],
      "bbox_max": [
        1530.0,
        940.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1480.0,
      "bbox_min": [
        1480.0,
        920.0,
        98.0
      ],
      "bbox_max": [
        1480.0,
        940.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.44721361994743347,
        0.8944272398948669
      ],
      "plane_d": -491.9349670410156,
      "bbox_min": [
        1510.0,
        920.0,
        80.0
      ],
      "bbox_max": [
        1520.0,
        940.0,
        90.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9999999403953552,
        0.0,
        0.0
      ],
      "plane_d": 1509.9998779296875,
      "bbox_min": [
        1510.0,
        920.0,
        80.0
      ],
      "bbox_max": [
        1510.0,
        940.0,
        90.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.27716064453125,
        0.9608235955238342,
        0.0
      ],
      "plane_d": -491.8677978515625,
      "bbox_min": [
        1276.0,
        880.0,
        100.0
      ],
      "bbox_max": [
        1470.0,
        910.0,
        125.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -125.0,
      "bbox_min": [
        1276.0,
        880.0,
        100.0
      ],
      "bbox_max": [
        1470.0,
        910.0,
        125.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 120.0,
      "bbox_min": [
        1290.0,
        880.0,
        100.0
      ],
      "bbox_max": [
        1470.0,
        910.0,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -910.0,
      "bbox_min": [
        1380.0,
        910.0,
        120.0
      ],
      "bbox_max": [
        1470.0,
        910.0,
        125.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -910.0,
      "bbox_min": [
        1290.0,
        880.0,
        100.0
      ],
      "bbox_max": [
        1470.0,
        910.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1380.0,
      "bbox_min": [
        1290.0,
        880.0,
        100.0
      ],
      "bbox_max": [
        1380.0,
        910.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1290.0,
      "bbox_min": [
        1290.0,
        880.0,
        100.0
      ],
      "bbox_max": [
        1290.0,
        884.0384521484375,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        1250.0,
        900.0,
        98.0
      ],
      "bbox_max": [
        1510.0001220703125,
        960.0,
        161.1999969482422
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        1250.0,
        900.0,
        98.0
      ],
      "bbox_max": [
        1510.0001220703125,
        960.0,
        100.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.2940857708454132,
        -0.9557791352272034,
        0.0
      ],
      "plane_d": 492.5940246582031,
      "bbox_min": [
        1250.0,
        900.0,
        98.0
      ],
      "bbox_max": [
        1445.0,
        940.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 940.0,
      "bbox_min": [
        1320.0,
        901.5384521484375,
        98.0
      ],
      "bbox_max": [
        1445.0,
        940.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1320.0,
      "bbox_min": [
        1320.0,
        901.5384521484375,
        98.0
      ],
      "bbox_max": [
        1340.0,
        927.6923217773438,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1340.0,
      "bbox_min": [
        1340.0,
        907.6923217773438,
        98.0
      ],
      "bbox_max": [
        1340.0,
        927.6923217773438,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        1390.0,
        957.859619140625,
        160.0
      ],
      "bbox_max": [
        1395.0,
        959.397216796875,
        161.1999969482422
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1395.0,
      "bbox_min": [
        1395.0,
        957.859619140625,
        160.0
      ],
      "bbox_max": [
        1395.0,
        959.397216796875,
        161.1999969482422
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1290.0,
      "bbox_min": [
        1260.0,
        502.3577880859375,
        100.0
      ],
      "bbox_max": [
        1910.0,
        720.0,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1600.0,
      "bbox_min": [
        1290.0,
        538.75,
        100.0
      ],
      "bbox_max": [
        1910.0,
        720.0,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 700.0,
      "bbox_min": [
        1600.0,
        560.0,
        100.0
      ],
      "bbox_max": [
        1910.0,
        720.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 100.0,
      "bbox_min": [
        1600.0,
        700.0,
        100.0
      ],
      "bbox_max": [
        1750.0,
        720.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1910.0,
      "bbox_min": [
        1910.0,
        560.0,
        149.0
      ],
      "bbox_max": [
        1910.0,
        650.0,
        199.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6305926442146301,
        -0.7761140465736389,
        -0.0
      ],
      "plane_d": 1294.6552734375,
      "bbox_min": [
        1290.0,
        538.75,
        140.0
      ],
      "bbox_max": [
        1390.0,
        700.0,
        338.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -670.0,
      "bbox_min": [
        1290.0,
        670.0,
        140.0
      ],
      "bbox_max": [
        1390.0,
        700.0,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -700.0,
      "bbox_min": [
        1290.0,
        670.0,
        220.0
      ],
      "bbox_max": [
        1390.0,
        700.0,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 257.9999694824219,
      "bbox_min": [
        1290.0,
        670.0,
        220.0
      ],
      "bbox_max": [
        1390.0,
        700.0,
        258.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.7848828434944153,
        -0.6196443438529968
      ],
      "plane_d": -389.54974365234375,
      "bbox_min": [
        1300.0,
        670.0,
        220.0
      ],
      "bbox_max": [
        1360.0,
        700.0,
        258.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1300.0,
      "bbox_min": [
        1300.0,
        670.0,
        220.0
      ],
      "bbox_max": [
        1350.0,
        700.0,
        258.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        0.0
      ],
      "plane_d": 1350.0,
      "bbox_min": [
        1350.0,
        670.0,
        220.0
      ],
      "bbox_max": [
        1350.0,
        700.0,
        258.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1260.0,
      "bbox_min": [
        1260.0,
        620.0,
        220.0
      ],
      "bbox_max": [
        1290.0,
        700.0,
        338.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 620.0,
      "bbox_min": [
        1260.0,
        620.0,
        220.0
      ],
      "bbox_max": [
        1290.0,
        700.0,
        338.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -700.0,
      "bbox_min": [
        1260.0,
        620.0,
        220.0
      ],
      "bbox_max": [
        1290.0,
        700.0,
        338.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 258.0,
      "bbox_min": [
        1260.0,
        620.0,
        220.0
      ],
      "bbox_max": [
        1290.0,
        700.0,
        258.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -670.0,
      "bbox_min": [
        1260.0,
        670.0,
        220.0
      ],
      "bbox_max": [
        1290.0,
        670.0,
        240.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.3451910614967346,
        0.9385325312614441,
        0.0
      ],
      "plane_d": 13.817352294921875,
      "bbox_min": [
        620.0,
        281.61761474609375,
        59.99999237060547
      ],
      "bbox_max": [
        1250.0,
        1105.8577880859375,
        810.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -650.0,
      "bbox_min": [
        620.0,
        281.61761474609375,
        59.99999237060547
      ],
      "bbox_max": [
        1250.0,
        1105.8577880859375,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944272398948669,
        -0.0,
        0.44721361994743347
      ],
      "plane_d": -590.3219604492188,
      "bbox_min": [
        620.0,
        281.61761474609375,
        60.0
      ],
      "bbox_max": [
        650.0,
        505.85784912109375,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        620.0,
        281.61761474609375,
        60.0
      ],
      "bbox_max": [
        650.0,
        505.85784912109375,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        620.0,
        281.61761474609375,
        60.0
      ],
      "bbox_max": [
        650.0,
        505.8578186035156,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09441325813531876,
        0.9955331087112427,
        0.0
      ],
      "plane_d": -220.8793182373047,
      "bbox_min": [
        620.0,
        281.61761474609375,
        78.0
      ],
      "bbox_max": [
        650.0,
        290.714111328125,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.672899067401886,
        0.7397342920303345,
        0.0
      ],
      "plane_d": -632.2486572265625,
      "bbox_min": [
        620.0,
        281.61761474609375,
        78.0
      ],
      "bbox_max": [
        630.0,
        290.714111328125,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09441325813531876,
        0.9955331087112427,
        0.0
      ],
      "plane_d": -220.8793182373047,
      "bbox_min": [
        621.0,
        281.61761474609375,
        60.0
      ],
      "bbox_max": [
        650.0,
        289.8044738769531,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.672899067401886,
        0.7397342920303345,
        0.0
      ],
      "plane_d": -632.2486572265625,
      "bbox_min": [
        621.0,
        281.61761474609375,
        60.0
      ],
      "bbox_max": [
        630.0,
        289.8044738769531,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09441325813531876,
        0.9955331087112427,
        0.0
      ],
      "plane_d": -220.8793182373047,
      "bbox_min": [
        620.0,
        281.61761474609375,
        80.0
      ],
      "bbox_max": [
        650.0,
        480.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        620.0,
        460.0,
        98.0
      ],
      "bbox_max": [
        650.0,
        480.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -480.0,
      "bbox_min": [
        624.1422119140625,
        480.0,
        98.0
      ],
      "bbox_max": [
        650.0,
        480.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.09441325813531876,
        0.9955331087112427,
        0.0
      ],
      "plane_d": -220.8793182373047,
      "bbox_min": [
        650.0,
        283.51434326171875,
        60.0
      ],
      "bbox_max": [
        866.760986328125,
        320.0,
        150.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": -309.9999694824219,
      "bbox_min": [
        720.0,
        300.0,
        60.0
      ],
      "bbox_max": [
        770.0,
        320.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44721361994743347,
        0.0,
        -0.8944272398948669
      ],
      "plane_d": -270.11700439453125,
      "bbox_min": [
        724.0,
        300.0,
        60.0
      ],
      "bbox_max": [
        770.0,
        310.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -79.99999237060547,
      "bbox_min": [
        760.0,
        300.0,
        80.0
      ],
      "bbox_max": [
        763.9999389648438,
        310.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 77.99999237060547,
      "bbox_min": [
        760.0,
        300.0,
        78.0
      ],
      "bbox_max": [
        770.0,
        310.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        763.9999389648438,
        300.0,
        78.0
      ],
      "bbox_max": [
        770.0,
        310.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -770.0,
      "bbox_min": [
        770.0,
        300.0,
        78.0
      ],
      "bbox_max": [
        770.0,
        310.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        760.0,
        310.0,
        78.0
      ],
      "bbox_max": [
        770.0,
        320.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 77.99999237060547,
      "bbox_min": [
        760.0,
        310.0,
        78.0
      ],
      "bbox_max": [
        770.0,
        320.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -770.0,
      "bbox_min": [
        770.0,
        310.0,
        78.0
      ],
      "bbox_max": [
        770.0,
        320.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        650.0,
        320.0,
        59.99999237060547
      ],
      "bbox_max": [
        1250.0,
        1105.8577880859375,
        810.0
      ],
      "face_count": 12
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        650.0,
        320.0,
        59.99999237060547
      ],
      "bbox_max": [
        1250.0,
        1105.8577880859375,
        100.0
      ],
      "face_count": 10
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1210.0,
      "bbox_min": [
        660.0260009765625,
        320.0,
        60.0
      ],
      "bbox_max": [
        1230.0,
        707.730224609375,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        1210.0,
        463.61309814453125,
        78.0
      ],
      "bbox_max": [
        1230.0,
        707.730224609375,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1230.0,
      "bbox_min": [
        1210.0,
        463.61309814453125,
        78.0
      ],
      "bbox_max": [
        1230.0,
        707.730224609375,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 463.61309814453125,
      "bbox_min": [
        1210.0,
        463.61309814453125,
        78.0
      ],
      "bbox_max": [
        1230.0,
        463.61309814453125,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -608.2105102539062,
      "bbox_min": [
        660.0260009765625,
        320.0,
        60.0
      ],
      "bbox_max": [
        1210.0,
        707.730224609375,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        660.0260009765625,
        324.3941650390625,
        60.0
      ],
      "bbox_max": [
        1200.0,
        650.0,
        80.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.8944272398948669,
        -0.0,
        0.44721361994743347
      ],
      "plane_d": -1100.1455078125,
      "bbox_min": [
        770.0,
        328.0721740722656,
        78.0
      ],
      "bbox_max": [
        1192.89697265625,
        641.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -770.0,
      "bbox_min": [
        770.0,
        328.0721740722656,
        78.0
      ],
      "bbox_max": [
        1191.0,
        483.6131286621094,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.5258789289873675e-06,
        1.0,
        0.0
      ],
      "plane_d": -483.61492919921875,
      "bbox_min": [
        1190.0,
        483.61309814453125,
        78.0
      ],
      "bbox_max": [
        1191.0,
        483.6131286621094,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.5258789289873675e-06,
        1.0,
        0.0
      ],
      "plane_d": -483.61492919921875,
      "bbox_min": [
        1190.0,
        483.61309814453125,
        78.0
      ],
      "bbox_max": [
        1192.89697265625,
        483.6131286621094,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944272398948669,
        -0.0,
        0.44721361994743347
      ],
      "plane_d": -1100.1455078125,
      "bbox_min": [
        1191.0,
        476.63616943359375,
        60.0
      ],
      "bbox_max": [
        1200.0,
        650.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        760.0,
        320.0,
        78.0
      ],
      "bbox_max": [
        1210.0,
        483.6131286621094,
        80.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.5258789289873675e-06,
        1.0,
        0.0
      ],
      "plane_d": -483.61492919921875,
      "bbox_min": [
        770.0,
        320.0,
        78.0
      ],
      "bbox_max": [
        1210.0,
        483.6131286621094,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -770.0,
      "bbox_min": [
        770.0,
        320.0,
        78.0
      ],
      "bbox_max": [
        770.0,
        329.1376647949219,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 463.61309814453125,
      "bbox_min": [
        1190.0,
        463.61309814453125,
        78.0
      ],
      "bbox_max": [
        1210.0,
        463.61309814453125,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9383428692817688,
        0.3457059860229492
      ],
      "plane_d": 636.09765625,
      "bbox_min": [
        844.1421508789062,
        700.0,
        60.0
      ],
      "bbox_max": [
        1200.0,
        707.730224609375,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9027172923088074,
        -0.0,
        0.43023425340652466
      ],
      "plane_d": -1109.0748291015625,
      "bbox_min": [
        850.8460083007812,
        700.0,
        60.0
      ],
      "bbox_max": [
        1200.0,
        707.730224609375,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6343928575515747,
        0.577269971370697,
        0.5141060948371887
      ],
      "plane_d": 91.6107177734375,
      "bbox_min": [
        850.8460083007812,
        706.7037963867188,
        78.19596862792969
      ],
      "bbox_max": [
        853.2420043945312,
        707.730224609375,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1210.0,
      "bbox_min": [
        851.8724365234375,
        707.730224609375,
        59.99999237060547
      ],
      "bbox_max": [
        1250.0,
        825.0,
        80.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 825.0,
      "bbox_min": [
        1210.0,
        707.730224609375,
        60.0
      ],
      "bbox_max": [
        1250.0,
        825.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        1210.0,
        707.730224609375,
        78.0
      ],
      "bbox_max": [
        1230.0,
        727.730224609375,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1230.0,
      "bbox_min": [
        1210.0,
        707.730224609375,
        78.0
      ],
      "bbox_max": [
        1230.0,
        727.730224609375,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -727.730224609375,
      "bbox_min": [
        1210.0,
        727.730224609375,
        78.0
      ],
      "bbox_max": [
        1230.0,
        727.730224609375,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6343928575515747,
        0.577269971370697,
        0.5141060948371887
      ],
      "plane_d": 91.6107177734375,
      "bbox_min": [
        851.8724365234375,
        707.730224609375,
        78.31001281738281
      ],
      "bbox_max": [
        867.0823364257812,
        722.9401245117188,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1200.0,
      "bbox_min": [
        1200.0,
        717.730224609375,
        59.99999237060547
      ],
      "bbox_max": [
        1210.0,
        765.730224609375,
        80.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -0.4657464921474457,
        -0.8849182724952698
      ],
      "plane_d": 407.96142578125,
      "bbox_min": [
        1200.0,
        717.730224609375,
        59.99999237060547
      ],
      "bbox_max": [
        1210.0,
        761.9302368164062,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 755.230224609375,
      "bbox_min": [
        1200.0,
        755.230224609375,
        63.52632141113281
      ],
      "bbox_max": [
        1210.0,
        755.230224609375,
        65.52631378173828
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        1200.0,
        717.730224609375,
        60.0
      ],
      "bbox_max": [
        1210.0,
        755.230224609375,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 717.730224609375,
      "bbox_min": [
        1200.0,
        717.730224609375,
        78.0
      ],
      "bbox_max": [
        1210.0,
        717.730224609375,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 755.230224609375,
      "bbox_min": [
        1200.0,
        755.230224609375,
        60.0
      ],
      "bbox_max": [
        1210.0,
        755.230224609375,
        63.52632141113281
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 825.0,
      "bbox_min": [
        1194.1214599609375,
        825.0,
        60.0
      ],
      "bbox_max": [
        1210.0,
        825.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -707.730224609375,
      "bbox_min": [
        650.0,
        363.9042053222656,
        80.0
      ],
      "bbox_max": [
        1250.0,
        1105.8577880859375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -680.0,
      "bbox_min": [
        650.0,
        363.9042053222656,
        80.0
      ],
      "bbox_max": [
        1190.468017578125,
        707.730224609375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -640.0,
      "bbox_min": [
        650.0,
        363.9042053222656,
        80.0
      ],
      "bbox_max": [
        1190.0,
        680.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34519103169441223,
        -0.9385324716567993,
        0.0
      ],
      "plane_d": 43.10931396484375,
      "bbox_min": [
        650.0,
        363.9042053222656,
        80.0
      ],
      "bbox_max": [
        1190.0,
        640.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1190.0,
      "bbox_min": [
        650.0,
        460.0,
        80.0
      ],
      "bbox_max": [
        1190.0,
        640.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        650.0,
        460.0,
        98.0
      ],
      "bbox_max": [
        660.0,
        480.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -480.0,
      "bbox_min": [
        650.0,
        480.0,
        98.0
      ],
      "bbox_max": [
        660.0,
        480.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 660.0,
      "bbox_min": [
        784.1422119140625,
        640.0,
        98.0
      ],
      "bbox_max": [
        1078.0,
        680.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 97.99999237060547,
      "bbox_min": [
        804.1421508789062,
        660.0,
        98.0
      ],
      "bbox_max": [
        1078.0,
        680.0,
        100.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1078.0,
      "bbox_min": [
        1078.0,
        660.0,
        98.0
      ],
      "bbox_max": [
        1078.0,
        680.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 97.99999237060547,
      "bbox_min": [
        784.1422119140625,
        640.0,
        98.0
      ],
      "bbox_max": [
        1004.0,
        660.0,
        100.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.44721361994743347,
        0.0,
        -0.8944272398948669
      ],
      "plane_d": -359.55975341796875,
      "bbox_min": [
        1000.0,
        640.0,
        98.0
      ],
      "bbox_max": [
        1004.0,
        660.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1000.0,
      "bbox_min": [
        1000.0,
        650.0,
        98.0
      ],
      "bbox_max": [
        1004.0,
        660.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": -649.9999389648438,
      "bbox_min": [
        1000.0,
        650.0,
        98.0
      ],
      "bbox_max": [
        1004.0,
        650.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -805.0,
      "bbox_min": [
        805.0,
        640.0,
        98.0
      ],
      "bbox_max": [
        805.0,
        660.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9383428692817688,
        0.3457059860229492
      ],
      "plane_d": 636.09765625,
      "bbox_min": [
        852.9127807617188,
        707.368408203125,
        80.0
      ],
      "bbox_max": [
        1190.468017578125,
        707.730224609375,
        80.98199462890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6343928575515747,
        0.577269971370697,
        0.5141060948371887
      ],
      "plane_d": 91.6107177734375,
      "bbox_min": [
        852.9127807617188,
        707.368408203125,
        80.0
      ],
      "bbox_max": [
        1190.468017578125,
        707.730224609375,
        80.98199462890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9027172923088074,
        -0.0,
        0.43023425340652466
      ],
      "plane_d": -1109.0748291015625,
      "bbox_min": [
        1190.0,
        707.368408203125,
        80.0
      ],
      "bbox_max": [
        1190.468017578125,
        707.730224609375,
        80.98199462890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 103.45501708984375,
      "bbox_min": [
        853.2420043945312,
        707.730224609375,
        80.0
      ],
      "bbox_max": [
        1250.0,
        1105.8577880859375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -867.8525390625,
      "bbox_min": [
        1014.1600952148438,
        707.730224609375,
        80.0
      ],
      "bbox_max": [
        1250.0,
        1103.6925048828125,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1190.0,
      "bbox_min": [
        1190.0,
        707.730224609375,
        80.0
      ],
      "bbox_max": [
        1250.0,
        825.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9589435458183289,
        -0.03134186938405037,
        0.281859815120697
      ],
      "plane_d": -1141.786865234375,
      "bbox_min": [
        1190.0,
        707.730224609375,
        80.0
      ],
      "bbox_max": [
        1250.0,
        825.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        1190.0,
        707.730224609375,
        80.0
      ],
      "bbox_max": [
        1250.0,
        825.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 825.0,
      "bbox_min": [
        1190.0,
        760.0,
        98.0
      ],
      "bbox_max": [
        1250.0,
        825.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 760.0,
      "bbox_min": [
        1190.0,
        760.0,
        98.0
      ],
      "bbox_max": [
        1250.0,
        760.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 825.0,
      "bbox_min": [
        1190.0,
        707.730224609375,
        80.0
      ],
      "bbox_max": [
        1250.0,
        825.0,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9027172923088074,
        -0.0,
        0.43023425340652466
      ],
      "plane_d": -1109.0748291015625,
      "bbox_min": [
        1190.0,
        707.730224609375,
        80.0
      ],
      "bbox_max": [
        1190.468017578125,
        713.2186279296875,
        80.98199462890625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8395703434944153,
        0.5432510375976562
      ],
      "plane_d": -782.281982421875,
      "bbox_min": [
        1014.1600952148438,
        867.8525390625,
        80.0
      ],
      "bbox_max": [
        1250.0,
        1103.6925048828125,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1016.0,
      "bbox_min": [
        1186.0,
        1016.0,
        80.0
      ],
      "bbox_max": [
        1250.0,
        1016.0,
        89.0526351928711
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1200.0,
      "bbox_min": [
        1186.0,
        930.0,
        80.0
      ],
      "bbox_max": [
        1250.0,
        1053.6925048828125,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1016.0,
      "bbox_min": [
        1186.0,
        1016.0,
        89.0526351928711
      ],
      "bbox_max": [
        1200.0,
        1016.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1016.0,
      "bbox_min": [
        1200.0,
        1016.0,
        89.0526351928711
      ],
      "bbox_max": [
        1250.0,
        1016.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -920.0,
      "bbox_min": [
        1080.0,
        887.8524780273438,
        80.0
      ],
      "bbox_max": [
        1250.0,
        920.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        1080.0,
        887.8524780273438,
        80.0
      ],
      "bbox_max": [
        1250.0,
        920.0,
        100.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 900.0,
      "bbox_min": [
        1125.0,
        887.8524780273438,
        98.0
      ],
      "bbox_max": [
        1250.0,
        920.0,
        100.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.371390700340271,
        0.0,
        0.9284767508506775
      ],
      "plane_d": 326.8238220214844,
      "bbox_min": [
        1125.0,
        900.0,
        98.0
      ],
      "bbox_max": [
        1140.0,
        920.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -910.0,
      "bbox_min": [
        1125.0,
        910.0,
        98.0
      ],
      "bbox_max": [
        1140.0,
        920.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1140.0,
      "bbox_min": [
        1140.0,
        910.0,
        98.0
      ],
      "bbox_max": [
        1140.0,
        920.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5547002553939819,
        -0.0,
        -0.8320503234863281
      ],
      "plane_d": 713.8992309570312,
      "bbox_min": [
        1137.0,
        887.8524780273438,
        98.0
      ],
      "bbox_max": [
        1150.0,
        900.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1150.0,
      "bbox_min": [
        1137.0,
        887.8524780273438,
        98.0
      ],
      "bbox_max": [
        1150.0,
        900.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 887.8524780273438,
      "bbox_min": [
        1137.0,
        887.8524780273438,
        98.0
      ],
      "bbox_max": [
        1150.0,
        887.8524780273438,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.371390700340271,
        0.0,
        0.9284767508506775
      ],
      "plane_d": 326.8238220214844,
      "bbox_min": [
        1080.0,
        900.0,
        80.0
      ],
      "bbox_max": [
        1130.0,
        910.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 900.0,
      "bbox_min": [
        1080.0,
        900.0,
        80.0
      ],
      "bbox_max": [
        1130.0,
        910.0,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": -909.9999389648438,
      "bbox_min": [
        1080.0,
        900.0,
        80.0
      ],
      "bbox_max": [
        1130.0,
        910.0,
        98.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1095.0,
      "bbox_min": [
        1095.0,
        900.0,
        84.0000228881836
      ],
      "bbox_max": [
        1095.0,
        910.0,
        86.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1095.0,
      "bbox_min": [
        1095.0,
        900.0,
        80.0
      ],
      "bbox_max": [
        1095.0,
        910.0,
        84.0000228881836
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6343928575515747,
        0.577269971370697,
        0.5141060948371887
      ],
      "plane_d": 91.6107177734375,
      "bbox_min": [
        853.2420043945312,
        707.730224609375,
        80.0
      ],
      "bbox_max": [
        1250.0,
        1105.8577880859375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8395703434944153,
        0.5432510375976562
      ],
      "plane_d": -782.281982421875,
      "bbox_min": [
        1013.6077270507812,
        867.8525390625,
        80.0
      ],
      "bbox_max": [
        1200.0,
        1055.8577880859375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1200.0,
      "bbox_min": [
        1200.0,
        1053.6925048828125,
        93.02027130126953
      ],
      "bbox_max": [
        1200.0,
        1055.8577880859375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -707.730224609375,
      "bbox_min": [
        660.0,
        324.5968933105469,
        100.0
      ],
      "bbox_max": [
        1250.0,
        1105.8577880859375,
        810.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -930.0,
      "bbox_min": [
        660.0,
        324.5968933105469,
        100.0
      ],
      "bbox_max": [
        1235.0,
        707.730224609375,
        250.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 120.0,
      "bbox_min": [
        660.0,
        324.5968933105469,
        100.0
      ],
      "bbox_max": [
        930.0,
        640.0,
        250.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -516.0,
      "bbox_min": [
        660.1421508789062,
        344.4016418457031,
        140.0
      ],
      "bbox_max": [
        930.0,
        640.0,
        250.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.3443901240825653,
        -0.9388266801834106,
        0.0
      ],
      "plane_d": 24.072601318359375,
      "bbox_min": [
        868.9588623046875,
        344.4016418457031,
        140.0
      ],
      "bbox_max": [
        930.0,
        366.79339599609375,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -516.0999755859375,
      "bbox_min": [
        715.0,
        516.0999755859375,
        145.0
      ],
      "bbox_max": [
        775.0,
        516.0999755859375,
        175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -460.0,
      "bbox_min": [
        660.0,
        344.4016418457031,
        120.0
      ],
      "bbox_max": [
        930.0,
        640.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3443901240825653,
        -0.9388266801834106,
        0.0
      ],
      "plane_d": 24.072601318359375,
      "bbox_min": [
        868.9588623046875,
        344.4016418457031,
        120.0
      ],
      "bbox_max": [
        930.0,
        366.79339599609375,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6246950626373291,
        0.7808688282966614,
        -0.0
      ],
      "plane_d": -1049.4876708984375,
      "bbox_min": [
        840.0,
        600.0,
        120.0
      ],
      "bbox_max": [
        930.0,
        640.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -640.0,
      "bbox_min": [
        840.0,
        640.0,
        120.0
      ],
      "bbox_max": [
        880.0,
        640.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -460.0,
      "bbox_min": [
        660.0,
        363.9042053222656,
        100.0
      ],
      "bbox_max": [
        930.0,
        640.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34519103169441223,
        -0.9385324716567993,
        0.0
      ],
      "plane_d": 43.10931396484375,
      "bbox_min": [
        864.5260009765625,
        363.9042053222656,
        100.0
      ],
      "bbox_max": [
        930.0,
        387.9854736328125,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -640.0,
      "bbox_min": [
        840.0,
        640.0,
        100.0
      ],
      "bbox_max": [
        930.0,
        640.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1060.0,
      "bbox_min": [
        930.0,
        366.79339599609375,
        100.0
      ],
      "bbox_max": [
        1235.0,
        707.730224609375,
        250.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.3443901240825653,
        -0.9388266801834106,
        0.0
      ],
      "plane_d": 24.072601318359375,
      "bbox_min": [
        1060.0,
        414.4813232421875,
        100.0
      ],
      "bbox_max": [
        1235.0,
        707.730224609375,
        250.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1190.0,
      "bbox_min": [
        1060.0,
        414.4813232421875,
        100.0
      ],
      "bbox_max": [
        1235.0,
        707.730224609375,
        250.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 120.0,
      "bbox_min": [
        1060.0,
        414.4813232421875,
        100.0
      ],
      "bbox_max": [
        1190.0,
        707.730224609375,
        250.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1150.0,
      "bbox_min": [
        1150.0,
        500.0,
        220.0
      ],
      "bbox_max": [
        1190.0,
        600.0,
        250.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -220.0,
      "bbox_min": [
        1150.0,
        500.0,
        220.0
      ],
      "bbox_max": [
        1190.0,
        600.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -600.0,
      "bbox_min": [
        1150.0,
        568.0,
        120.0
      ],
      "bbox_max": [
        1190.0,
        600.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -220.0,
      "bbox_min": [
        1150.0,
        568.0,
        220.0
      ],
      "bbox_max": [
        1190.0,
        600.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34519103169441223,
        -0.9385324716567993,
        0.0
      ],
      "plane_d": 43.10931396484375,
      "bbox_min": [
        1060.0,
        435.79931640625,
        100.0
      ],
      "bbox_max": [
        1190.0,
        707.730224609375,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -640.0,
      "bbox_min": [
        1060.0,
        640.0,
        100.0
      ],
      "bbox_max": [
        1190.0,
        707.730224609375,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1060.0,
        640.0,
        118.0
      ],
      "bbox_max": [
        1190.0,
        707.730224609375,
        120.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 687.730224609375,
      "bbox_min": [
        1060.0,
        640.0,
        118.0
      ],
      "bbox_max": [
        1170.0,
        687.730224609375,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1170.0,
      "bbox_min": [
        1170.0,
        640.0,
        118.0
      ],
      "bbox_max": [
        1170.0,
        687.730224609375,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 687.730224609375,
      "bbox_min": [
        1190.0,
        687.730224609375,
        118.0
      ],
      "bbox_max": [
        1235.0,
        707.730224609375,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1190.0,
        687.730224609375,
        118.0
      ],
      "bbox_max": [
        1235.0,
        707.730224609375,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1235.0,
      "bbox_min": [
        1235.0,
        687.730224609375,
        118.0
      ],
      "bbox_max": [
        1235.0,
        707.730224609375,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3443901240825653,
        -0.9388266801834106,
        0.0
      ],
      "plane_d": 24.072601318359375,
      "bbox_min": [
        930.0,
        366.79339599609375,
        100.0
      ],
      "bbox_max": [
        1060.0,
        707.730224609375,
        250.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 120.0,
      "bbox_min": [
        930.0,
        366.79339599609375,
        100.0
      ],
      "bbox_max": [
        1060.0,
        707.730224609375,
        250.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -250.0,
      "bbox_min": [
        930.0,
        500.0,
        120.0
      ],
      "bbox_max": [
        1060.0,
        640.0,
        250.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 950.0,
      "bbox_min": [
        930.0,
        500.0,
        120.0
      ],
      "bbox_max": [
        1060.0,
        640.0,
        250.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1040.0,
      "bbox_min": [
        1040.0,
        500.0,
        220.0
      ],
      "bbox_max": [
        1060.0,
        600.0,
        250.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -220.0,
      "bbox_min": [
        1040.0,
        500.0,
        220.0
      ],
      "bbox_max": [
        1060.0,
        600.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -600.0,
      "bbox_min": [
        930.0,
        600.0,
        120.0
      ],
      "bbox_max": [
        950.0,
        600.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -600.0,
      "bbox_min": [
        1040.0,
        584.0,
        120.0
      ],
      "bbox_max": [
        1060.0,
        600.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -220.0,
      "bbox_min": [
        1040.0,
        584.0,
        220.0
      ],
      "bbox_max": [
        1060.0,
        600.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.34519103169441223,
        -0.9385324716567993,
        0.0
      ],
      "plane_d": 43.10931396484375,
      "bbox_min": [
        930.0,
        387.9854736328125,
        100.0
      ],
      "bbox_max": [
        1060.0,
        707.730224609375,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -640.0,
      "bbox_min": [
        930.0,
        640.0,
        100.0
      ],
      "bbox_max": [
        1060.0,
        707.730224609375,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1000.0,
        640.0,
        100.0
      ],
      "bbox_max": [
        1060.0,
        707.730224609375,
        120.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.44721361994743347,
        0.0,
        0.8944272398948669
      ],
      "plane_d": 357.7709045410156,
      "bbox_min": [
        1036.0,
        640.0,
        118.0
      ],
      "bbox_max": [
        1040.0,
        650.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": -649.9999389648438,
      "bbox_min": [
        1036.0,
        650.0,
        118.0
      ],
      "bbox_max": [
        1040.0,
        650.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44721361994743347,
        0.0,
        0.8944272398948669
      ],
      "plane_d": 357.7709045410156,
      "bbox_min": [
        1000.0,
        640.0,
        100.0
      ],
      "bbox_max": [
        1040.0,
        650.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44721361994743347,
        0.0,
        -0.8944272398948669
      ],
      "plane_d": -359.55975341796875,
      "bbox_min": [
        1000.0,
        640.0,
        100.0
      ],
      "bbox_max": [
        1040.0,
        650.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.9999999403953552,
        0.0
      ],
      "plane_d": -649.9999389648438,
      "bbox_min": [
        1000.0,
        650.0,
        100.0
      ],
      "bbox_max": [
        1040.0,
        650.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 900.0,
      "bbox_min": [
        854.0377807617188,
        707.730224609375,
        100.0
      ],
      "bbox_max": [
        1250.0,
        1105.8577880859375,
        750.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1240.0,
      "bbox_min": [
        1074.1422119140625,
        908.76806640625,
        100.0
      ],
      "bbox_max": [
        1250.0,
        1105.8577880859375,
        750.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 1050.0,
      "bbox_min": [
        1240.0,
        916.4603881835938,
        100.0
      ],
      "bbox_max": [
        1250.0,
        1105.8577880859375,
        330.10211181640625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.25881895422935486,
        0.965925931930542
      ],
      "plane_d": -4.2996978759765625,
      "bbox_min": [
        1240.0,
        916.4603881835938,
        100.0
      ],
      "bbox_max": [
        1250.0,
        1050.0,
        283.118408203125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944272398948669,
        0.0,
        -0.44721361994743347
      ],
      "plane_d": 1180.6439208984375,
      "bbox_min": [
        1240.0,
        916.4603881835938,
        100.0
      ],
      "bbox_max": [
        1250.0,
        1050.0,
        204.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2630382478237152,
        -0.8548743724822998,
        -0.4472142457962036
      ],
      "plane_d": 528.8453369140625,
      "bbox_min": [
        1240.0,
        916.4603881835938,
        140.0
      ],
      "bbox_max": [
        1250.0,
        930.0,
        161.1999969482422
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -161.19998168945312,
      "bbox_min": [
        1240.0,
        916.4603881835938,
        160.0
      ],
      "bbox_max": [
        1250.0,
        919.5852661132812,
        161.1999969482422
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        1240.0,
        916.4603881835938,
        160.0
      ],
      "bbox_max": [
        1250.0,
        919.5852661132812,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1016.0,
      "bbox_min": [
        1240.0,
        1016.0,
        100.0
      ],
      "bbox_max": [
        1250.0,
        1016.0,
        160.00010681152344
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9992009997367859,
        -0.0,
        0.039968036115169525
      ],
      "plane_d": -1194.2449951171875,
      "bbox_min": [
        1074.1422119140625,
        908.76806640625,
        100.0
      ],
      "bbox_max": [
        1240.0,
        1090.8577880859375,
        580.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9992009997367859,
        0.039968036115169525
      ],
      "plane_d": 934.0531005859375,
      "bbox_min": [
        1074.1422119140625,
        930.0,
        100.0
      ],
      "bbox_max": [
        1191.199951171875,
        1016.0,
        580.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7068241238594055,
        0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": -1530.41552734375,
      "bbox_min": [
        1150.0,
        940.0,
        100.0
      ],
      "bbox_max": [
        1191.199951171875,
        1016.0,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7068241238594055,
        -0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": 1480.6552734375,
      "bbox_min": [
        1150.0,
        940.0,
        130.0
      ],
      "bbox_max": [
        1160.0,
        960.0,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1016.0,
      "bbox_min": [
        1186.0,
        1016.0,
        100.0
      ],
      "bbox_max": [
        1191.199951171875,
        1016.0,
        204.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9968152642250061,
        0.07974521815776825
      ],
      "plane_d": 916.6713256835938,
      "bbox_min": [
        1074.1422119140625,
        930.0,
        100.0
      ],
      "bbox_max": [
        1191.199951171875,
        957.0,
        580.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 930.0,
      "bbox_min": [
        1168.800048828125,
        930.0,
        100.0
      ],
      "bbox_max": [
        1191.199951171875,
        930.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 930.0,
      "bbox_min": [
        1074.1422119140625,
        930.0,
        100.0
      ],
      "bbox_max": [
        1170.000244140625,
        940.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8320503234863281,
        0.5547001957893372
      ],
      "plane_d": 701.69580078125,
      "bbox_min": [
        1074.1422119140625,
        930.0,
        130.0
      ],
      "bbox_max": [
        1170.0,
        940.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9993880391120911,
        0.034978583455085754
      ],
      "plane_d": 936.1267700195312,
      "bbox_min": [
        1094.1422119140625,
        950.0,
        380.0
      ],
      "bbox_max": [
        1180.0,
        957.0,
        580.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9968152642250061,
        -0.0,
        0.07974522560834885
      ],
      "plane_d": -1206.545166015625,
      "bbox_min": [
        1171.9998779296875,
        908.76806640625,
        100.0
      ],
      "bbox_max": [
        1240.0,
        1090.8577880859375,
        580.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9968152642250061,
        0.07974521815776825
      ],
      "plane_d": 916.6713256835938,
      "bbox_min": [
        1180.0,
        930.0,
        100.0
      ],
      "bbox_max": [
        1202.4000244140625,
        1055.8577880859375,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1200.0,
      "bbox_min": [
        1190.0,
        930.0,
        100.0
      ],
      "bbox_max": [
        1200.0,
        961.1998901367188,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 930.0,
      "bbox_min": [
        1190.0,
        930.0,
        100.0
      ],
      "bbox_max": [
        1200.0,
        930.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1016.0,
      "bbox_min": [
        1187.0400390625,
        959.9998168945312,
        100.0
      ],
      "bbox_max": [
        1202.4000244140625,
        1055.8577880859375,
        204.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1200.0,
      "bbox_min": [
        1190.0,
        1016.0,
        100.0
      ],
      "bbox_max": [
        1200.0,
        1055.8577880859375,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320502638816833,
        0.0,
        0.5547001957893372
      ],
      "plane_d": -1070.5714111328125,
      "bbox_min": [
        1190.0,
        1016.0,
        130.0
      ],
      "bbox_max": [
        1200.0,
        1055.8577880859375,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1200.0,
      "bbox_min": [
        1190.0,
        959.9998168945312,
        100.0
      ],
      "bbox_max": [
        1200.0,
        1016.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320502638816833,
        0.0,
        0.5547001957893372
      ],
      "plane_d": -1070.5714111328125,
      "bbox_min": [
        1190.0,
        960.0,
        130.0
      ],
      "bbox_max": [
        1200.0,
        1016.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9993880391120911,
        0.0,
        0.034978583455085754
      ],
      "plane_d": -1192.56982421875,
      "bbox_min": [
        1171.9998779296875,
        908.76806640625,
        100.0
      ],
      "bbox_max": [
        1240.0,
        1090.8577880859375,
        580.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9993880391120911,
        0.034978583455085754
      ],
      "plane_d": 936.1267700195312,
      "bbox_min": [
        1171.9998779296875,
        950.0,
        380.0
      ],
      "bbox_max": [
        1180.0,
        957.0,
        580.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        1194.0799560546875,
        908.76806640625,
        118.0
      ],
      "bbox_max": [
        1235.0,
        1090.0,
        204.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1215.0,
      "bbox_min": [
        1200.7999267578125,
        908.76806640625,
        118.0
      ],
      "bbox_max": [
        1235.0,
        1070.8577880859375,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1016.0,
      "bbox_min": [
        1215.0,
        1016.0,
        118.0
      ],
      "bbox_max": [
        1235.0,
        1016.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1016.0,
      "bbox_min": [
        1200.7999267578125,
        1016.0,
        118.0
      ],
      "bbox_max": [
        1215.0,
        1016.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1016.0,
      "bbox_min": [
        1194.0799560546875,
        1016.0,
        120.0
      ],
      "bbox_max": [
        1235.0,
        1016.0,
        204.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1016.0,
      "bbox_min": [
        1200.9599609375,
        1016.0,
        100.0
      ],
      "bbox_max": [
        1235.0,
        1016.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1016.0,
      "bbox_min": [
        1235.0,
        1016.0,
        100.0
      ],
      "bbox_max": [
        1240.0,
        1016.0,
        204.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1173.0,
      "bbox_min": [
        1101.1422119140625,
        957.0,
        580.0
      ],
      "bbox_max": [
        1173.0,
        1028.85791015625,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 957.0,
      "bbox_min": [
        1101.1422119140625,
        957.0,
        580.0
      ],
      "bbox_max": [
        1173.0,
        957.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        1215.0,
        900.0,
        118.0
      ],
      "bbox_max": [
        1250.0,
        919.5372924804688,
        161.1999969482422
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1215.0,
        900.0,
        118.0
      ],
      "bbox_max": [
        1235.0,
        914.9219360351562,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1235.0,
      "bbox_min": [
        1215.0,
        900.0,
        118.0
      ],
      "bbox_max": [
        1235.0,
        914.9219360351562,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1215.0,
      "bbox_min": [
        1215.0,
        900.0,
        118.0
      ],
      "bbox_max": [
        1215.0,
        908.76806640625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -161.19998168945312,
      "bbox_min": [
        1240.0,
        911.7310791015625,
        160.0
      ],
      "bbox_max": [
        1250.0,
        919.5372924804688,
        161.1999969482422
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1240.0,
      "bbox_min": [
        1240.0,
        911.7310791015625,
        160.0
      ],
      "bbox_max": [
        1240.0,
        916.4603881835938,
        161.1999969482422
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        854.0377807617188,
        707.730224609375,
        100.0
      ],
      "bbox_max": [
        1250.0,
        900.0,
        290.0
      ],
      "face_count": 18
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        866.4380493164062,
        707.730224609375,
        100.0
      ],
      "bbox_max": [
        1250.0,
        900.0,
        120.0
      ],
      "face_count": 10
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -867.8525390625,
      "bbox_min": [
        1014.1600952148438,
        707.730224609375,
        118.0
      ],
      "bbox_max": [
        1250.0,
        900.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1190.0,
      "bbox_min": [
        1190.0,
        707.730224609375,
        118.0
      ],
      "bbox_max": [
        1250.0,
        825.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1235.0,
      "bbox_min": [
        1190.0,
        707.730224609375,
        118.0
      ],
      "bbox_max": [
        1250.0,
        825.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1215.0,
      "bbox_min": [
        1190.0,
        707.730224609375,
        118.0
      ],
      "bbox_max": [
        1235.0,
        825.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 825.0,
      "bbox_min": [
        1215.0,
        825.0,
        118.0
      ],
      "bbox_max": [
        1235.0,
        825.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -780.0,
      "bbox_min": [
        1190.0,
        760.0,
        118.0
      ],
      "bbox_max": [
        1215.0,
        825.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 760.0,
      "bbox_min": [
        1190.0,
        760.0,
        118.0
      ],
      "bbox_max": [
        1215.0,
        760.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 825.0,
      "bbox_min": [
        1190.0,
        825.0,
        118.0
      ],
      "bbox_max": [
        1215.0,
        825.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 825.0,
      "bbox_min": [
        1235.0,
        825.0,
        118.0
      ],
      "bbox_max": [
        1250.0,
        825.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -887.8524780273438,
      "bbox_min": [
        1034.159912109375,
        867.8524780273438,
        118.0
      ],
      "bbox_max": [
        1235.0,
        900.0,
        120.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1235.0,
      "bbox_min": [
        1235.0,
        867.8524780273438,
        118.0
      ],
      "bbox_max": [
        1235.0,
        887.8524780273438,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547002553939819,
        -0.0,
        0.8320503234863281
      ],
      "plane_d": -715.5632934570312,
      "bbox_min": [
        1100.0,
        887.8524780273438,
        118.0
      ],
      "bbox_max": [
        1235.0,
        900.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1100.0,
      "bbox_min": [
        1100.0,
        887.8524780273438,
        118.0
      ],
      "bbox_max": [
        1100.0,
        900.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1215.0,
      "bbox_min": [
        1215.0,
        887.8524780273438,
        118.0
      ],
      "bbox_max": [
        1235.0,
        900.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1235.0,
      "bbox_min": [
        1235.0,
        887.8524780273438,
        118.0
      ],
      "bbox_max": [
        1235.0,
        900.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -867.8525390625,
      "bbox_min": [
        1014.1600952148438,
        707.730224609375,
        100.0
      ],
      "bbox_max": [
        1250.0,
        900.0,
        118.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1190.0,
      "bbox_min": [
        1190.0,
        707.730224609375,
        100.0
      ],
      "bbox_max": [
        1250.0,
        825.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 825.0,
      "bbox_min": [
        1190.0,
        825.0,
        100.0
      ],
      "bbox_max": [
        1250.0,
        825.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.5547002553939819,
        -0.0,
        -0.8320503234863281
      ],
      "plane_d": 713.8992309570312,
      "bbox_min": [
        1110.0,
        887.8524780273438,
        100.0
      ],
      "bbox_max": [
        1140.0,
        900.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5547002553939819,
        -0.0,
        0.8320503234863281
      ],
      "plane_d": -715.5632934570312,
      "bbox_min": [
        1110.0,
        887.8524780273438,
        100.0
      ],
      "bbox_max": [
        1140.0,
        900.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 887.8524780273438,
      "bbox_min": [
        1110.0,
        887.8524780273438,
        100.0
      ],
      "bbox_max": [
        1140.0,
        887.8524780273438,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        865.3554077148438,
        720.1305541992188,
        118.0
      ],
      "bbox_max": [
        1034.159912109375,
        887.8524780273438,
        120.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -887.8524780273438,
      "bbox_min": [
        1031.99462890625,
        887.8524780273438,
        118.0
      ],
      "bbox_max": [
        1034.159912109375,
        887.8524780273438,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -867.8525390625,
      "bbox_min": [
        854.0377807617188,
        707.730224609375,
        120.0
      ],
      "bbox_max": [
        1200.0,
        867.8525390625,
        290.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -170.0,
      "bbox_min": [
        854.0377807617188,
        707.730224609375,
        120.0
      ],
      "bbox_max": [
        1200.0,
        867.8525390625,
        290.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        0.7071067690849304,
        0.0
      ],
      "plane_d": 103.45501708984375,
      "bbox_min": [
        854.0377807617188,
        707.730224609375,
        120.0
      ],
      "bbox_max": [
        1200.0,
        867.8525390625,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1060.0,
      "bbox_min": [
        1060.0,
        707.730224609375,
        120.0
      ],
      "bbox_max": [
        1200.0,
        867.8525390625,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 747.730224609375,
      "bbox_min": [
        1060.0,
        747.730224609375,
        120.0
      ],
      "bbox_max": [
        1200.0,
        867.8525390625,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1200.0,
      "bbox_min": [
        1060.0,
        747.730224609375,
        120.0
      ],
      "bbox_max": [
        1200.0,
        867.8525390625,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1150.0,
      "bbox_min": [
        1060.0,
        747.730224609375,
        120.0
      ],
      "bbox_max": [
        1200.0,
        867.8525390625,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1100.0,
      "bbox_min": [
        1060.0,
        747.730224609375,
        120.0
      ],
      "bbox_max": [
        1150.0,
        867.8525390625,
        170.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -785.0,
      "bbox_min": [
        1100.0,
        750.0,
        120.0
      ],
      "bbox_max": [
        1150.0,
        867.8525390625,
        170.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -750.0,
      "bbox_min": [
        1100.0,
        750.0,
        120.0
      ],
      "bbox_max": [
        1140.0,
        785.0,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        1100.0,
        750.0,
        120.0
      ],
      "bbox_max": [
        1140.0,
        785.0,
        170.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 130.0,
      "bbox_min": [
        1130.0,
        761.0,
        120.0
      ],
      "bbox_max": [
        1140.0,
        780.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1140.0,
      "bbox_min": [
        1130.0,
        761.0,
        120.0
      ],
      "bbox_max": [
        1140.0,
        780.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -761.0,
      "bbox_min": [
        1130.0,
        761.0,
        120.0
      ],
      "bbox_max": [
        1140.0,
        780.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        1130.0,
        780.0,
        120.0
      ],
      "bbox_max": [
        1140.0,
        780.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1120.0,
      "bbox_min": [
        1100.0,
        750.0,
        120.0
      ],
      "bbox_max": [
        1130.0,
        785.0,
        170.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 130.0,
      "bbox_min": [
        1100.0,
        761.0,
        120.0
      ],
      "bbox_max": [
        1120.0,
        780.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -761.0,
      "bbox_min": [
        1100.0,
        761.0,
        120.0
      ],
      "bbox_max": [
        1120.0,
        780.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        1100.0,
        780.0,
        120.0
      ],
      "bbox_max": [
        1120.0,
        780.0,
        130.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 760.0,
      "bbox_min": [
        1120.0,
        760.0,
        130.0
      ],
      "bbox_max": [
        1130.0,
        785.0,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 130.0,
      "bbox_min": [
        1120.0,
        760.0,
        130.0
      ],
      "bbox_max": [
        1130.0,
        785.0,
        130.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1132.5,
      "bbox_min": [
        1100.0,
        825.0,
        120.0
      ],
      "bbox_max": [
        1150.0,
        867.8525390625,
        170.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -135.0,
      "bbox_min": [
        1132.5,
        825.0,
        120.0
      ],
      "bbox_max": [
        1150.0,
        867.8525390625,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 825.0,
      "bbox_min": [
        1132.5,
        825.0,
        120.0
      ],
      "bbox_max": [
        1150.0,
        825.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 145.0,
      "bbox_min": [
        1132.5,
        825.0,
        135.0
      ],
      "bbox_max": [
        1150.0,
        867.8525390625,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 825.0,
      "bbox_min": [
        1132.5,
        825.0,
        145.0
      ],
      "bbox_max": [
        1150.0,
        825.0,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1142.5,
      "bbox_min": [
        1142.5,
        825.0,
        135.0
      ],
      "bbox_max": [
        1150.0,
        867.8525390625,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 825.0,
      "bbox_min": [
        1142.5,
        825.0,
        135.0
      ],
      "bbox_max": [
        1150.0,
        825.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1117.5,
      "bbox_min": [
        1100.0,
        825.0,
        120.0
      ],
      "bbox_max": [
        1117.5,
        867.8525390625,
        170.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -135.0,
      "bbox_min": [
        1100.0,
        825.0,
        120.0
      ],
      "bbox_max": [
        1117.5,
        867.8525390625,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 825.0,
      "bbox_min": [
        1100.0,
        825.0,
        120.0
      ],
      "bbox_max": [
        1117.5,
        825.0,
        135.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 145.0,
      "bbox_min": [
        1100.0,
        825.0,
        135.0
      ],
      "bbox_max": [
        1117.5,
        867.8525390625,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 825.0,
      "bbox_min": [
        1100.0,
        825.0,
        145.0
      ],
      "bbox_max": [
        1117.5,
        825.0,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1107.5,
      "bbox_min": [
        1100.0,
        825.0,
        135.0
      ],
      "bbox_max": [
        1107.5,
        867.8525390625,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 825.0,
      "bbox_min": [
        1100.0,
        825.0,
        135.0
      ],
      "bbox_max": [
        1107.5,
        825.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 825.0,
      "bbox_min": [
        1060.0,
        825.0,
        120.0
      ],
      "bbox_max": [
        1100.0,
        825.0,
        170.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 825.0,
      "bbox_min": [
        1150.0,
        825.0,
        120.0
      ],
      "bbox_max": [
        1200.0,
        825.0,
        170.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 825.0,
      "bbox_min": [
        1039.16015625,
        707.730224609375,
        170.0
      ],
      "bbox_max": [
        1200.0,
        867.8525390625,
        290.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.8201950788497925,
        -0.3988734185695648,
        0.41009753942489624
      ],
      "plane_d": 1128.7607421875,
      "bbox_min": [
        1039.16015625,
        825.0,
        170.0
      ],
      "bbox_max": [
        1200.0,
        867.8525390625,
        290.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1200.0,
      "bbox_min": [
        1099.16015625,
        825.0,
        170.0
      ],
      "bbox_max": [
        1200.0,
        867.8525390625,
        290.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -290.0,
      "bbox_min": [
        1099.16015625,
        825.0,
        290.0
      ],
      "bbox_max": [
        1200.0,
        867.8525390625,
        290.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -199.99998474121094,
      "bbox_min": [
        1060.0,
        707.730224609375,
        170.0
      ],
      "bbox_max": [
        1190.0,
        825.0,
        200.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 747.730224609375,
      "bbox_min": [
        1100.0,
        747.730224609375,
        170.0
      ],
      "bbox_max": [
        1150.0,
        785.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -785.0,
      "bbox_min": [
        1100.0,
        747.730224609375,
        170.0
      ],
      "bbox_max": [
        1150.0,
        785.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1150.0,
      "bbox_min": [
        1100.0,
        747.730224609375,
        170.0
      ],
      "bbox_max": [
        1150.0,
        785.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1100.0,
      "bbox_min": [
        1100.0,
        747.730224609375,
        170.0
      ],
      "bbox_max": [
        1130.0,
        785.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        1120.0,
        750.0,
        170.0
      ],
      "bbox_max": [
        1130.0,
        760.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 760.0,
      "bbox_min": [
        1120.0,
        760.0,
        170.0
      ],
      "bbox_max": [
        1130.0,
        760.0,
        180.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 195.0,
      "bbox_min": [
        1060.0,
        707.730224609375,
        180.0
      ],
      "bbox_max": [
        1190.0,
        825.0,
        200.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -319.8031005859375,
      "bbox_min": [
        1060.0,
        707.730224609375,
        195.0
      ],
      "bbox_max": [
        1190.0,
        825.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 1271.1873779296875,
      "bbox_min": [
        1060.0,
        707.730224609375,
        195.0
      ],
      "bbox_max": [
        1190.0,
        825.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1190.0,
      "bbox_min": [
        1060.0,
        737.730224609375,
        195.0
      ],
      "bbox_max": [
        1190.0,
        825.0,
        200.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1060.0,
      "bbox_min": [
        1060.0,
        737.730224609375,
        195.0
      ],
      "bbox_max": [
        1190.0,
        825.0,
        200.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1100.0,
      "bbox_min": [
        1060.0,
        785.0,
        195.0
      ],
      "bbox_max": [
        1190.0,
        825.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1150.0,
      "bbox_min": [
        1150.0,
        785.0,
        195.0
      ],
      "bbox_max": [
        1190.0,
        825.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -785.0,
      "bbox_min": [
        1150.0,
        785.0,
        195.0
      ],
      "bbox_max": [
        1190.0,
        785.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -785.0,
      "bbox_min": [
        1060.0,
        785.0,
        195.0
      ],
      "bbox_max": [
        1100.0,
        785.0,
        200.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -709.0,
      "bbox_min": [
        1060.0,
        707.730224609375,
        180.0
      ],
      "bbox_max": [
        1190.0,
        825.0,
        195.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 190.0,
      "bbox_min": [
        1088.730224609375,
        707.730224609375,
        180.0
      ],
      "bbox_max": [
        1161.269775390625,
        709.0,
        195.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -319.8031005859375,
      "bbox_min": [
        1088.730224609375,
        707.730224609375,
        190.0
      ],
      "bbox_max": [
        1161.269775390625,
        709.0,
        195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 1271.1873779296875,
      "bbox_min": [
        1088.730224609375,
        707.730224609375,
        190.0
      ],
      "bbox_max": [
        1090.0,
        709.0,
        195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -183.5,
      "bbox_min": [
        1088.730224609375,
        707.730224609375,
        180.0
      ],
      "bbox_max": [
        1161.269775390625,
        709.0,
        183.5
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -319.8030090332031,
      "bbox_min": [
        1088.730224609375,
        707.730224609375,
        180.0
      ],
      "bbox_max": [
        1161.269775390625,
        709.0,
        183.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 1271.187255859375,
      "bbox_min": [
        1088.730224609375,
        707.730224609375,
        180.0
      ],
      "bbox_max": [
        1090.0,
        709.0,
        183.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 784.0,
      "bbox_min": [
        1060.0,
        709.0,
        180.0
      ],
      "bbox_max": [
        1190.0,
        825.0,
        195.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1100.0,
      "bbox_min": [
        1060.0,
        784.0,
        180.0
      ],
      "bbox_max": [
        1190.0,
        825.0,
        195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1150.0,
      "bbox_min": [
        1105.0,
        784.0,
        180.0
      ],
      "bbox_max": [
        1190.0,
        825.0,
        195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 820.0,
      "bbox_min": [
        1105.0,
        784.0,
        180.0
      ],
      "bbox_max": [
        1145.0,
        820.0,
        195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1145.0,
      "bbox_min": [
        1105.0,
        784.0,
        180.0
      ],
      "bbox_max": [
        1145.0,
        820.0,
        195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1105.0,
      "bbox_min": [
        1105.0,
        784.0,
        180.0
      ],
      "bbox_max": [
        1137.0,
        820.0,
        195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9486832618713379,
        0.3162277638912201
      ],
      "plane_d": 690.6414184570312,
      "bbox_min": [
        1113.0,
        788.0,
        180.0
      ],
      "bbox_max": [
        1137.0,
        812.0,
        183.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9486832618713379,
        0.0,
        0.3162277638912201
      ],
      "plane_d": 998.9634399414062,
      "bbox_min": [
        1113.0,
        788.0,
        180.0
      ],
      "bbox_max": [
        1137.0,
        812.0,
        183.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.9486832618713379,
        0.3162277638912201
      ],
      "plane_d": -827.2518310546875,
      "bbox_min": [
        1113.0,
        788.0,
        180.0
      ],
      "bbox_max": [
        1137.0,
        812.0,
        183.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9486832618713379,
        0.0,
        0.3162277638912201
      ],
      "plane_d": -1135.5738525390625,
      "bbox_min": [
        1114.0,
        788.0,
        180.0
      ],
      "bbox_max": [
        1137.0,
        812.0,
        183.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -182.99998474121094,
      "bbox_min": [
        1114.0,
        789.0,
        180.0
      ],
      "bbox_max": [
        1136.0,
        811.0,
        183.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1115.0,
      "bbox_min": [
        1115.0,
        790.0,
        180.0
      ],
      "bbox_max": [
        1135.0,
        810.0,
        183.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1135.0,
      "bbox_min": [
        1115.0,
        790.0,
        180.0
      ],
      "bbox_max": [
        1135.0,
        810.0,
        183.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 810.0,
      "bbox_min": [
        1115.0,
        790.0,
        180.0
      ],
      "bbox_max": [
        1135.0,
        810.0,
        183.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -790.0,
      "bbox_min": [
        1115.0,
        790.0,
        180.0
      ],
      "bbox_max": [
        1135.0,
        790.0,
        183.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -785.0,
      "bbox_min": [
        1150.0,
        784.0,
        180.0
      ],
      "bbox_max": [
        1190.0,
        785.0,
        195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1190.0,
      "bbox_min": [
        1190.0,
        784.0,
        180.0
      ],
      "bbox_max": [
        1190.0,
        785.0,
        195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -785.0,
      "bbox_min": [
        1060.0,
        784.0,
        180.0
      ],
      "bbox_max": [
        1100.0,
        785.0,
        195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1060.0,
      "bbox_min": [
        1060.0,
        784.0,
        180.0
      ],
      "bbox_max": [
        1060.0,
        785.0,
        195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1190.0,
      "bbox_min": [
        1060.0,
        709.0,
        180.0
      ],
      "bbox_max": [
        1190.0,
        784.0,
        195.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1060.0,
      "bbox_min": [
        1060.0,
        709.0,
        180.0
      ],
      "bbox_max": [
        1190.0,
        784.0,
        195.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -319.8031005859375,
      "bbox_min": [
        1060.0,
        709.0,
        180.0
      ],
      "bbox_max": [
        1190.0,
        784.0,
        195.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 1271.1873779296875,
      "bbox_min": [
        1060.0,
        709.0,
        180.0
      ],
      "bbox_max": [
        1190.0,
        784.0,
        195.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -1272.085205078125,
      "bbox_min": [
        1060.0,
        709.0,
        180.0
      ],
      "bbox_max": [
        1190.0,
        784.0,
        195.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 189.99998474121094,
      "bbox_min": [
        1060.0,
        709.0,
        183.5
      ],
      "bbox_max": [
        1090.0,
        739.0001220703125,
        190.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -183.49998474121094,
      "bbox_min": [
        1160.0,
        709.0,
        183.5
      ],
      "bbox_max": [
        1190.0,
        739.0001220703125,
        190.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 189.99998474121094,
      "bbox_min": [
        1160.0,
        709.0,
        190.0
      ],
      "bbox_max": [
        1190.0,
        739.0001220703125,
        190.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1061.0,
      "bbox_min": [
        1060.0,
        738.0,
        180.0
      ],
      "bbox_max": [
        1190.0,
        784.0,
        195.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -183.5,
      "bbox_min": [
        1060.0,
        738.0,
        183.5
      ],
      "bbox_max": [
        1061.0,
        780.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 190.0,
      "bbox_min": [
        1060.0,
        738.0,
        183.5
      ],
      "bbox_max": [
        1061.0,
        780.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        1060.0,
        780.0,
        183.5
      ],
      "bbox_max": [
        1061.0,
        780.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -770.0,
      "bbox_min": [
        1080.0,
        738.0,
        180.0
      ],
      "bbox_max": [
        1190.0,
        784.0,
        195.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 749.0,
      "bbox_min": [
        1080.0,
        738.0,
        180.0
      ],
      "bbox_max": [
        1190.0,
        770.0,
        195.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1170.0,
      "bbox_min": [
        1080.0,
        749.0,
        180.0
      ],
      "bbox_max": [
        1190.0,
        770.0,
        195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1080.0,
      "bbox_min": [
        1080.0,
        749.0,
        180.0
      ],
      "bbox_max": [
        1130.0,
        770.0,
        195.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1130.0,
      "bbox_min": [
        1120.0,
        749.0,
        180.0
      ],
      "bbox_max": [
        1130.0,
        760.0,
        190.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1120.0,
      "bbox_min": [
        1120.0,
        749.0,
        180.0
      ],
      "bbox_max": [
        1130.0,
        760.0,
        190.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 190.0,
      "bbox_min": [
        1120.0,
        749.0,
        180.0
      ],
      "bbox_max": [
        1130.0,
        760.0,
        190.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 760.0,
      "bbox_min": [
        1120.0,
        760.0,
        180.0
      ],
      "bbox_max": [
        1130.0,
        760.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1189.0,
      "bbox_min": [
        1189.0,
        749.0,
        180.0
      ],
      "bbox_max": [
        1190.0,
        770.0,
        195.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -183.5,
      "bbox_min": [
        1189.0,
        749.0,
        183.5
      ],
      "bbox_max": [
        1190.0,
        770.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 190.0,
      "bbox_min": [
        1189.0,
        749.0,
        190.0
      ],
      "bbox_max": [
        1190.0,
        770.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1189.0,
      "bbox_min": [
        1189.0,
        738.0,
        180.0
      ],
      "bbox_max": [
        1190.0,
        749.0,
        195.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -183.5,
      "bbox_min": [
        1189.0,
        738.0,
        183.5
      ],
      "bbox_max": [
        1190.0,
        749.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 190.0,
      "bbox_min": [
        1189.0,
        738.0,
        190.0
      ],
      "bbox_max": [
        1190.0,
        749.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1189.0,
      "bbox_min": [
        1189.0,
        770.0,
        180.0
      ],
      "bbox_max": [
        1190.0,
        784.0,
        195.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 780.0,
      "bbox_min": [
        1189.0,
        780.0,
        183.5
      ],
      "bbox_max": [
        1190.0,
        780.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1173.0,
      "bbox_min": [
        1135.85791015625,
        957.0,
        750.0
      ],
      "bbox_max": [
        1173.0,
        981.1421508789062,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 957.0,
      "bbox_min": [
        1135.85791015625,
        957.0,
        750.0
      ],
      "bbox_max": [
        1173.0,
        981.1421508789062,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.707107663154602,
        -0.7071058750152588,
        0.0
      ],
      "plane_d": 1496.9451904296875,
      "bbox_min": [
        1135.85791015625,
        957.0,
        750.0
      ],
      "bbox_max": [
        1160.0,
        981.1421508789062,
        803.63623046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 760.0,
      "bbox_min": [
        620.0,
        475.8577880859375,
        60.0
      ],
      "bbox_max": [
        1250.0,
        1130.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 950.0,
      "bbox_min": [
        760.0,
        900.0,
        60.0
      ],
      "bbox_max": [
        1250.0,
        1130.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        950.0,
        900.0,
        76.36363220214844
      ],
      "bbox_max": [
        1250.0,
        1130.0,
        750.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        950.0,
        900.0,
        76.36363220214844
      ],
      "bbox_max": [
        1250.0,
        1130.0,
        140.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1120.0,
      "bbox_min": [
        950.0,
        1120.0,
        76.36363220214844
      ],
      "bbox_max": [
        960.0,
        1120.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -21.21319580078125,
      "bbox_min": [
        950.0,
        920.0,
        78.88888549804688
      ],
      "bbox_max": [
        960.0,
        1120.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -930.0,
      "bbox_min": [
        950.0,
        930.0,
        78.88888549804688
      ],
      "bbox_max": [
        960.0,
        1120.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1120.0,
      "bbox_min": [
        950.0,
        1120.0,
        78.8888931274414
      ],
      "bbox_max": [
        960.0,
        1120.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1010.0,
      "bbox_min": [
        950.0,
        900.0,
        80.0
      ],
      "bbox_max": [
        1250.0,
        1130.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1120.0,
      "bbox_min": [
        1010.0,
        930.0,
        80.0
      ],
      "bbox_max": [
        1250.0,
        1130.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1010.0,
        1120.0,
        118.0
      ],
      "bbox_max": [
        1110.0,
        1130.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        1010.0,
        1120.0,
        120.0
      ],
      "bbox_max": [
        1110.0,
        1130.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9992009997367859,
        0.0,
        0.039968036115169525
      ],
      "plane_d": 1013.9891357421875,
      "bbox_min": [
        1010.0,
        930.0,
        80.0
      ],
      "bbox_max": [
        1250.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.10468478500843048,
        0.9945054650306702
      ],
      "plane_d": 17.796409606933594,
      "bbox_min": [
        1018.0,
        930.0,
        80.0
      ],
      "bbox_max": [
        1250.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 930.0,
      "bbox_min": [
        1018.0,
        930.0,
        80.0
      ],
      "bbox_max": [
        1250.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1200.0,
      "bbox_min": [
        1019.9999389648438,
        930.0,
        93.2481918334961
      ],
      "bbox_max": [
        1250.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9992009997367859,
        0.039968036115169525
      ],
      "plane_d": 934.0531005859375,
      "bbox_min": [
        1019.9999389648438,
        930.0,
        130.0
      ],
      "bbox_max": [
        1200.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9992009997367859,
        -0.0,
        0.039968036115169525
      ],
      "plane_d": -1194.2449951171875,
      "bbox_min": [
        1020.0,
        940.0,
        130.0
      ],
      "bbox_max": [
        1200.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7068241238594055,
        -0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": -81.4261474609375,
      "bbox_min": [
        1020.0,
        940.0,
        130.0
      ],
      "bbox_max": [
        1190.0,
        1080.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7068241238594055,
        0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": 31.665771484375,
      "bbox_min": [
        1020.0,
        970.0,
        130.0
      ],
      "bbox_max": [
        1020.7999877929688,
        1080.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7068241238594055,
        -0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": 1480.6552734375,
      "bbox_min": [
        1020.0,
        1079.5999755859375,
        130.0
      ],
      "bbox_max": [
        1020.7999877929688,
        1080.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320502638816833,
        0.0,
        0.5547001957893372
      ],
      "plane_d": -1070.5714111328125,
      "bbox_min": [
        1189.5999755859375,
        1049.191162109375,
        130.0
      ],
      "bbox_max": [
        1200.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7068241238594055,
        -0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": -81.4261474609375,
      "bbox_min": [
        1189.5999755859375,
        1080.0,
        130.0
      ],
      "bbox_max": [
        1200.0,
        1090.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9968152642250061,
        -0.0,
        0.07974521815776825
      ],
      "plane_d": -1206.545166015625,
      "bbox_min": [
        1193.33349609375,
        1083.7335205078125,
        130.0
      ],
      "bbox_max": [
        1200.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7068241238594055,
        -0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": -81.4261474609375,
      "bbox_min": [
        1193.33349609375,
        1083.7335205078125,
        130.0
      ],
      "bbox_max": [
        1200.0,
        1090.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8320503234863281,
        0.5547001957893372
      ],
      "plane_d": 701.69580078125,
      "bbox_min": [
        1019.9999389648438,
        930.0,
        130.0
      ],
      "bbox_max": [
        1080.808837890625,
        940.4000244140625,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7068241238594055,
        -0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": -81.4261474609375,
      "bbox_min": [
        1040.0,
        930.0,
        130.0
      ],
      "bbox_max": [
        1050.0,
        940.4000244140625,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9968152642250061,
        0.07974522560834885
      ],
      "plane_d": 916.6713256835938,
      "bbox_min": [
        1019.9999389648438,
        930.0,
        130.0
      ],
      "bbox_max": [
        1046.2667236328125,
        936.6666870117188,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7068241238594055,
        -0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": -81.4261474609375,
      "bbox_min": [
        1040.0,
        930.0,
        130.0
      ],
      "bbox_max": [
        1046.2667236328125,
        936.6666870117188,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1235.0,
      "bbox_min": [
        1215.0,
        1070.8577880859375,
        98.5113525390625
      ],
      "bbox_max": [
        1250.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1215.0,
        1070.8577880859375,
        118.0
      ],
      "bbox_max": [
        1234.1422119140625,
        1090.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        1215.0,
        1070.8577880859375,
        118.0
      ],
      "bbox_max": [
        1234.1422119140625,
        1090.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 1215.0,
      "bbox_min": [
        1215.0,
        1070.8577880859375,
        118.0
      ],
      "bbox_max": [
        1215.0,
        1085.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1250.0,
      "bbox_min": [
        1250.0,
        1105.8577880859375,
        98.5113525390625
      ],
      "bbox_max": [
        1250.0,
        1120.0,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.8320503234863281,
        0.0,
        0.5547001957893372
      ],
      "plane_d": 768.2598266601562,
      "bbox_min": [
        1010.0,
        930.0,
        80.0
      ],
      "bbox_max": [
        1020.3999633789062,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 930.0,
      "bbox_min": [
        1010.0,
        930.0,
        80.0
      ],
      "bbox_max": [
        1020.3999633789062,
        1090.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7068241238594055,
        0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": 31.665771484375,
      "bbox_min": [
        1010.0,
        930.0,
        130.0
      ],
      "bbox_max": [
        1020.3999633789062,
        1090.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9968152642250061,
        0.07974522560834885
      ],
      "plane_d": 916.6713256835938,
      "bbox_min": [
        1010.0,
        930.0,
        130.0
      ],
      "bbox_max": [
        1020.3999633789062,
        930.7999877929688,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9968152642250061,
        0.0,
        0.07974521815776825
      ],
      "plane_d": 996.4165649414062,
      "bbox_min": [
        1010.0,
        930.0,
        130.0
      ],
      "bbox_max": [
        1016.6666870117188,
        1120.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7068241238594055,
        0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": 31.665771484375,
      "bbox_min": [
        1010.0,
        930.0,
        130.0
      ],
      "bbox_max": [
        1016.6666870117188,
        1090.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9968152642250061,
        0.07974522560834885
      ],
      "plane_d": 916.6713256835938,
      "bbox_min": [
        1010.0,
        930.0,
        130.0
      ],
      "bbox_max": [
        1016.6666870117188,
        930.7999877929688,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7068241238594055,
        -0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": 1480.6552734375,
      "bbox_min": [
        1010.0,
        1083.7332763671875,
        130.0
      ],
      "bbox_max": [
        1016.6666870117188,
        1090.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1000.0,
      "bbox_min": [
        950.0,
        900.0,
        80.0
      ],
      "bbox_max": [
        1010.0,
        1130.0,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        950.0,
        900.0,
        80.0
      ],
      "bbox_max": [
        1000.0,
        1130.0,
        140.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 117.99999237060547,
      "bbox_min": [
        950.0,
        900.0,
        80.0
      ],
      "bbox_max": [
        1000.0,
        1130.0,
        120.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        950.0,
        900.0,
        118.0
      ],
      "bbox_max": [
        980.0,
        1130.0,
        120.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -41.21319580078125,
      "bbox_min": [
        950.0,
        900.0,
        118.0
      ],
      "bbox_max": [
        980.0,
        1130.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1120.0,
      "bbox_min": [
        950.0,
        920.0,
        118.0
      ],
      "bbox_max": [
        980.0,
        1130.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8237894773483276,
        -0.29381439089775085,
        -0.48481348156929016
      ],
      "plane_d": -413.284423828125,
      "bbox_min": [
        970.59326171875,
        1120.0,
        118.0
      ],
      "bbox_max": [
        975.3369750976562,
        1130.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.44721361994743347,
        0.0,
        0.8944272398948669
      ],
      "plane_d": 330.9380798339844,
      "bbox_min": [
        950.0,
        920.0,
        118.0
      ],
      "bbox_max": [
        980.0,
        990.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 969.9999389648438,
      "bbox_min": [
        976.0,
        970.0,
        118.0
      ],
      "bbox_max": [
        980.0,
        970.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -930.0,
      "bbox_min": [
        950.0,
        930.0,
        118.0
      ],
      "bbox_max": [
        960.0,
        930.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -99.99999237060547,
      "bbox_min": [
        950.0,
        920.0,
        80.0
      ],
      "bbox_max": [
        1000.0,
        1130.0,
        118.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 97.99999237060547,
      "bbox_min": [
        950.0,
        920.0,
        80.0
      ],
      "bbox_max": [
        1000.0,
        1130.0,
        100.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1100.0,
      "bbox_min": [
        950.0,
        920.0,
        98.0
      ],
      "bbox_max": [
        1000.0,
        1130.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9284767508506775,
        -0.371390700340271,
        0.0
      ],
      "plane_d": -475.3800964355469,
      "bbox_min": [
        950.0,
        1120.0,
        98.0
      ],
      "bbox_max": [
        980.0,
        1130.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1120.0,
      "bbox_min": [
        950.0,
        1120.0,
        98.0
      ],
      "bbox_max": [
        960.0,
        1120.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        980.0,
        1120.0,
        98.0
      ],
      "bbox_max": [
        980.0,
        1130.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -21.21319580078125,
      "bbox_min": [
        950.0,
        920.0,
        98.0
      ],
      "bbox_max": [
        960.0,
        1100.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        -0.0
      ],
      "plane_d": -959.9999389648438,
      "bbox_min": [
        960.0,
        1096.0,
        98.0
      ],
      "bbox_max": [
        960.0,
        1100.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -930.0,
      "bbox_min": [
        950.0,
        930.0,
        98.0
      ],
      "bbox_max": [
        960.0,
        930.0,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9284767508506775,
        -0.371390700340271,
        0.0
      ],
      "plane_d": -475.3800964355469,
      "bbox_min": [
        950.0,
        930.0,
        80.0
      ],
      "bbox_max": [
        964.0,
        1130.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1120.0,
      "bbox_min": [
        950.0,
        1120.0,
        80.0
      ],
      "bbox_max": [
        960.0,
        1120.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -930.0,
      "bbox_min": [
        950.0,
        930.0,
        80.0
      ],
      "bbox_max": [
        960.0,
        930.0,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1120.0,
      "bbox_min": [
        950.0,
        920.0,
        100.0
      ],
      "bbox_max": [
        980.0,
        1130.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8237894773483276,
        -0.29381439089775085,
        -0.48481348156929016
      ],
      "plane_d": -413.284423828125,
      "bbox_min": [
        960.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        974.159912109375,
        1130.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8304547071456909,
        -0.3321818709373474,
        -0.4472138285636902
      ],
      "plane_d": -380.4714660644531,
      "bbox_min": [
        960.0,
        1120.0,
        100.0
      ],
      "bbox_max": [
        968.667724609375,
        1130.0,
        108.66770935058594
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44721361994743347,
        0.0,
        -0.8944272398948669
      ],
      "plane_d": -332.7269287109375,
      "bbox_min": [
        950.0,
        920.0,
        100.0
      ],
      "bbox_max": [
        980.0,
        1100.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.9999999403953552,
        0.0
      ],
      "plane_d": 969.9999389648438,
      "bbox_min": [
        950.0,
        920.0,
        103.00000762939453
      ],
      "bbox_max": [
        980.0,
        1090.0,
        118.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 108.0,
      "bbox_min": [
        950.0,
        970.0,
        103.00000762939453
      ],
      "bbox_max": [
        960.0,
        1090.0,
        110.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -960.0,
      "bbox_min": [
        956.0,
        1070.0,
        108.0
      ],
      "bbox_max": [
        960.0,
        1084.0,
        110.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1070.0,
      "bbox_min": [
        956.0,
        1070.0,
        108.0
      ],
      "bbox_max": [
        960.0,
        1070.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.44721361994743347,
        -0.8944272398948669
      ],
      "plane_d": 579.5888671875,
      "bbox_min": [
        950.0,
        1080.0,
        103.00000762939453
      ],
      "bbox_max": [
        960.0,
        1090.0,
        108.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -110.0,
      "bbox_min": [
        950.0,
        970.0,
        105.0
      ],
      "bbox_max": [
        960.0,
        1086.0,
        110.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 108.0,
      "bbox_min": [
        950.0,
        970.0,
        105.0
      ],
      "bbox_max": [
        960.0,
        1086.0,
        110.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1070.0,
      "bbox_min": [
        950.0,
        1070.0,
        108.0
      ],
      "bbox_max": [
        960.0,
        1070.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.44721361994743347,
        -0.8944272398948669
      ],
      "plane_d": 579.5888671875,
      "bbox_min": [
        950.0,
        1080.0,
        105.0
      ],
      "bbox_max": [
        956.0,
        1086.0,
        108.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -21.21319580078125,
      "bbox_min": [
        950.0,
        920.0,
        103.00000762939453
      ],
      "bbox_max": [
        960.0,
        930.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -930.0,
      "bbox_min": [
        950.0,
        930.0,
        103.00000762939453
      ],
      "bbox_max": [
        960.0,
        930.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.44721361994743347,
        -0.8944272398948669
      ],
      "plane_d": 579.5888671875,
      "bbox_min": [
        950.0,
        920.0,
        100.0
      ],
      "bbox_max": [
        960.0,
        1100.0,
        108.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9999999403953552,
        0.0,
        -0.0
      ],
      "plane_d": -959.9999389648438,
      "bbox_min": [
        960.0,
        1080.0,
        100.0
      ],
      "bbox_max": [
        960.0,
        1100.0,
        108.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -21.21319580078125,
      "bbox_min": [
        950.0,
        920.0,
        100.0
      ],
      "bbox_max": [
        960.0,
        930.0,
        108.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -930.0,
      "bbox_min": [
        950.0,
        930.0,
        100.0
      ],
      "bbox_max": [
        960.0,
        930.0,
        108.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8237894773483276,
        -0.29381439089775085,
        -0.48481348156929016
      ],
      "plane_d": -413.284423828125,
      "bbox_min": [
        971.7703247070312,
        1120.0,
        120.0
      ],
      "bbox_max": [
        987.1072998046875,
        1130.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -21.21319580078125,
      "bbox_min": [
        950.0,
        920.0,
        120.0
      ],
      "bbox_max": [
        960.0,
        930.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -930.0,
      "bbox_min": [
        950.0,
        930.0,
        120.0
      ],
      "bbox_max": [
        960.0,
        930.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        1000.0,
        1120.0,
        118.0
      ],
      "bbox_max": [
        1010.0,
        1130.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        1000.0,
        1120.0,
        118.0
      ],
      "bbox_max": [
        1010.0,
        1130.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1120.0,
      "bbox_min": [
        1000.0,
        1120.0,
        118.0
      ],
      "bbox_max": [
        1010.0,
        1120.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9992009997367859,
        0.0,
        0.039968036115169525
      ],
      "plane_d": 1013.9891357421875,
      "bbox_min": [
        950.0,
        950.0,
        140.0
      ],
      "bbox_max": [
        1250.0,
        1130.0,
        580.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9992009997367859,
        -0.0,
        0.039968036115169525
      ],
      "plane_d": -1194.2449951171875,
      "bbox_min": [
        1020.3999633789062,
        950.0,
        140.0
      ],
      "bbox_max": [
        1250.0,
        1130.0,
        580.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7068241238594055,
        -0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": -81.4261474609375,
      "bbox_min": [
        1030.0,
        950.0,
        140.0
      ],
      "bbox_max": [
        1189.5999755859375,
        1080.0,
        580.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.9993880391120911,
        0.034978583455085754
      ],
      "plane_d": 936.1267700195312,
      "bbox_min": [
        1030.0,
        950.0,
        380.0
      ],
      "bbox_max": [
        1050.0,
        957.0,
        580.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9993880391120911,
        0.034978583455085754
      ],
      "plane_d": 936.1267700195312,
      "bbox_min": [
        1049.0,
        950.0,
        380.0
      ],
      "bbox_max": [
        1101.1422119140625,
        957.0,
        580.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7068241238594055,
        -0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": 1480.6552734375,
      "bbox_min": [
        1020.3999633789062,
        1070.0,
        140.0
      ],
      "bbox_max": [
        1040.0,
        1080.0,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9968152642250061,
        -0.0,
        0.07974521815776825
      ],
      "plane_d": -1206.545166015625,
      "bbox_min": [
        1173.0,
        1028.85791015625,
        140.0
      ],
      "bbox_max": [
        1250.0,
        1130.0,
        580.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7068241238594055,
        -0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": -81.4261474609375,
      "bbox_min": [
        1180.0,
        1045.85791015625,
        140.0
      ],
      "bbox_max": [
        1199.199951171875,
        1089.5999755859375,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8320502638816833,
        0.0,
        0.5547001957893372
      ],
      "plane_d": -1070.5714111328125,
      "bbox_min": [
        1190.0,
        1045.85791015625,
        140.0
      ],
      "bbox_max": [
        1193.3333740234375,
        1083.3333740234375,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9993880391120911,
        0.0,
        0.034978583455085754
      ],
      "plane_d": -1192.56982421875,
      "bbox_min": [
        1173.0,
        1028.85791015625,
        140.0
      ],
      "bbox_max": [
        1250.0,
        1130.0,
        580.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1240.0,
      "bbox_min": [
        1240.0,
        1095.8577880859375,
        140.0
      ],
      "bbox_max": [
        1250.0,
        1130.0,
        284.24432373046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8944272398948669,
        0.0,
        -0.44721361994743347
      ],
      "plane_d": 1180.6439208984375,
      "bbox_min": [
        1240.0,
        1095.8577880859375,
        140.0
      ],
      "bbox_max": [
        1250.0,
        1130.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9993880391120911,
        0.0,
        0.034978583455085754
      ],
      "plane_d": 1016.0777587890625,
      "bbox_min": [
        950.0,
        950.0,
        140.0
      ],
      "bbox_max": [
        1038.0,
        1130.0,
        580.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9993880391120911,
        0.034978583455085754
      ],
      "plane_d": 936.1267700195312,
      "bbox_min": [
        1030.0,
        950.0,
        380.0
      ],
      "bbox_max": [
        1038.0,
        957.0,
        580.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7068241238594055,
        0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": 31.665771484375,
      "bbox_min": [
        1010.7999877929688,
        960.4000244140625,
        140.0
      ],
      "bbox_max": [
        1030.0,
        1089.5999755859375,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7068241238594055,
        -0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": 1480.6552734375,
      "bbox_min": [
        1010.7999877929688,
        966.6666870117188,
        140.0
      ],
      "bbox_max": [
        1030.0,
        1089.5999755859375,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.8320503234863281,
        0.0,
        0.5547001957893372
      ],
      "plane_d": 768.2598266601562,
      "bbox_min": [
        1016.6666870117188,
        966.6666870117188,
        140.0
      ],
      "bbox_max": [
        1020.0,
        1083.3333740234375,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1120.0,
      "bbox_min": [
        950.0,
        1120.0,
        140.0
      ],
      "bbox_max": [
        987.1072998046875,
        1130.0,
        280.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9418852925300598,
        -0.33593469858169556,
        0.0
      ],
      "plane_d": -550.1356201171875,
      "bbox_min": [
        983.5406494140625,
        1120.0,
        140.0
      ],
      "bbox_max": [
        987.1072998046875,
        1130.0,
        280.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1037.0,
      "bbox_min": [
        1037.0,
        957.0,
        580.0
      ],
      "bbox_max": [
        1173.0,
        1093.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 957.0,
      "bbox_min": [
        1037.0,
        957.0,
        580.0
      ],
      "bbox_max": [
        1173.0,
        1093.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -1173.0,
      "bbox_min": [
        1173.0,
        1028.85791015625,
        580.0
      ],
      "bbox_max": [
        1173.0,
        1093.0,
        750.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9992009997367859,
        0.039968036115169525
      ],
      "plane_d": 934.0531005859375,
      "bbox_min": [
        950.0,
        900.0,
        140.0
      ],
      "bbox_max": [
        1094.14208984375,
        950.0,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9992009997367859,
        0.0,
        0.039968036115169525
      ],
      "plane_d": 1013.9891357421875,
      "bbox_min": [
        1020.4000244140625,
        940.4000244140625,
        140.0
      ],
      "bbox_max": [
        1055.0,
        950.0,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7068241238594055,
        -0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": -81.4261474609375,
      "bbox_min": [
        1050.0,
        940.4000244140625,
        140.0
      ],
      "bbox_max": [
        1055.0,
        950.0,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -41.21319580078125,
      "bbox_min": [
        995.8233032226562,
        940.3999633789062,
        140.0
      ],
      "bbox_max": [
        1008.2842407226562,
        950.0,
        245.16859436035156
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.693566083908081,
        -0.693566083908081,
        0.19476176798343658
      ],
      "plane_d": -83.2716064453125,
      "bbox_min": [
        995.8233032226562,
        943.5999755859375,
        220.0
      ],
      "bbox_max": [
        1008.2842407226562,
        950.0,
        245.16859436035156
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9968152642250061,
        0.07974522560834885
      ],
      "plane_d": 916.6713256835938,
      "bbox_min": [
        950.0,
        900.0,
        140.0
      ],
      "bbox_max": [
        1084.1422119140625,
        950.0,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.9968152642250061,
        0.0,
        0.07974521815776825
      ],
      "plane_d": 996.4165649414062,
      "bbox_min": [
        986.7498168945312,
        930.7999877929688,
        140.0
      ],
      "bbox_max": [
        1084.1422119140625,
        950.0,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7068241238594055,
        -0.7068241238594055,
        0.02827296406030655
      ],
      "plane_d": -81.4261474609375,
      "bbox_min": [
        1040.4000244140625,
        930.7999877929688,
        140.0
      ],
      "bbox_max": [
        1084.1422119140625,
        950.0,
        380.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8320503234863281,
        0.5547001957893372
      ],
      "plane_d": 701.69580078125,
      "bbox_min": [
        1046.6666259765625,
        936.6666870117188,
        140.0
      ],
      "bbox_max": [
        1084.1422119140625,
        940.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -41.21319580078125,
      "bbox_min": [
        986.7498168945312,
        930.7999877929688,
        140.0
      ],
      "bbox_max": [
        1001.8842163085938,
        944.6067504882812,
        263.4952392578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.693566083908081,
        -0.693566083908081,
        0.19476176798343658
      ],
      "plane_d": -83.2716064453125,
      "bbox_min": [
        986.7498168945312,
        937.2000122070312,
        220.0
      ],
      "bbox_max": [
        1001.8842163085938,
        944.6067504882812,
        263.4952392578125
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.693566083908081,
        -0.693566083908081,
        0.19476176798343658
      ],
      "plane_d": -83.2716064453125,
      "bbox_min": [
        950.0,
        900.0,
        140.0
      ],
      "bbox_max": [
        995.4842529296875,
        940.6796264648438,
        337.72265625
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -41.21319580078125,
      "bbox_min": [
        958.2842407226562,
        900.0,
        140.0
      ],
      "bbox_max": [
        995.4842529296875,
        937.2000122070312,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        760.0,
        900.0,
        60.0
      ],
      "bbox_max": [
        950.0,
        1121.3931884765625,
        600.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -110.0,
      "bbox_min": [
        780.0,
        900.0,
        60.0
      ],
      "bbox_max": [
        950.0,
        1120.0,
        140.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 970.0,
      "bbox_min": [
        780.0,
        900.0,
        60.0
      ],
      "bbox_max": [
        950.0,
        1120.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1120.0,
      "bbox_min": [
        900.0,
        1120.0,
        60.0
      ],
      "bbox_max": [
        950.0,
        1120.0,
        110.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.11043152958154678,
        0.0,
        0.9938837289810181
      ],
      "plane_d": 26.50357437133789,
      "bbox_min": [
        780.0,
        900.0,
        60.0
      ],
      "bbox_max": [
        950.0,
        970.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -930.0,
      "bbox_min": [
        780.0,
        900.0,
        60.0
      ],
      "bbox_max": [
        950.0,
        970.0,
        110.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -21.21319580078125,
      "bbox_min": [
        930.0,
        900.0,
        76.66666412353516
      ],
      "bbox_max": [
        950.0,
        920.0,
        110.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        930.0,
        900.0,
        80.0
      ],
      "bbox_max": [
        950.0,
        920.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -860.0,
      "bbox_min": [
        840.0,
        930.0,
        108.0
      ],
      "bbox_max": [
        860.0,
        970.0,
        110.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 107.99999237060547,
      "bbox_min": [
        840.0,
        930.0,
        108.0
      ],
      "bbox_max": [
        860.0,
        970.0,
        108.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -930.0,
      "bbox_min": [
        780.0,
        900.0,
        110.0
      ],
      "bbox_max": [
        950.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        930.0,
        900.0,
        118.0
      ],
      "bbox_max": [
        950.0,
        920.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1120.0,
      "bbox_min": [
        780.0,
        930.0,
        110.0
      ],
      "bbox_max": [
        950.0,
        1120.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3549693822860718,
        -0.9348779320716858,
        0.0
      ],
      "plane_d": 618.4806518554688,
      "bbox_min": [
        865.0,
        990.0,
        110.0
      ],
      "bbox_max": [
        925.0,
        1083.890869140625,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9112828373908997,
        0.4117811918258667,
        -0.0
      ],
      "plane_d": -1273.248046875,
      "bbox_min": [
        907.4263916015625,
        1006.109130859375,
        110.0
      ],
      "bbox_max": [
        925.0,
        1083.890869140625,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9112828373908997,
        -0.4117811918258667,
        0.0
      ],
      "plane_d": -412.62530517578125,
      "bbox_min": [
        907.4263916015625,
        1006.109130859375,
        110.0
      ],
      "bbox_max": [
        925.0,
        1045.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        780.0,
        930.0,
        110.0
      ],
      "bbox_max": [
        840.0,
        950.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        780.0,
        930.0,
        110.0
      ],
      "bbox_max": [
        840.0,
        950.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44721361994743347,
        0.0,
        0.8944272398948669
      ],
      "plane_d": -474.04644775390625,
      "bbox_min": [
        820.0,
        930.0,
        118.0
      ],
      "bbox_max": [
        824.0,
        950.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.44721361994743347,
        0.0,
        0.8944272398948669
      ],
      "plane_d": -474.04644775390625,
      "bbox_min": [
        824.0,
        930.0,
        110.0
      ],
      "bbox_max": [
        840.0,
        950.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        760.0,
        900.0,
        118.0
      ],
      "bbox_max": [
        780.0,
        950.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 117.99999237060547,
      "bbox_min": [
        760.0,
        900.0,
        118.0
      ],
      "bbox_max": [
        780.0,
        950.0,
        118.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 170.0,
      "bbox_min": [
        783.0528564453125,
        968.6068725585938,
        140.0
      ],
      "bbox_max": [
        950.0,
        1121.3931884765625,
        600.0
      ],
      "face_count": 7
    },
    {
      "plane_normal": [
        0.35496851801872253,
        -0.9348782300949097,
        0.0
      ],
      "plane_d": 598.481689453125,
      "bbox_min": [
        807.7501220703125,
        968.6068725585938,
        170.0
      ],
      "bbox_max": [
        950.0,
        1120.0,
        600.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.35496851801872253,
        -0.9348782300949097,
        -0.0
      ],
      "plane_d": 1212.5772705078125,
      "bbox_min": [
        807.7501220703125,
        968.6068725585938,
        170.0
      ],
      "bbox_max": [
        950.0,
        1120.0,
        600.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9112825989723206,
        -0.4117816090583801,
        0.0
      ],
      "plane_d": -432.6246337890625,
      "bbox_min": [
        885.0,
        990.3443603515625,
        170.0
      ],
      "bbox_max": [
        950.0,
        1120.0,
        600.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9112825989723206,
        0.4117816090583801,
        0.0
      ],
      "plane_d": -1293.248291015625,
      "bbox_min": [
        885.0,
        1045.0,
        170.0
      ],
      "bbox_max": [
        950.0,
        1120.0,
        600.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1120.0,
      "bbox_min": [
        885.0,
        1120.0,
        170.0
      ],
      "bbox_max": [
        913.0569458007812,
        1120.0,
        280.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1120.0,
      "bbox_min": [
        913.0569458007812,
        1120.0,
        170.0
      ],
      "bbox_max": [
        950.0,
        1120.0,
        280.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1120.0,
      "bbox_min": [
        822.5736083984375,
        990.0,
        140.0
      ],
      "bbox_max": [
        950.0,
        1120.0,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9112828373908997,
        0.4117811918258667,
        -0.0
      ],
      "plane_d": -1273.248046875,
      "bbox_min": [
        865.0,
        990.0,
        140.0
      ],
      "bbox_max": [
        925.0,
        1083.890869140625,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9112828373908997,
        -0.4117811918258667,
        0.0
      ],
      "plane_d": -412.62530517578125,
      "bbox_min": [
        865.0,
        990.0,
        140.0
      ],
      "bbox_max": [
        925.0,
        1045.0,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3549693822860718,
        -0.9348779320716858,
        0.0
      ],
      "plane_d": 618.4806518554688,
      "bbox_min": [
        865.0,
        990.0,
        140.0
      ],
      "bbox_max": [
        907.4263916015625,
        1023.7418212890625,
        170.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.9348785877227783,
        0.35496786236763,
        0.0
      ],
      "plane_d": -1176.133056640625,
      "bbox_min": [
        869.3509521484375,
        995.6954345703125,
        160.0
      ],
      "bbox_max": [
        880.0,
        1023.7418212890625,
        170.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.693566083908081,
        -0.693566083908081,
        0.19476176798343658
      ],
      "plane_d": -83.2716064453125,
      "bbox_min": [
        892.7614135742188,
        900.0,
        249.50100708007812
      ],
      "bbox_max": [
        950.0,
        924.7737426757812,
        453.3333435058594
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -140.0,
      "bbox_min": [
        760.0,
        615.8577880859375,
        60.0
      ],
      "bbox_max": [
        1044.1422119140625,
        900.0,
        570.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -680.0,
      "bbox_min": [
        760.0,
        615.8577880859375,
        60.0
      ],
      "bbox_max": [
        1044.1422119140625,
        900.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 97.99999237060547,
      "bbox_min": [
        760.0,
        615.8577880859375,
        60.0
      ],
      "bbox_max": [
        824.1422119140625,
        680.0,
        100.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        760.0,
        615.8578491210938,
        98.0
      ],
      "bbox_max": [
        824.1422119140625,
        680.0,
        100.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        -0.7063384652137756,
        0.7078742384910583,
        0.0
      ],
      "plane_d": 80.83029174804688,
      "bbox_min": [
        760.0,
        644.1637573242188,
        98.0
      ],
      "bbox_max": [
        770.0000610351562,
        654.1421508789062,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6324553489685059,
        0.6324553489685059,
        0.4472139775753021
      ],
      "plane_d": 55.386383056640625,
      "bbox_min": [
        760.0,
        615.8578491210938,
        60.0
      ],
      "bbox_max": [
        794.1422119140625,
        680.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -608.2105102539062,
      "bbox_min": [
        780.0,
        640.0,
        60.0
      ],
      "bbox_max": [
        794.1422119140625,
        650.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 676.1616821289062,
      "bbox_min": [
        760.0,
        676.1616821289062,
        78.0
      ],
      "bbox_max": [
        770.0,
        680.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -79.99999237060547,
      "bbox_min": [
        760.0,
        676.1616821289062,
        78.0
      ],
      "bbox_max": [
        770.0,
        680.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        760.0,
        676.1616821289062,
        78.0
      ],
      "bbox_max": [
        770.0,
        680.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -770.0,
      "bbox_min": [
        770.0,
        676.1616821289062,
        78.0
      ],
      "bbox_max": [
        770.0,
        680.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6343928575515747,
        0.577269971370697,
        0.5141060948371887
      ],
      "plane_d": 91.6107177734375,
      "bbox_min": [
        760.0,
        680.0,
        60.0
      ],
      "bbox_max": [
        1044.1422119140625,
        900.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        830.0,
        700.0,
        60.0
      ],
      "bbox_max": [
        1044.1422119140625,
        900.0,
        96.28055572509766
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.9383428692817688,
        0.3457059860229492
      ],
      "plane_d": 636.09765625,
      "bbox_min": [
        830.0,
        700.0,
        60.0
      ],
      "bbox_max": [
        850.8460083007812,
        706.7037963867188,
        78.19596862792969
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8395703434944153,
        0.5432510375976562
      ],
      "plane_d": -782.281982421875,
      "bbox_min": [
        1010.0,
        869.4655151367188,
        80.0
      ],
      "bbox_max": [
        1024.1422119140625,
        880.0,
        96.28055572509766
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -91.92388916015625,
      "bbox_min": [
        760.0,
        680.0,
        60.0
      ],
      "bbox_max": [
        1031.99462890625,
        900.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -21.21319580078125,
      "bbox_min": [
        760.0,
        680.0,
        60.0
      ],
      "bbox_max": [
        1028.1990966796875,
        900.0,
        140.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        760.0,
        730.0,
        118.0
      ],
      "bbox_max": [
        780.0,
        900.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 117.99999237060547,
      "bbox_min": [
        760.0,
        730.0,
        118.0
      ],
      "bbox_max": [
        780.0,
        900.0,
        118.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.07647191733121872,
        -0.07647191733121872,
        0.9941348433494568
      ],
      "plane_d": 57.35394287109375,
      "bbox_min": [
        760.0,
        680.0,
        60.0
      ],
      "bbox_max": [
        1028.1990966796875,
        900.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        910.0,
        830.0,
        80.0
      ],
      "bbox_max": [
        1028.1990966796875,
        900.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        760.0,
        680.0,
        60.0
      ],
      "bbox_max": [
        1017.8524780273438,
        900.0,
        120.0
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        760.0,
        701.7156982421875,
        118.0
      ],
      "bbox_max": [
        1017.8524780273438,
        900.0,
        120.0
      ],
      "face_count": 9
    },
    {
      "plane_normal": [
        -0.7073715925216675,
        0.7068419456481934,
        0.0
      ],
      "plane_d": 83.90362548828125,
      "bbox_min": [
        780.0,
        701.7156982421875,
        118.0
      ],
      "bbox_max": [
        1017.8524780273438,
        900.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.381051242351532,
        0.9245539903640747,
        0.0
      ],
      "plane_d": -434.4053649902344,
      "bbox_min": [
        1000.0,
        882.0,
        118.0
      ],
      "bbox_max": [
        1017.8524780273438,
        887.8524780273438,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -887.8524780273438,
      "bbox_min": [
        1014.2000122070312,
        887.8524780273438,
        118.0
      ],
      "bbox_max": [
        1017.8524780273438,
        887.8524780273438,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1000.0,
      "bbox_min": [
        1000.0,
        882.0,
        118.0
      ],
      "bbox_max": [
        1000.0,
        882.0472412109375,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -41.21319580078125,
      "bbox_min": [
        780.0,
        701.7156982421875,
        118.0
      ],
      "bbox_max": [
        1000.0,
        900.0,
        120.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        -0.7071068286895752,
        -0.0
      ],
      "plane_d": 1231.87353515625,
      "bbox_min": [
        780.0,
        735.8578491210938,
        118.0
      ],
      "bbox_max": [
        900.2081909179688,
        856.0660400390625,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -1081.87353515625,
      "bbox_min": [
        780.0,
        735.8578491210938,
        118.0
      ],
      "bbox_max": [
        794.1421508789062,
        750.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": -61.2132568359375,
      "bbox_min": [
        788.2843017578125,
        701.7156982421875,
        118.0
      ],
      "bbox_max": [
        1000.0,
        900.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -1141.87353515625,
      "bbox_min": [
        836.568603515625,
        764.1421508789062,
        118.0
      ],
      "bbox_max": [
        980.0,
        900.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        980.0,
        893.431396484375,
        118.0
      ],
      "bbox_max": [
        980.0,
        900.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        -0.0,
        -0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        850.7107543945312,
        748.4000244140625,
        118.0
      ],
      "bbox_max": [
        1000.0,
        900.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -1000.0,
      "bbox_min": [
        1000.0,
        882.0472412109375,
        118.0
      ],
      "bbox_max": [
        1000.0,
        900.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -1141.87353515625,
      "bbox_min": [
        850.7107543945312,
        748.4000244140625,
        118.0
      ],
      "bbox_max": [
        866.452880859375,
        764.1421508789062,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.45172518491744995,
        0.892157256603241
      ],
      "plane_d": -381.2560729980469,
      "bbox_min": [
        760.0,
        680.0,
        60.0
      ],
      "bbox_max": [
        770.0,
        725.5,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -770.0,
      "bbox_min": [
        760.0,
        680.0,
        60.0
      ],
      "bbox_max": [
        770.0,
        725.5,
        80.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        6.806619126109581e-07,
        -0.4517251253128052,
        -0.8921571969985962
      ],
      "plane_d": 379.4711608886719,
      "bbox_min": [
        760.0,
        680.0,
        60.0
      ],
      "bbox_max": [
        770.0,
        721.5499877929688,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        760.0,
        682.0499267578125,
        80.0
      ],
      "bbox_max": [
        770.0,
        686.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        760.0,
        680.0,
        78.0
      ],
      "bbox_max": [
        770.0,
        686.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        0.9999999403953552
      ],
      "plane_d": -79.99999237060547,
      "bbox_min": [
        760.0,
        680.0,
        80.0
      ],
      "bbox_max": [
        770.0,
        682.0499267578125,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 118.0,
      "bbox_min": [
        858.2843017578125,
        721.2131958007812,
        118.0
      ],
      "bbox_max": [
        1031.99462890625,
        887.8524780273438,
        120.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        858.2843017578125,
        721.2131958007812,
        118.0
      ],
      "bbox_max": [
        1031.99462890625,
        887.8524780273438,
        120.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -887.8524780273438,
      "bbox_min": [
        1017.8524780273438,
        887.8524780273438,
        118.0
      ],
      "bbox_max": [
        1031.99462890625,
        887.8524780273438,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.693566083908081,
        -0.693566083908081,
        0.19476176798343658
      ],
      "plane_d": -83.2716064453125,
      "bbox_min": [
        760.0,
        701.7157592773438,
        140.0
      ],
      "bbox_max": [
        958.2842407226562,
        900.0,
        570.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -41.21319580078125,
      "bbox_min": [
        760.0,
        701.7157592773438,
        140.0
      ],
      "bbox_max": [
        958.2842407226562,
        900.0,
        220.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 1037.0,
      "bbox_min": [
        1037.0,
        957.0,
        750.0
      ],
      "bbox_max": [
        1173.0,
        1093.0,
        810.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -1.0,
        -0.0
      ],
      "plane_d": 957.0,
      "bbox_min": [
        1037.0,
        957.0,
        750.0
      ],
      "bbox_max": [
        1173.0,
        1093.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -1173.0,
      "bbox_min": [
        1037.0,
        957.0,
        750.0
      ],
      "bbox_max": [
        1173.0,
        1093.0,
        810.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.707107663154602,
        -0.7071058750152588,
        0.0
      ],
      "plane_d": -65.76275634765625,
      "bbox_min": [
        1037.0,
        957.0,
        750.0
      ],
      "bbox_max": [
        1173.0,
        1080.0,
        803.63623046875
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7071067690849304,
        -0.7071067690849304,
        -0.0
      ],
      "plane_d": 1496.945068359375,
      "bbox_min": [
        1037.0,
        1055.85791015625,
        750.0
      ],
      "bbox_max": [
        1061.14208984375,
        1080.0,
        803.63623046875
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        620.0,
        475.8577880859375,
        60.0
      ],
      "bbox_max": [
        760.0,
        1120.0,
        300.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        620.0,
        980.0,
        120.0
      ],
      "bbox_max": [
        700.0,
        1000.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1000.0,
      "bbox_min": [
        620.0,
        980.0,
        120.0
      ],
      "bbox_max": [
        700.0,
        1000.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        620.0,
        980.0,
        160.0
      ],
      "bbox_max": [
        680.0,
        1000.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -720.0,
      "bbox_min": [
        680.0,
        980.0,
        80.0
      ],
      "bbox_max": [
        720.0,
        1110.0,
        190.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -0.9999999403953552
      ],
      "plane_d": 159.99998474121094,
      "bbox_min": [
        680.0,
        980.0,
        120.0
      ],
      "bbox_max": [
        720.0,
        1110.0,
        160.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        680.0,
        980.0,
        120.0
      ],
      "bbox_max": [
        720.0,
        1110.0,
        160.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1000.0,
      "bbox_min": [
        680.0,
        1000.0,
        120.0
      ],
      "bbox_max": [
        700.0,
        1000.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 940.0,
      "bbox_min": [
        620.0,
        475.8577880859375,
        60.0
      ],
      "bbox_max": [
        760.0,
        980.0,
        300.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": 840.7615966796875,
      "bbox_min": [
        620.0,
        940.0,
        60.0
      ],
      "bbox_max": [
        760.0,
        980.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944271802902222,
        -0.0,
        0.4472135901451111
      ],
      "plane_d": -679.7646484375,
      "bbox_min": [
        720.0,
        970.0,
        60.0
      ],
      "bbox_max": [
        730.0,
        980.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -720.0,
      "bbox_min": [
        720.0,
        979.0,
        78.0
      ],
      "bbox_max": [
        720.0,
        980.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        620.0,
        940.0,
        78.0
      ],
      "bbox_max": [
        760.0,
        980.0,
        80.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 77.99999237060547,
      "bbox_min": [
        720.0,
        940.0,
        78.0
      ],
      "bbox_max": [
        760.0,
        980.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -720.0,
      "bbox_min": [
        720.0,
        960.0,
        78.0
      ],
      "bbox_max": [
        720.0,
        980.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -79.99999237060547,
      "bbox_min": [
        620.0,
        475.8577880859375,
        60.0
      ],
      "bbox_max": [
        760.0,
        940.0,
        240.0
      ],
      "face_count": 16
    },
    {
      "plane_normal": [
        -0.7071071863174438,
        0.707106351852417,
        0.0
      ],
      "plane_d": 45.15484619140625,
      "bbox_min": [
        620.0,
        475.8577880859375,
        60.0
      ],
      "bbox_max": [
        760.0,
        940.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.6324553489685059,
        0.6324553489685059,
        0.4472139775753021
      ],
      "plane_d": 55.386383056640625,
      "bbox_min": [
        620.0,
        540.0,
        60.0
      ],
      "bbox_max": [
        760.0,
        696.142333984375,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        620.0,
        540.0,
        78.0
      ],
      "bbox_max": [
        760.0,
        696.142333984375,
        80.0
      ],
      "face_count": 12
    },
    {
      "plane_normal": [
        0.9243307113647461,
        -0.381592333316803,
        0.0
      ],
      "plane_d": -444.47320556640625,
      "bbox_min": [
        754.1616821289062,
        662.01953125,
        78.0
      ],
      "bbox_max": [
        760.0,
        676.1616821289062,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -75.154296875,
      "bbox_min": [
        638.0,
        540.0,
        78.0
      ],
      "bbox_max": [
        710.9116821289062,
        611.698486328125,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9483067989349365,
        0.31735536456108093,
        0.0
      ],
      "plane_d": -778.2506713867188,
      "bbox_min": [
        638.0,
        540.0,
        78.0
      ],
      "bbox_max": [
        639.9603271484375,
        545.8578491210938,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8944272398948669,
        -0.0,
        0.44721361994743347
      ],
      "plane_d": -590.3219604492188,
      "bbox_min": [
        620.0,
        475.8577880859375,
        60.0
      ],
      "bbox_max": [
        684.1421508789062,
        540.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": -491.93499755859375,
      "bbox_min": [
        620.0,
        510.0,
        60.0
      ],
      "bbox_max": [
        630.0,
        520.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -650.0,
      "bbox_min": [
        650.0,
        505.8578186035156,
        78.0
      ],
      "bbox_max": [
        650.0,
        507.27203369140625,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        623.85791015625,
        487.2720031738281,
        78.0
      ],
      "bbox_max": [
        650.0,
        540.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -650.0,
      "bbox_min": [
        650.0,
        505.8578186035156,
        78.0
      ],
      "bbox_max": [
        650.0,
        510.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -560.0,
      "bbox_min": [
        620.0,
        556.14208984375,
        60.0
      ],
      "bbox_max": [
        760.0,
        940.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        620.0,
        556.14208984375,
        78.0
      ],
      "bbox_max": [
        623.85791015625,
        560.0,
        78.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -0.9999999403953552
      ],
      "plane_d": 77.99999237060547,
      "bbox_min": [
        740.0,
        676.1422729492188,
        78.0
      ],
      "bbox_max": [
        760.0,
        940.0,
        78.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.8944271206855774,
        -0.0,
        0.4472135603427887
      ],
      "plane_d": -679.7646484375,
      "bbox_min": [
        620.0,
        590.0,
        60.0
      ],
      "bbox_max": [
        740.0,
        930.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6324553489685059,
        -0.6324553489685059,
        0.4472139775753021
      ],
      "plane_d": -45.806488037109375,
      "bbox_min": [
        620.0,
        590.0,
        60.0
      ],
      "bbox_max": [
        730.0,
        930.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -858.6500854492188,
      "bbox_min": [
        620.0,
        704.1421508789062,
        60.0
      ],
      "bbox_max": [
        730.0,
        930.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        720.0,
        704.1421508789062,
        78.0
      ],
      "bbox_max": [
        721.0000610351562,
        750.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 704.1422119140625,
      "bbox_min": [
        720.0,
        704.1421508789062,
        78.0
      ],
      "bbox_max": [
        721.0000610351562,
        704.1422119140625,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        652.263427734375,
        611.698486328125,
        78.0
      ],
      "bbox_max": [
        721.0000610351562,
        657.1543579101562,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.7072440385818481,
        0.7069695591926575,
        0.0
      ],
      "plane_d": 45.334869384765625,
      "bbox_min": [
        665.698486328125,
        625.8406372070312,
        78.0
      ],
      "bbox_max": [
        721.0000610351562,
        657.1543579101562,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        0.7071067690849304,
        2.1591460608760826e-05
      ],
      "plane_d": -930.2283935546875,
      "bbox_min": [
        665.698486328125,
        625.8406372070312,
        78.0
      ],
      "bbox_max": [
        689.698486328125,
        649.8406372070312,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        720.0,
        656.1539306640625,
        78.0
      ],
      "bbox_max": [
        740.0,
        750.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 704.1422119140625,
      "bbox_min": [
        720.0,
        704.1421508789062,
        78.0
      ],
      "bbox_max": [
        740.0,
        704.1422119140625,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 750.0,
      "bbox_min": [
        620.0,
        475.8577880859375,
        80.0
      ],
      "bbox_max": [
        760.0,
        920.0,
        240.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -720.0,
      "bbox_min": [
        620.0,
        750.0,
        80.0
      ],
      "bbox_max": [
        720.0,
        920.0,
        240.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -920.0,
      "bbox_min": [
        620.0,
        920.0,
        80.0
      ],
      "bbox_max": [
        720.0,
        920.0,
        240.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.7063384652137756,
        0.7078742384910583,
        0.0
      ],
      "plane_d": 80.83029174804688,
      "bbox_min": [
        620.0,
        475.8577880859375,
        80.0
      ],
      "bbox_max": [
        760.0,
        644.163818359375,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        620.0,
        475.8577880859375,
        98.0
      ],
      "bbox_max": [
        760.0,
        644.163818359375,
        190.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        620.0,
        475.8577880859375,
        98.0
      ],
      "bbox_max": [
        760.0,
        644.163818359375,
        100.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -480.0,
      "bbox_min": [
        620.0,
        480.0,
        98.0
      ],
      "bbox_max": [
        624.1422119140625,
        480.0,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -516.0,
      "bbox_min": [
        620.0,
        485.0,
        140.0
      ],
      "bbox_max": [
        660.1421508789062,
        516.0,
        190.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 155.0,
      "bbox_min": [
        620.0,
        485.0,
        140.0
      ],
      "bbox_max": [
        660.1421508789062,
        516.0,
        156.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -156.0,
      "bbox_min": [
        620.0,
        485.0,
        155.0
      ],
      "bbox_max": [
        625.0,
        495.0,
        156.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -625.0,
      "bbox_min": [
        620.0,
        485.0,
        155.0
      ],
      "bbox_max": [
        625.0,
        495.0,
        156.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -495.0,
      "bbox_min": [
        620.0,
        495.0,
        155.0
      ],
      "bbox_max": [
        625.0,
        495.0,
        156.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 140.0,
      "bbox_min": [
        660.0,
        515.8578491210938,
        140.0
      ],
      "bbox_max": [
        660.1421508789062,
        516.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.3629886209964752,
        0.3629886209964752,
        0.8581832647323608
      ],
      "plane_d": -535.9135131835938,
      "bbox_min": [
        658.9852905273438,
        555.0899658203125,
        80.0
      ],
      "bbox_max": [
        696.76953125,
        597.5563354492188,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": 65.15435791015625,
      "bbox_min": [
        658.9852905273438,
        555.0899658203125,
        80.0
      ],
      "bbox_max": [
        696.76953125,
        597.5563354492188,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": -75.154296875,
      "bbox_min": [
        658.9852905273438,
        555.0899658203125,
        80.0
      ],
      "bbox_max": [
        696.76953125,
        590.4852905273438,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        658.9852905273438,
        559.7703247070312,
        98.0
      ],
      "bbox_max": [
        673.1273803710938,
        573.9141845703125,
        100.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        658.9852905273438,
        559.7703857421875,
        98.0
      ],
      "bbox_max": [
        673.1273803710938,
        566.8431396484375,
        98.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 98.0,
      "bbox_min": [
        666.0545654296875,
        555.0899658203125,
        98.0
      ],
      "bbox_max": [
        677.8394165039062,
        566.8431396484375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        666.0545654296875,
        555.0899658203125,
        98.0
      ],
      "bbox_max": [
        677.8394165039062,
        566.8431396484375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7032982110977173,
        0.7108950018882751,
        -0.0
      ],
      "plane_d": -876.375244140625,
      "bbox_min": [
        673.1273803710938,
        562.1814575195312,
        98.0
      ],
      "bbox_max": [
        677.8394165039062,
        566.8431396484375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7032982110977173,
        0.7108950018882751,
        -0.0
      ],
      "plane_d": -876.375244140625,
      "bbox_min": [
        673.1273803710938,
        562.1563720703125,
        99.9787368774414
      ],
      "bbox_max": [
        677.8394165039062,
        566.8431396484375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -100.0,
      "bbox_min": [
        673.1273803710938,
        562.1563720703125,
        100.0
      ],
      "bbox_max": [
        677.8394165039062,
        566.8431396484375,
        100.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        360.0,
        318.8201904296875,
        60.0
      ],
      "bbox_max": [
        620.0,
        1130.0,
        460.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 1000.0,
      "bbox_min": [
        440.0,
        980.0,
        120.0
      ],
      "bbox_max": [
        620.0,
        1130.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -490.0,
      "bbox_min": [
        440.0,
        1000.0,
        190.0
      ],
      "bbox_max": [
        490.0,
        1130.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": -551.5433349609375,
      "bbox_min": [
        440.0,
        1000.0,
        290.0
      ],
      "bbox_max": [
        490.0,
        1130.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 160.0,
      "bbox_min": [
        440.0,
        980.0,
        120.0
      ],
      "bbox_max": [
        620.0,
        1000.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -490.0,
      "bbox_min": [
        440.0,
        980.0,
        190.0
      ],
      "bbox_max": [
        490.0,
        1000.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.0,
        0.7071068286895752
      ],
      "plane_d": -551.5433349609375,
      "bbox_min": [
        440.0,
        980.0,
        290.0
      ],
      "bbox_max": [
        490.0,
        1000.0,
        340.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        1.0
      ],
      "plane_d": -120.0,
      "bbox_min": [
        440.0,
        980.0,
        120.0
      ],
      "bbox_max": [
        620.0,
        1000.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -440.0,
      "bbox_min": [
        440.0,
        980.0,
        120.0
      ],
      "bbox_max": [
        440.0,
        1000.0,
        160.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 940.0,
      "bbox_min": [
        360.0,
        318.8201904296875,
        60.0
      ],
      "bbox_max": [
        620.0,
        980.0,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        360.0,
        940.0,
        60.0
      ],
      "bbox_max": [
        620.0,
        980.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": 840.7615966796875,
      "bbox_min": [
        360.0,
        970.0,
        60.0
      ],
      "bbox_max": [
        620.0,
        980.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.6000000238418579,
        0.8000000715255737
      ],
      "plane_d": 492.0,
      "bbox_min": [
        360.0,
        960.0,
        100.0
      ],
      "bbox_max": [
        440.0,
        980.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 100.0,
      "bbox_min": [
        360.0,
        960.0,
        100.0
      ],
      "bbox_max": [
        440.0,
        980.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 960.0,
      "bbox_min": [
        360.0,
        960.0,
        100.0
      ],
      "bbox_max": [
        440.0,
        980.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -440.0,
      "bbox_min": [
        440.0,
        960.0,
        100.0
      ],
      "bbox_max": [
        440.0,
        980.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        -0.0
      ],
      "plane_d": -1003.95166015625,
      "bbox_min": [
        360.0,
        318.8201904296875,
        60.0
      ],
      "bbox_max": [
        620.0,
        930.0,
        460.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -79.99999237060547,
      "bbox_min": [
        360.0,
        318.8201904296875,
        60.0
      ],
      "bbox_max": [
        620.0,
        930.0,
        460.0
      ],
      "face_count": 8
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -560.0,
      "bbox_min": [
        360.0,
        400.0,
        60.0
      ],
      "bbox_max": [
        620.0,
        930.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        480.0,
        540.0,
        78.0
      ],
      "bbox_max": [
        620.0,
        560.0,
        78.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": -491.93499755859375,
      "bbox_min": [
        360.0,
        400.0,
        60.0
      ],
      "bbox_max": [
        620.0,
        540.0,
        80.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.8944272398948669,
        -0.0,
        0.44721361994743347
      ],
      "plane_d": -442.9906921386719,
      "bbox_min": [
        455.27862548828125,
        476.08453369140625,
        60.0
      ],
      "bbox_max": [
        498.0239562988281,
        520.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.2344612514425535e-06,
        1.0,
        0.0
      ],
      "plane_d": -481.1792297363281,
      "bbox_min": [
        455.27862548828125,
        481.1797790527344,
        78.0
      ],
      "bbox_max": [
        456.27862548828125,
        481.1797790527344,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.2344612514425535e-06,
        1.0,
        0.0
      ],
      "plane_d": -481.1792297363281,
      "bbox_min": [
        455.27862548828125,
        481.1797790527344,
        78.0
      ],
      "bbox_max": [
        456.9799499511719,
        481.1797790527344,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        455.27862548828125,
        481.1797790527344,
        78.0
      ],
      "bbox_max": [
        500.0,
        511.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.2344612514425535e-06,
        1.0,
        0.0
      ],
      "plane_d": -481.1792297363281,
      "bbox_min": [
        455.27862548828125,
        481.1797790527344,
        78.0
      ],
      "bbox_max": [
        480.0,
        481.1798095703125,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 78.0,
      "bbox_min": [
        480.0,
        510.0,
        78.0
      ],
      "bbox_max": [
        500.0,
        540.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        -0.0
      ],
      "plane_d": -500.0,
      "bbox_min": [
        500.0,
        510.0,
        78.0
      ],
      "bbox_max": [
        500.0,
        540.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -858.6500854492188,
      "bbox_min": [
        360.0,
        560.0,
        60.0
      ],
      "bbox_max": [
        620.0,
        930.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -911.966796875,
      "bbox_min": [
        544.5025024414062,
        560.0,
        65.0
      ],
      "bbox_max": [
        570.0,
        755.2131958007812,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -570.0,
      "bbox_min": [
        570.0,
        560.0,
        78.0
      ],
      "bbox_max": [
        570.0,
        580.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24342486262321472,
        -0.24342486262321472,
        -0.9388762712478638
      ],
      "plane_d": 123.02920532226562,
      "bbox_min": [
        544.5025024414062,
        743.2847290039062,
        79.0
      ],
      "bbox_max": [
        556.4309692382812,
        755.2131958007812,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 750.0,
      "bbox_min": [
        360.0,
        346.7968444824219,
        80.0
      ],
      "bbox_max": [
        620.0,
        920.0,
        460.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -920.0,
      "bbox_min": [
        360.0,
        749.9961547851562,
        80.0
      ],
      "bbox_max": [
        559.7156982421875,
        920.0,
        460.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071070671081543,
        -0.7071065902709961,
        0.0
      ],
      "plane_d": 176.77639770507812,
      "bbox_min": [
        410.03387451171875,
        749.9961547851562,
        80.0
      ],
      "bbox_max": [
        559.7156982421875,
        869.8349609375,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6504544615745544,
        -0.7595453858375549,
        0.0
      ],
      "plane_d": 302.95068359375,
      "bbox_min": [
        410.03387451171875,
        749.9961547851562,
        240.0
      ],
      "bbox_max": [
        549.9862060546875,
        869.8349609375,
        460.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.4225330054759979,
        -0.49339815974235535,
        0.7602789998054504
      ],
      "plane_d": -152.93255615234375,
      "bbox_min": [
        450.3636474609375,
        749.9961547851562,
        240.0
      ],
      "bbox_max": [
        549.9862060546875,
        869.8349609375,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.48428842425346375,
        -0.4842880964279175,
        0.7286493182182312
      ],
      "plane_d": -177.67437744140625,
      "bbox_min": [
        499.9961853027344,
        749.9961547851562,
        240.0
      ],
      "bbox_max": [
        549.9862060546875,
        869.8349609375,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7121667861938477,
        0.7020103335380554,
        -0.0
      ],
      "plane_d": -953.280517578125,
      "bbox_min": [
        512.6419067382812,
        799.9862060546875,
        240.0
      ],
      "bbox_max": [
        549.9862060546875,
        869.8349609375,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.00027554581174626946,
        -0.0
      ],
      "plane_d": -550.2066650390625,
      "bbox_min": [
        549.9669799804688,
        799.9862060546875,
        240.0
      ],
      "bbox_max": [
        549.9862060546875,
        869.8349609375,
        260.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.00027554581174626946,
        -0.0
      ],
      "plane_d": -550.2066650390625,
      "bbox_min": [
        549.9862060546875,
        750.0,
        80.0
      ],
      "bbox_max": [
        559.7156982421875,
        799.9862060546875,
        260.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24342486262321472,
        -0.24342486262321472,
        -0.9388762712478638
      ],
      "plane_d": 123.02920532226562,
      "bbox_min": [
        553.146240234375,
        750.0,
        80.0
      ],
      "bbox_max": [
        559.7156982421875,
        753.2847290039062,
        81.70327758789062
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071067690849304,
        -0.7071067690849304,
        0.0
      ],
      "plane_d": 91.92388916015625,
      "bbox_min": [
        360.0,
        346.7968444824219,
        80.0
      ],
      "bbox_max": [
        620.0,
        750.0,
        460.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -510.0,
      "bbox_min": [
        360.0,
        510.0,
        80.0
      ],
      "bbox_max": [
        620.0,
        750.0,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        7.630560139659792e-05,
        -1.0,
        0.0
      ],
      "plane_d": 749.9580078125,
      "bbox_min": [
        410.0213928222656,
        680.0,
        80.0
      ],
      "bbox_max": [
        620.0,
        750.0,
        460.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.6504544615745544,
        -0.7595453858375549,
        0.0
      ],
      "plane_d": 302.95068359375,
      "bbox_min": [
        410.0213928222656,
        749.9893188476562,
        360.0
      ],
      "bbox_max": [
        410.03387451171875,
        750.0,
        460.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -550.0,
      "bbox_min": [
        546.4309692382812,
        680.0,
        80.0
      ],
      "bbox_max": [
        620.0,
        750.0,
        240.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.24342486262321472,
        -0.24342486262321472,
        -0.9388762712478638
      ],
      "plane_d": 123.02920532226562,
      "bbox_min": [
        546.4309692382812,
        739.7156982421875,
        80.0
      ],
      "bbox_max": [
        550.0,
        746.853759765625,
        81.85070037841797
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -911.966796875,
      "bbox_min": [
        546.4309692382812,
        739.7156982421875,
        80.0
      ],
      "bbox_max": [
        550.0,
        743.2847290039062,
        81.85070037841797
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -119.99999237060547,
      "bbox_min": [
        550.0,
        680.0,
        80.0
      ],
      "bbox_max": [
        620.0,
        750.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        -1.0
      ],
      "plane_d": 95.0,
      "bbox_min": [
        550.0,
        705.0,
        80.0
      ],
      "bbox_max": [
        595.0,
        750.0,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.24342486262321472,
        -0.24342486262321472,
        -0.9388762712478638
      ],
      "plane_d": 123.02920532226562,
      "bbox_min": [
        550.0,
        705.0,
        80.0
      ],
      "bbox_max": [
        580.8578491210938,
        750.0,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 111.92391967773438,
      "bbox_min": [
        560.8578491210938,
        709.4998168945312,
        90.0
      ],
      "bbox_max": [
        580.8578491210938,
        739.1421508789062,
        95.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -905.0967407226562,
      "bbox_min": [
        560.8578491210938,
        709.4998168945312,
        90.0
      ],
      "bbox_max": [
        570.5001831054688,
        719.1421508789062,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -911.966796875,
      "bbox_min": [
        550.0,
        705.0,
        80.0
      ],
      "bbox_max": [
        575.0,
        739.7156982421875,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        0.7071068286895752,
        0.0
      ],
      "plane_d": -905.0967407226562,
      "bbox_min": [
        560.8578491210938,
        705.0,
        80.0
      ],
      "bbox_max": [
        575.0,
        724.0,
        95.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.7071068286895752,
        -0.7071068286895752,
        0.0
      ],
      "plane_d": 111.92391967773438,
      "bbox_min": [
        560.8578491210938,
        719.1421508789062,
        80.0
      ],
      "bbox_max": [
        565.7156982421875,
        724.0,
        90.00000762939453
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -510.0,
      "bbox_min": [
        379.9999694824219,
        346.7968444824219,
        80.0
      ],
      "bbox_max": [
        620.0,
        680.0,
        240.0
      ],
      "face_count": 6
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -455.27862548828125,
      "bbox_min": [
        399.4853820800781,
        346.7968444824219,
        80.0
      ],
      "bbox_max": [
        620.0,
        510.0,
        215.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9510565996170044,
        -0.3090168535709381,
        0.0
      ],
      "plane_d": -256.32647705078125,
      "bbox_min": [
        399.4853820800781,
        346.7968444824219,
        80.0
      ],
      "bbox_max": [
        455.27862548828125,
        481.1797790527344,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9510565996170044,
        0.3090168535709381,
        -0.0
      ],
      "plane_d": -503.5399475097656,
      "bbox_min": [
        399.4853820800781,
        346.7968444824219,
        80.0
      ],
      "bbox_max": [
        455.27862548828125,
        481.1797790527344,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.5877854824066162,
        -0.8090169429779053,
        0.0
      ],
      "plane_d": 121.67642211914062,
      "bbox_min": [
        416.7721252441406,
        453.2031555175781,
        80.0
      ],
      "bbox_max": [
        455.27862548828125,
        481.1797790527344,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        -0.0
      ],
      "plane_d": -500.0,
      "bbox_min": [
        455.2785949707031,
        460.0,
        85.0
      ],
      "bbox_max": [
        620.0,
        510.0,
        215.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 215.0,
      "bbox_min": [
        455.2785949707031,
        460.0,
        85.0
      ],
      "bbox_max": [
        620.0,
        500.0,
        215.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 95.5,
      "bbox_min": [
        455.2785949707031,
        460.0,
        85.0
      ],
      "bbox_max": [
        620.0,
        500.0,
        166.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.2747211158275604,
        0.0,
        -0.9615239500999451
      ],
      "plane_d": -19.15392303466797,
      "bbox_min": [
        524.7213745117188,
        460.0,
        130.0
      ],
      "bbox_max": [
        620.0,
        500.0,
        166.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.5390536785125732,
        -0.8422713875770569
      ],
      "plane_d": -121.62398529052734,
      "bbox_min": [
        559.7213745117188,
        464.5886535644531,
        140.0
      ],
      "bbox_max": [
        620.0,
        500.0,
        166.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -605.0,
      "bbox_min": [
        559.7213745117188,
        464.58868408203125,
        140.0
      ],
      "bbox_max": [
        620.0,
        500.0,
        166.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -559.7213745117188,
      "bbox_min": [
        559.7213745117188,
        485.0,
        140.0
      ],
      "bbox_max": [
        559.7213745117188,
        500.0,
        145.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 166.0,
      "bbox_min": [
        605.0,
        485.0,
        156.0
      ],
      "bbox_max": [
        620.0,
        495.0,
        166.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -156.0,
      "bbox_min": [
        605.0,
        485.0,
        156.0
      ],
      "bbox_max": [
        620.0,
        495.0,
        166.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -485.0,
      "bbox_min": [
        615.0,
        485.0,
        156.0
      ],
      "bbox_max": [
        620.0,
        485.0,
        166.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -605.0,
      "bbox_min": [
        559.7213745117188,
        460.0,
        130.0
      ],
      "bbox_max": [
        620.0,
        500.0,
        157.2224578857422
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -559.7213745117188,
      "bbox_min": [
        559.7213745117188,
        495.0,
        130.0
      ],
      "bbox_max": [
        559.7213745117188,
        500.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.5390536785125732,
        -0.8422713875770569
      ],
      "plane_d": -121.62398529052734,
      "bbox_min": [
        605.0,
        460.0,
        150.0
      ],
      "bbox_max": [
        620.0,
        495.0,
        157.2224578857422
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -156.0,
      "bbox_min": [
        615.7213745117188,
        485.0,
        156.0
      ],
      "bbox_max": [
        620.0,
        495.0,
        157.2224578857422
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -485.0,
      "bbox_min": [
        615.7213745117188,
        485.0,
        156.0
      ],
      "bbox_max": [
        620.0,
        485.0,
        157.2224578857422
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.6246950626373291,
        0.0,
        -0.7808688282966614
      ],
      "plane_d": -216.08425903320312,
      "bbox_min": [
        455.2785949707031,
        481.1798095703125,
        85.0
      ],
      "bbox_max": [
        465.2785949707031,
        500.0,
        95.5
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -486.5,
      "bbox_min": [
        455.2785949707031,
        486.5,
        87.5
      ],
      "bbox_max": [
        458.4035949707031,
        486.5,
        90.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -460.0,
      "bbox_min": [
        455.2785949707031,
        481.1798095703125,
        85.0
      ],
      "bbox_max": [
        460.0,
        486.5,
        90.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -486.5,
      "bbox_min": [
        455.2785949707031,
        486.5,
        85.0
      ],
      "bbox_max": [
        460.0,
        486.5,
        90.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 215.0,
      "bbox_min": [
        455.27862548828125,
        500.0,
        130.0
      ],
      "bbox_max": [
        580.0,
        510.0,
        215.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -559.7213745117188,
      "bbox_min": [
        559.7213745117188,
        500.0,
        130.0
      ],
      "bbox_max": [
        580.0,
        510.0,
        145.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 140.0,
      "bbox_min": [
        565.0,
        508.0,
        133.5
      ],
      "bbox_max": [
        580.0,
        510.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": -565.0,
      "bbox_min": [
        565.0,
        508.0,
        133.5
      ],
      "bbox_max": [
        565.0,
        510.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": -550.0,
      "bbox_min": [
        550.0,
        580.0,
        80.0
      ],
      "bbox_max": [
        550.0,
        680.0,
        240.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        1.0,
        0.0
      ],
      "plane_d": -920.0,
      "bbox_min": [
        600.1320190429688,
        920.0,
        60.0
      ],
      "bbox_max": [
        620.0,
        930.0,
        240.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -858.6500854492188,
      "bbox_min": [
        600.1320190429688,
        920.0,
        60.0
      ],
      "bbox_max": [
        620.0,
        930.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -858.6500854492188,
      "bbox_min": [
        489.8018798828125,
        869.8349609375,
        60.0
      ],
      "bbox_max": [
        610.132080078125,
        930.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        0.9999999403953552
      ],
      "plane_d": -79.99999237060547,
      "bbox_min": [
        499.80194091796875,
        869.8349609375,
        80.0
      ],
      "bbox_max": [
        600.1320190429688,
        920.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        -1.0,
        0.0,
        0.0
      ],
      "plane_d": 310.0,
      "bbox_min": [
        -309.5032958984375,
        250.0,
        60.0
      ],
      "bbox_max": [
        360.0,
        1295.0,
        540.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        310.0,
        480.0,
        60.0
      ],
      "bbox_max": [
        360.0,
        980.0,
        340.0
      ],
      "face_count": 3
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        310.0,
        480.0,
        60.0
      ],
      "bbox_max": [
        360.0,
        980.0,
        120.0
      ],
      "face_count": 5
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": 840.7615966796875,
      "bbox_min": [
        310.0,
        970.0,
        60.0
      ],
      "bbox_max": [
        330.0,
        980.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": 840.7615966796875,
      "bbox_min": [
        330.0,
        510.0,
        60.0
      ],
      "bbox_max": [
        360.0,
        980.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        1.0,
        0.0
      ],
      "plane_d": -560.0,
      "bbox_min": [
        330.0,
        510.0,
        60.0
      ],
      "bbox_max": [
        360.0,
        930.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944272398948669,
        0.44721361994743347
      ],
      "plane_d": -491.93499755859375,
      "bbox_min": [
        350.0,
        510.0,
        60.0
      ],
      "bbox_max": [
        360.0,
        520.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.8944271802902222,
        0.4472135901451111
      ],
      "plane_d": -858.6500854492188,
      "bbox_min": [
        350.0,
        920.0,
        60.0
      ],
      "bbox_max": [
        360.0,
        930.0,
        80.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.6000000238418579,
        0.8000000715255737
      ],
      "plane_d": 492.0,
      "bbox_min": [
        310.0,
        960.0,
        100.0
      ],
      "bbox_max": [
        360.0,
        980.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        0.0,
        -1.0
      ],
      "plane_d": 100.0,
      "bbox_min": [
        310.0,
        960.0,
        100.0
      ],
      "bbox_max": [
        360.0,
        980.0,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 960.0,
      "bbox_min": [
        310.0,
        960.0,
        100.0
      ],
      "bbox_max": [
        360.0,
        960.0,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807853102684021,
        -0.1950904279947281,
        0.0
      ],
      "plane_d": -59.91375732421875,
      "bbox_min": [
        236.40264892578125,
        881.3681640625,
        60.0
      ],
      "bbox_max": [
        310.0,
        1000.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -0.6000000238418579,
        0.8000000715255737
      ],
      "plane_d": 492.0,
      "bbox_min": [
        260.0,
        960.0,
        100.0
      ],
      "bbox_max": [
        310.0,
        980.0,
        120.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 960.0,
      "bbox_min": [
        260.0,
        960.0,
        100.0
      ],
      "bbox_max": [
        310.0,
        960.0,
        105.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        0.0,
        0.0
      ],
      "plane_d": 100.0,
      "bbox_min": [
        -309.5032958984375,
        830.0,
        120.0
      ],
      "bbox_max": [
        310.0,
        1115.0986328125,
        540.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        1.0,
        -0.0,
        0.0
      ],
      "plane_d": 309.5,
      "bbox_min": [
        -309.5032958984375,
        971.800048828125,
        120.0
      ],
      "bbox_max": [
        -184.49986267089844,
        1115.0986328125,
        540.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.0,
        -0.0,
        -1.0
      ],
      "plane_d": 300.0,
      "bbox_min": [
        -309.5,
        971.800048828125,
        300.0
      ],
      "bbox_max": [
        -184.49986267089844,
        1115.0986328125,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.8544728755950928,
        -0.5194960832595825,
        0.0
      ],
      "plane_d": 700.9478759765625,
      "bbox_min": [
        -229.5,
        971.800048828125,
        300.0
      ],
      "bbox_max": [
        -184.49986267089844,
        1045.8167724609375,
        350.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.0,
        -1.0,
        0.0
      ],
      "plane_d": 980.0,
      "bbox_min": [
        107.05952453613281,
        881.3681640625,
        120.0
      ],
      "bbox_max": [
        310.0,
        1000.0,
        340.0
      ],
      "face_count": 4
    },
    {
      "plane_normal": [
        0.9807853698730469,
        -0.195090189576149,
        0.0
      ],
      "plane_d": 77.39595031738281,
      "bbox_min": [
        116.02175903320312,
        980.0,
        120.0
      ],
      "bbox_max": [
        260.0,
        1000.0,
        175.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        0.9807853102684021,
        -0.1950904279947281,
        0.0
      ],
      "plane_d": -59.91375732421875,
      "bbox_min": [
        256.0217590332031,
        980.0,
        120.0
      ],
      "bbox_max": [
        260.0,
        1000.0,
        140.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807853102684021,
        -0.1950904279947281,
        0.0
      ],
      "plane_d": -59.91375732421875,
      "bbox_min": [
        107.05952453613281,
        881.3681640625,
        120.0
      ],
      "bbox_max": [
        256.0217590332031,
        980.0,
        175.0
      ],
      "face_count": 1
    },
    {
      "plane_normal": [
        0.9807853698730469,
        -0.195090189576149,
        0.0
      ],
      "plane_d": 77.39595031738281,
      "bbox_min": [
        107.05952453613281,
        934.9437866210938,
        130.0
      ],
      "bbox_max": [
        116.02175903320312,
        980.0,
        175.0
      ],
      "face_count": 2
    },
    {
      "plane_normal": [
        -0.0,
        0.0,
        1.0
      ],
      "plane_d": -80.0,
      "bbox_min": [
        -55.0,
        470.0,
        80.0
      ],
      "bbox_max": [
        310.0,
        520.0,
        80.0
      ],
      "face_count": 1
    }
  ],
  "placed_objects": [
    {
      "tag": "CSlidingDoor piece: drt2",
      "entity_class": "CSlidingDoor",
      "piece_name": "drt2",
      "offset": 19534,
      "centroid": [
        1125.0,
        749.5,
        185.0
      ],
      "bbox_min": [
        1120.0,
        749.0,
        180.0
      ],
      "bbox_max": [
        1130.0,
        750.0,
        190.0
      ],
      "dimensions_source": {
        "span_x": 10.0,
        "span_y": 1.0,
        "height_z": 10.0,
        "door_width": 10.0,
        "door_depth": 1.0,
        "leaf_depth": 0.96,
        "clearance_margin": 0.02,
        "slide_axis": "x",
        "slide_vector": [
          0.0,
          1.0,
          0.0
        ]
      },
      "vertices": [
        [
          1120.0,
          750.0,
          180.0
        ],
        [
          1120.0,
          750.0,
          190.0
        ],
        [
          1120.0,
          749.0,
          190.0
        ],
        [
          1120.0,
          749.0,
          180.0
        ],
        [
          1130.0,
          750.0,
          180.0
        ],
        [
          1130.0,
          749.0,
          180.0
        ],
        [
          1130.0,
          749.0,
          190.0
        ],
        [
          1130.0,
          750.0,
          190.0
        ]
      ],
      "plane_distance": -750.0,
      "authentic_texture": "spkelevdoor1"
    },
    {
      "tag": "CSlidingDoor piece: lockerdr",
      "entity_class": "CSlidingDoor",
      "piece_name": "lockerdr",
      "offset": 21936,
      "centroid": [
        1280.2,
        757.5,
        189.0
      ],
      "bbox_min": [
        1280.0,
        755.0,
        185.0
      ],
      "bbox_max": [
        1280.5,
        760.0,
        195.0
      ],
      "dimensions_source": {
        "span_x": 0.5,
        "span_y": 5.0,
        "height_z": 10.0,
        "door_width": 5.0,
        "door_depth": 0.5,
        "leaf_depth": 0.46,
        "clearance_margin": 0.02,
        "slide_axis": "z",
        "slide_vector": [
          -1.0,
          0.0,
          0.0
        ]
      },
      "vertices": [
        [
          1280.0,
          755.0,
          185.0
        ],
        [
          1280.0,
          760.0,
          185.0
        ],
        [
          1280.0,
          755.0,
          185.0
        ],
        [
          1280.5,
          755.0,
          185.0
        ],
        [
          1280.5,
          760.0,
          185.0
        ],
        [
          1280.0,
          760.0,
          185.0
        ],
        [
          1280.0,
          760.0,
          195.0
        ],
        [
          1280.5,
          760.0,
          195.0
        ],
        [
          1280.5,
          755.0,
          195.0
        ],
        [
          1280.0,
          755.0,
          195.0
        ]
      ],
      "plane_distance": 1280.0,
      "authentic_texture": "hotkitcab_h"
    }
  ],
  "tutorial_messages": []
}